function onYouTubeIframeAPIReady() {
    theme.SlideshowVideo.loadVideos()
}

function gm_authFailure() {
    $(".map-section").addClass("map-section--load-error"), $(".map-section__container").remove(), $(".map-section__link").remove(), $(".map-section__overlay").after('<div class="errors text-center">' + theme.strings.authError + "</div>")
}

function onYouTubeIframeAPIReady() {
    theme.YouTubeVideos.loadVideos()
}
window.theme = window.theme || {}, window.home_video_list = window.home_video_list || {}, window.theme = window.theme || {}, theme.Sections = function() {
        this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
    }, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
        _createInstance: function(t, e) {
            var i = $(t),
                o = i.attr("data-section-id"),
                a = i.attr("data-section-type");
            if (e = e || this.constructors[a], !_.isUndefined(e)) {
                var n = _.assignIn(new e(t), {
                    id: o,
                    type: a,
                    container: t
                });
                this.instances.push(n)
            }
        },
        _onSectionLoad: function(t) {
            var e = $("[data-section-id]", t.target)[0];
            e && this._createInstance(e)
        },
        _onSectionUnload: function(t) {
            this.instances = _.filter(this.instances, (function(e) {
                var i = e.id === t.detail.sectionId;
                return i && _.isFunction(e.onUnload) && e.onUnload(t), !i
            }))
        },
        _onSelect: function(t) {
            var e = _.find(this.instances, (function(e) {
                return e.id === t.detail.sectionId
            }));
            !_.isUndefined(e) && _.isFunction(e.onSelect) && e.onSelect(t)
        },
        _onDeselect: function(t) {
            var e = _.find(this.instances, (function(e) {
                return e.id === t.detail.sectionId
            }));
            !_.isUndefined(e) && _.isFunction(e.onDeselect) && e.onDeselect(t)
        },
        _onBlockSelect: function(t) {
            var e = _.find(this.instances, (function(e) {
                return e.id === t.detail.sectionId
            }));
            !_.isUndefined(e) && _.isFunction(e.onBlockSelect) && e.onBlockSelect(t)
        },
        _onBlockDeselect: function(t) {
            var e = _.find(this.instances, (function(e) {
                return e.id === t.detail.sectionId
            }));
            !_.isUndefined(e) && _.isFunction(e.onBlockDeselect) && e.onBlockDeselect(t)
        },
        register: function(t, e) {
            this.constructors[t] = e, $("[data-section-type=" + t + "]").each(function(t, i) {
                this._createInstance(i, e)
            }.bind(this))
        }
    }), window.slate = window.slate || {}, slate.rte = {
        wrapTable: function() {
            $(".rte table").wrap('<div class="rte__table-wrapper"></div>')
        },
        iframeReset: function() {
            var t = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
                e = t.add(".rte iframe#admin_bar_iframe");
            t.each((function() {
                $(this).wrap('<div class="video-wrapper"></div>')
            })), e.each((function() {
                this.src = this.src
            }))
        }
    }, window.slate = window.slate || {}, slate.a11y = {
        pageLinkFocus: function(t) {
            var e = "js-focus-hidden";
            t.first().attr("tabIndex", "-1").focus().addClass(e).one("blur", (function() {
                t.first().removeClass(e).removeAttr("tabindex")
            }))
        },
        focusHash: function() {
            var t = window.location.hash;
            t && document.getElementById(t.slice(1)) && this.pageLinkFocus($(t))
        },
        bindInPageLinks: function() {
            $("a[href*=#]").on("click", function(t) {
                this.pageLinkFocus($(t.currentTarget.hash))
            }.bind(this))
        },
        trapFocus: function(t) {
            var e = t.namespace ? "focusin." + t.namespace : "focusin";
            t.$elementToFocus || (t.$elementToFocus = t.$container), t.$container.attr("tabindex", "-1"), t.$elementToFocus.focus(), $(document).off("focusin"), $(document).on(e, (function(e) {
                t.$container[0] === e.target || t.$container.has(e.target).length || t.$container.focus()
            }))
        },
        removeTrapFocus: function(t) {
            var e = t.namespace ? "focusin." + t.namespace : "focusin";
            t.$container && t.$container.length && t.$container.removeAttr("tabindex"), $(document).off(e)
        }
    }, theme.Images = function() {
        return {
            preload: function(t, e) {
                "string" == typeof t && (t = [t]);
                for (var i, o = 0; o < t.length; o++) i = t[o], this.loadImage(this.getSizedImageUrl(i, e))
            },
            loadImage: function(t) {
                (new Image).src = t
            },
            switchImage: function(t, e, i) {
                var o = this.imageSize(e.src),
                    a = this.getSizedImageUrl(t.src, o);
                i ? i(a, t, e) : e.src = a
            },
            imageSize: function(t) {
                var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                return null === e ? null : e[1]
            },
            getSizedImageUrl: function(t, e) {
                if (null == e) return t;
                if ("master" === e) return this.removeProtocol(t);
                var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null != i) {
                    var o = t.split(i[0]),
                        a = i[0];
                    return this.removeProtocol(o[0] + "_" + e + a)
                }
                return null
            },
            removeProtocol: function(t) {
                return t.replace(/http(s)?:/, "")
            }
        }
    }(), theme.Currency = function() {
        return {
            formatMoney: function(t, e) {
                function i(t, e, i, o) {
                    if (e = e || 2, i = i || ",", o = o || ".", isNaN(t) || null == t) return 0;
                    var a = (t = (t / 100).toFixed(e)).split("."),
                        n, s;
                    return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? o + a[1] : "")
                }
                "string" == typeof t && (t = t.replace(".", ""));
                var o = "",
                    a = /\{\{\s*(\w+)\s*\}\}/,
                    n = e || "${{amount}}";
                switch (n.match(a)[1]) {
                    case "amount":
                        o = i(t, 2);
                        break;
                    case "amount_no_decimals":
                        o = i(t, 0);
                        break;
                    case "amount_with_comma_separator":
                        o = i(t, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        o = i(t, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        o = i(t, 0, " ")
                }
                return n.replace(a, o)
            }
        }
    }(), slate.Variants = function() {
        function t(t) {
            this.$container = t.$container, this.product = t.product, this.singleOptionSelector = t.singleOptionSelector, this.originalSelectorId = t.originalSelectorId, this.enableHistoryState = t.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _getCurrentOptions: function() {
                var t = _.map($(this.singleOptionSelector, this.$container), (function(t) {
                    var e = $(t),
                        i = e.attr("type"),
                        o = {};
                    return "radio" === i || "checkbox" === i ? !!e[0].checked && (o.value = e.val(), o.index = e.data("index"), o) : (o.value = e.val(), o.index = e.data("index"), o)
                }));
                return t = _.compact(t)
            },
            _getVariantFromOptions: function() {
                var t = this._getCurrentOptions(),
                    e = this.product.variants,
                    i;
                return _.find(e, (function(e) {
                    return t.every((function(t) {
                        return _.isEqual(e[t.index], t.value)
                    }))
                }))
            },
            _onSelectChange: function() {
                var t = this._getVariantFromOptions();
                this.$container.trigger({
                    type: "variantChange",
                    variant: t
                }), t && (this._updateMasterSelect(t), this._updateImages(t), this._updatePrice(t), this._updateSKU(t), this.currentVariant = t, this.enableHistoryState && this._updateHistoryState(t))
            },
            _updateImages: function(t) {
                var e = t.featured_image || {},
                    i = this.currentVariant.featured_image || {};
                t.featured_image && e.src !== i.src && this.$container.trigger({
                    type: "variantImageChange",
                    variant: t
                })
            },
            _updatePrice: function(t) {
                t.price === this.currentVariant.price && t.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
                    type: "variantPriceChange",
                    variant: t
                })
            },
            _updateSKU: function(t) {
                t.sku === this.currentVariant.sku || this.$container.trigger({
                    type: "variantSKUChange",
                    variant: t
                })
            },
            _updateHistoryState: function(t) {
                if (history.replaceState && t) {
                    var e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id;
                    window.history.replaceState({
                        path: e
                    }, "", e)
                }
            },
            _updateMasterSelect: function(t) {
                $(this.originalSelectorId, this.$container).val(t.id)
            }
        }), t
    }(), theme.Drawers = function() {
        function t(t, e, i) {
            return this.nodes = {
                $parent: $("html").add("body"),
                $page: $("#PageContainer")
            }, this.config = $.extend({
                close: ".js-drawer-close",
                open: ".js-drawer-open-" + e,
                openClass: "js-drawer-open",
                dirOpenClass: "js-drawer-open-" + e
            }, i), this.position = e, this.$drawer = $("#" + t), !!this.$drawer.length && (this.drawerIsOpen = !1, void this.init())
        }
        return t.prototype.init = function() {
            $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.on("click", this.config.close, $.proxy(this.close, this))
        }, t.prototype.open = function(t) {
            var e = !1;
            return t ? t.preventDefault() : e = !0, t && t.stopPropagation && (t.stopPropagation(), this.$activeSource = $(t.currentTarget)), this.drawerIsOpen && !e ? this.close() : (this.$drawer.prepareTransition(), this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, slate.a11y.trapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && !e && this.config.onDrawerOpen(), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents(), this)
        }, t.prototype.close = function() {
            this.drawerIsOpen && ($(document.activeElement).trigger("blur"), this.$drawer.prepareTransition(), this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.drawerIsOpen = !1, slate.a11y.removeTrapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.unbindEvents())
        }, t.prototype.bindEvents = function() {
            this.nodes.$parent.on("keyup.drawer", $.proxy((function(t) {
                return 27 !== t.keyCode || (this.close(), !1)
            }), this)), this.nodes.$page.on("touchmove.drawer", (function() {
                return !1
            })), this.nodes.$page.on("click.drawer", $.proxy((function() {
                return this.close(), !1
            }), this))
        }, t.prototype.unbindEvents = function() {
            this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer")
        }, t
    }(), window.theme = window.theme || {}, theme.Header = function() {
        function t() {}

        function e() {
            $(".sub-active").closest(".parent-menu-item").addClass("current-menu-ancestor")
        }

        function i() {
            $(document.body).hasClass("sticky-header") && ($(window).on("scroll", (function() {
                var t = 5;
                $(document.body).hasClass("header-slider-top") && (t = $("#header-slider").height() + $("#un-header-minimized").height()), $(window).scrollTop() > t ? ($(o.header).addClass("minimized"), $(document.body).addClass("sticky-header-show")) : ($(o.header).removeClass("minimized"), $(document.body).removeClass("sticky-header-show"))
            })), $(window).on("resize", (function() {
                if (768 > $(window).width()) {
                    var t = $(o.header).height();
                    $("#un-header-minimized").height(t)
                } else $("#un-header-minimized").removeAttr("style")
            })).trigger("resize"))
        }
        var o = {
            header: ".site-header",
            navigation: "ul#menu-primary-header"
        };
        return {
            init: function() {
                $(o.header).length && (t(), e(), i())
            }
        }
    }(), window.theme = window.theme || {}, theme.Search = function() {
        function t() {}

        function e() {
            function t() {
                var t = n.val(),
                    r = "";
                if (0 < o.find(".product-cats").length && (r = o.find(".product-cats input:checked").val()), 2 > t.length) o.removeClass("searching found-products found-no-product").addClass("invalid-length");
                else {
                    o.removeClass("found-products found-no-product").addClass("searching");
                    var c = t + r;
                    if (c in i) {
                        var l = i[c];
                        o.removeClass("searching"), o.addClass("found-products"), s.find(".rt-unero").html(l.products), $(document.body).trigger("unero_ajax_search_request_success", [s]), s.find(".rt-unero, .buttons").slideDown((function() {
                            o.removeClass("invalid-length")
                        })), o.addClass("searched actived")
                    } else {
                        var d = "/search?view=ajax&" + a.serialize();
                        e = $.get(d, (function(t) {
                            var e = $(t).html();
                            o.removeClass("searching"), o.addClass("found-products"), s.find(".rt-unero").html(e), s.find(".rt-unero, .buttons").slideDown((function() {
                                o.removeClass("invalid-length")
                            })), $(document.body).trigger("unero_ajax_search_request_success", [s]), i[c] = {
                                found: !0,
                                products: e
                            }, o.addClass("searched actived")
                        }))
                    }
                    $(document.body).on("unero_ajax_search_request_success", (function(t, e) {
                        e.find("img.lazy").lazyload({
                            threshold: 1e3
                        })
                    }))
                }
            }
            var e = null,
                i = {},
                o = $("#search-modal"),
                a = o.find("form"),
                n = a.find("input.search-field"),
                s = o.find(".search-results");
            o.on("keyup", ".search-field", (function(i) {
                    var o = !1;
                    "undefined" == typeof i.which ? o = !0 : "number" == typeof i.which && 0 < i.which && (o = !i.ctrlKey && !i.metaKey && !i.altKey), o && (e && e.abort(), t())
                })).on("change", ".product-cats input", (function() {
                    e && e.abort(), t()
                })).on("focusout", ".search-field", (function() {
                    2 > n.val().length && s.find(".rt-unero, .buttons").slideUp((function() {
                        o.removeClass("searching searched actived found-products found-no-product invalid-length")
                    }))
                })),
                function() {
                    var t = $(".header-layout-4").find("#search-modal"),
                        e = t.find("input.search-field");
                    0 >= t.length || ($(window).on("scroll", (function() {
                        10 < $(window).scrollTop() && t.removeClass("show found-products searched")
                    })), $(document).on("click", (function(e) {
                        var i = e.target;
                        $(i).closest(".extra-menu-item").hasClass("menu-item-search") || t.removeClass("searching searched found-products found-no-product invalid-length")
                    })), t.on("click", ".t-icon", (function(i) {
                        t.hasClass("actived") && (i.preventDefault(), e.val(""), t.removeClass("searching searched actived found-products found-no-product invalid-length"))
                    })))
                }()
        }
        var i = {
            search: "#search-modal"
        };
        return {
            init: function() {
                $(i.search).length && (t(), e())
            }
        }
    }(), window.theme = window.theme || {}, theme.CurrencyPicker = function() {
        function t() {
            var t = $(e.currency).first().closest(".currency-wrapper");
            i.currency_format = t.find(".currency_format").val(), i.shop_currency = t.find(".shop_currency").val(), i.default_currency = t.find(".default_currency").val(), i.money_with_currency_format = t.find(".money_with_currency_format").val(), i.money_format = t.find(".money_format").val(), Currency.format = i.currency_format;
            var o = i.shop_currency;
            Currency.moneyFormats[o].money_with_currency_format = i.money_with_currency_format, Currency.moneyFormats[o].money_format = i.money_format;
            var a = i.default_currency;
            try {
                var n = Currency.cookie.read();
                $("span.money span.money").each((function() {
                    $(this).parents("span.money").removeClass("money")
                })), $("span.money").each((function() {
                    $(this).attr("data-currency-" + i.shop_currency, $(this).html())
                })), null == n ? (o === a ? Currency.currentCurrency = a : Currency.convertAll(o, a), Currency.cookie.write(a)) : $(e.currency).length && 0 === $(e.currency + " .currency[data-code=" + n + "]").size() ? (Currency.currentCurrency = o, Currency.cookie.write(o)) : n === o ? Currency.currentCurrency = o : Currency.convertAll(o, n), $(e.currency).on("click", ".currency:not(.active)", (function() {
                    var t = $(this).attr("data-code");
                    Currency.convertAll(Currency.currentCurrency, t), $(e.currencyPicker).removeClass("active"), $(e.currencyPicker).closest("li").removeClass("actived"), $(this).addClass("active"), $(this).closest("li").addClass("actived"), $(".menu-item-currency.currency-wrapper").find("span.current").html($(this).html() + '<span class="toggle-children i-icon arrow_carrot-down"></span>')
                }));
                var s = window.selectCallback;
                $("body").on("ajaxCart.afterCartLoad", (function() {
                    Currency.convertAll(o, $(e.currencyActive).attr("data-code")), $(e.currencyPicker).removeClass("active"), $(e.currencyPicker).closest("li").removeClass("actived"), $(e.currency + " .currency[data-code=" + Currency.currentCurrency + "]").addClass("active"), $(e.currency + " .currency[data-code=" + Currency.currentCurrency + "]").closest("li").addClass("actived"), $(".menu-item-currency.currency-wrapper").find("span.current").html(Currency.currentCurrency + '<span class="toggle-children i-icon arrow_carrot-down"></span>')
                })), $(e.currencyPicker).removeClass("active"), $(e.currencyPicker).closest("li").removeClass("actived"), $(e.currency + " .currency[data-code=" + Currency.currentCurrency + "]").addClass("active"), $(e.currency + " .currency[data-code=" + Currency.currentCurrency + "]").closest("li").addClass("actived"), $(".menu-item-currency.currency-wrapper").find("span.current").html(Currency.currentCurrency + '<span class="toggle-children i-icon arrow_carrot-down"></span>')
            } catch (t) {
                console.log(t.message)
            }
        }
        var e = {
                currency: ".currency_switcher",
                currencyPicker: ".currency_switcher .currency",
                currencyActive: ".currency_switcher .currency.active"
            },
            i = {
                currency_format: "",
                shop_currency: "",
                default_currency: "",
                money_with_currency_format: "",
                money_format: ""
            };
        return {
            init: function() {
                $(e.currency).length && t()
            },
            convert: function(t) {
                if ($(e.currency).length) try {
                    $(t).each((function() {
                        $(this).attr("data-currency-" + i.shop_currency, $(this).html())
                    })), Currency.convertAll(i.shop_currency, Currency.cookie.read(), t, i.currency_format)
                } catch (t) {
                    console.log(t.message)
                }
            }
        }
    }(),
    function() {
        function t(t) {
            var e = document.createElement("a");
            return e.ref = t, e.hostname
        }
        var e = $([".return-link"][0]);
        document.referrer && e.length && window.history.length && e.one("click", (function(e) {
            e.preventDefault();
            var i = t(document.referrer),
                o;
            return t(window.location.href) === i && history.back(), !1
        }))
    }(), theme.Slideshow = function() {
        function t(t) {
            this.$slideshow = $(t), this.$wrapper = this.$slideshow.closest("." + s.wrapper), this.$pause = this.$wrapper.find("." + s.pauseButton), this.settings = {
                accessibility: !0,
                arrows: !0,
                dots: !1,
                fade: !0,
                draggable: !0,
                touchThreshold: 20,
                autoplay: this.$slideshow.data("autoplay"),
                autoplaySpeed: this.$slideshow.data("speed")
            }, this.$slideshow.on("beforeChange", o.bind(this)), this.$slideshow.on("init", i.bind(this)), this.$slideshow.slick(this.settings), this.$pause.on("click", this.togglePause.bind(this)), e()
        }

        function e() {
            function t() {
                var t = $(window).height();
                $("." + s.slideshowWindow).css("height", t)
            }
            $("." + s.slideshowWindow).length && (t(), $(window).on("resize", (function() {
                t()
            })))
        }

        function i(t, e) {
            var i = e.$slider,
                o = e.$list,
                a = this.$wrapper,
                n = this.settings.autoplay;
            o.removeAttr("aria-live"), a.on("focusin", (function(t) {
                a.has(t.target).length && (o.attr("aria-live", "polite"), n && i.slick("slickPause"))
            })), a.on("focusout", (function(t) {
                if (a.has(t.target).length && (o.removeAttr("aria-live"), n)) {
                    if ($(t.target).hasClass(s.closeVideoBtn)) return;
                    i.slick("slickPlay")
                }
            })), e.$dots && e.$dots.on("keydown", (function(t) {
                37 === t.which && i.slick("slickPrev"), 39 === t.which && i.slick("slickNext"), (37 === t.which || 39 === t.which) && e.$dots.find(".slick-active button").focus()
            }))
        }

        function o(t, e, i, o) {
            var n = e.$slider,
                r = n.find("." + s.currentSlide),
                c = n.find('.slideshow__slide[data-slick-index="' + o + '"]');
            if (a(r)) {
                var l = r.find("." + s.video),
                    d = l.attr("id");
                theme.SlideshowVideo.pauseVideo(d), l.attr("tabindex", "-1")
            }
            if (a(c)) {
                var u = c.find("." + s.video),
                    p = u.attr("id"),
                    h;
                u.hasClass(s.videoBackground) ? theme.SlideshowVideo.playVideo(p) : u.attr("tabindex", "0")
            }
        }

        function a(t) {
            return t.find("." + s.video).length
        }

        function n(t) {
            return "#Slideshow-" + t.data("id")
        }
        this.$slideshow = null;
        var s = {
            wrapper: "slideshow-wrapper",
            slideshow: "slideshow",
            slideshowWindow: "slideshow--window",
            imageBackground: "slideshow__image",
            currentSlide: "slick-current",
            video: "slideshow__video",
            videoBackground: "slideshow__video--background",
            closeVideoBtn: "slideshow__video-control--close",
            pauseButton: "slideshow__pause",
            isPaused: "is-paused"
        };
        return t.prototype.togglePause = function() {
            var t = n(this.$pause);
            this.$pause.hasClass(s.isPaused) ? (this.$pause.removeClass(s.isPaused), $(t).slick("slickPlay")) : (this.$pause.addClass(s.isPaused), $(t).slick("slickPause"))
        }, t
    }();
theme.SlideshowVideo = function() {
        function t(t, e) {
            var o = b[t],
                a = C[t],
                n = b[t].$parentSlide;
            if (_) s(o);
            else if (e || v && g) return n.removeClass(S.loading), s(o), void a.playVideo();
            v || i(a, n)
        }

        function e(t) {
            var e = t ? S.supportsAutoplay : S.supportsNoAutoplay;
            $(document.documentElement).addClass(e), t || (_ = !0), v = !0
        }

        function i(t, i) {
            t.playVideo(), o(t).then((function() {
                e(!0)
            })).fail((function() {
                e(!1), t.stopVideo()
            })).always((function() {
                v = !0, i.removeClass(S.loading)
            }))
        }

        function o(t) {
            var e, i, o = $.Deferred();
            return e = setInterval((function() {
                0 >= t.getCurrentTime() || (g = !0, clearInterval(e), clearTimeout(i), o.resolve())
            }), 500), i = setTimeout((function() {
                clearInterval(e), o.reject()
            }), 4e3), o
        }

        function a() {
            y || ((750 > $(window).width() || window.mobileCheck()) && (_ = !0), _ && e(!1), y = !0)
        }

        function n(t) {
            switch (t.type) {
                case "background":
                    C[t.id].seekTo(0);
                    break;
                case "background-chrome":
                    C[t.id].seekTo(0), c(t.id);
                    break;
                case "chrome":
                    c(t.id)
            }
        }

        function s(t) {
            var e = t.$parentSlideshowWrapper,
                i = t.$parentSlide;
            if (i.removeClass(S.loading), "background" !== t.status) {
                switch ($("#" + t.id).attr("tabindex", "0"), t.type) {
                    case "chrome":
                    case "background-chrome":
                        e.removeClass(S.paused).addClass(S.playing), i.removeClass(S.paused).addClass(S.playing)
                }
                i.find("." + S.closeVideoBtn).focus()
            }
        }

        function r(t) {
            var e = t.$parentSlideshowWrapper,
                i = t.$parentSlide;
            return "background-chrome" === t.type ? void c(t.id) : ("closed" !== t.status && "background" !== t.type && (e.addClass(S.paused), i.addClass(S.paused)), "chrome" === t.type && "closed" === t.status && (e.removeClass(S.paused), i.removeClass(S.paused)), e.removeClass(S.playing), void i.removeClass(S.playing))
        }

        function c(t) {
            var e = b[t],
                i = e.$parentSlideshowWrapper,
                o = e.$parentSlide,
                a = [S.pause, S.playing].join(" ");
            switch ($("#" + e.id).attr("tabindex", "-1"), e.status = "closed", e.type) {
                case "background-chrome":
                    C[t].mute(), m(t);
                    break;
                case "chrome":
                    C[t].stopVideo(), r(e)
            }
            i.removeClass(a), o.removeClass(a)
        }

        function l(t) {
            return b[t.target.h.id]
        }

        function d(e) {
            var i = b[e];
            switch (i.$parentSlide.addClass(S.loading), i.status = "open", i.type) {
                case "background-chrome":
                    h(e, i), C[e].unMute(), t(e, !0);
                    break;
                case "chrome":
                    t(e, !0)
            }
            $(document).on("keydown.videoPlayer", (function(t) {
                27 === t.keyCode && c(e)
            }))
        }

        function u() {
            $("." + S.videoBackground).each((function(t, e) {
                p($(e))
            }))
        }

        function p(t) {
            var e = t.closest("." + S.slide);
            if (!e.hasClass(S.slickClone)) {
                var i = e.width(),
                    o = t.width(),
                    a = t.height();
                i / k.ratio < a ? (o = Math.ceil(a * k.ratio), t.width(o).height(a).css({
                    left: (i - o) / 2,
                    top: 0
                })) : (a = Math.ceil(i / k.ratio), t.width(i).height(a).css({
                    left: 0,
                    top: (a - a) / 2
                })), t.prepareTransition().addClass(S.loaded)
            }
        }

        function h(t) {
            $("#" + t).removeAttr("style").removeClass(S.videoBackground).addClass(S.videoChrome), b[t].$parentSlideshowWrapper.removeClass(S.slideBackgroundVideo).addClass(S.playing), b[t].$parentSlide.removeClass(S.slideBackgroundVideo).addClass(S.playing), b[t].status = "open"
        }

        function m(t) {
            var e = $("#" + t).addClass(S.videoBackground).removeClass(S.videoChrome);
            b[t].$parentSlide.addClass(S.slideBackgroundVideo), b[t].status = "background", p(e)
        }

        function f() {
            $(document).on("click.videoPlayer", "." + S.playVideoBtn, (function(t) {
                var e;
                d($(t.currentTarget).data("controls"))
            })), $(document).on("click.videoPlayer", "." + S.closeVideoBtn, (function(t) {
                var e;
                c($(t.currentTarget).data("controls"))
            })), $(window).on("resize.videoPlayer", $.debounce(250, (function() {
                w && u()
            })))
        }
        var v = !1,
            g = !1,
            y = !1,
            _ = !1,
            w = !1,
            b = {},
            C = [],
            k = {
                ratio: 16 / 9,
                playerVars: {
                    iv_load_policy: 3,
                    modestbranding: 1,
                    autoplay: 0,
                    controls: 0,
                    showinfo: 0,
                    wmode: "opaque",
                    branding: 0,
                    autohide: 0,
                    rel: 0
                },
                events: {
                    onReady: function(e) {
                        e.target.setPlaybackQuality("hd1080");
                        var i = l(e);
                        switch (a(), $("#" + i.id).attr("tabindex", "-1"), u(), i.type) {
                            case "background-chrome":
                            case "background":
                                e.target.mute(), i.$parentSlide.hasClass(S.currentSlide) && t(i.id)
                        }
                        i.$parentSlide.addClass(S.loaded)
                    },
                    onStateChange: function(t) {
                        var e = l(t);
                        switch (t.data) {
                            case 0:
                                n(e);
                                break;
                            case 1:
                                s(e);
                                break;
                            case 2:
                                r(e)
                        }
                    }
                }
            },
            S = {
                playing: "video-is-playing",
                paused: "video-is-paused",
                loading: "video-is-loading",
                loaded: "video-is-loaded",
                slideshowWrapper: "slideshow-wrapper",
                slide: "slideshow__slide",
                slideBackgroundVideo: "slideshow__slide--background-video",
                slideDots: "slick-dots",
                videoChrome: "slideshow__video--chrome",
                videoBackground: "slideshow__video--background",
                playVideoBtn: "slideshow__video-control--play",
                closeVideoBtn: "slideshow__video-control--close",
                currentSlide: "slick-current",
                slickClone: "slick-cloned",
                supportsAutoplay: "autoplay",
                supportsNoAutoplay: "no-autoplay"
            };
        return {
            init: function(t) {
                if (t.length && (b[t.attr("id")] = {
                        id: t.attr("id"),
                        videoId: t.data("id"),
                        type: t.data("type"),
                        status: "chrome" === t.data("type") ? "closed" : "background",
                        videoSelector: t.attr("id"),
                        $parentSlide: t.closest("." + S.slide),
                        $parentSlideshowWrapper: t.closest("." + S.slideshowWrapper),
                        controls: "background" === t.data("type") ? 0 : 1,
                        slideshow: t.data("slideshow")
                    }, !w)) {
                    var e = document.createElement("script");
                    e.src = "https://www.youtube.com/iframe_api";
                    var i = document.getElementsByTagName("script")[0];
                    i.parentNode.insertBefore(e, i)
                }
            },
            loadVideos: function() {
                for (var t in b)
                    if (b.hasOwnProperty(t)) {
                        var e = $.extend({}, k, b[t]);
                        e.playerVars.controls = e.controls, C[t] = new YT.Player(t, e)
                    } f(), w = !0
            },
            loadVideo: function(t) {
                if (w) {
                    var e = $.extend({}, k, b[t]);
                    e.playerVars.controls = e.controls, C[t] = new YT.Player(t, e), f()
                }
            },
            playVideo: function(e) {
                (y || _) && (!e || "function" != typeof C[e].playVideo || t(e))
            },
            pauseVideo: function(t) {
                C[t] && "function" == typeof C[t].pauseVideo && C[t].pauseVideo()
            },
            removeEvents: function() {
                $(document).off(".videoPlayer"), $(window).off(".videoPlayer")
            }
        }
    }(),
    function() {
        var t = $("#BlogTagFilter");
        t.length && t.on("change", (function() {
            location.href = $(this).val()
        }))
    }(), window.theme = theme || {}, theme.customerTemplates = function() {
        function t() {
            $("#RecoverPassword").on("click", (function(t) {
                t.preventDefault(), $("#forgot-pass-tab").trigger("click")
            })), $("#HideRecoverPasswordLink").on("click", (function(t) {
                t.preventDefault(), $("#login-tab").trigger("click")
            })), $("#RecoverPasswordMobile").on("click", (function(t) {
                t.preventDefault(), $("#forgot-pass-tab-mobile").trigger("click")
            })), $("#HideRecoverPasswordLinkMobile").on("click", (function(t) {
                t.preventDefault(), $("#login-tab-mobile").trigger("click")
            }))
        }

        function e() {
            var t;
            $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide")
        }

        function i() {
            var t = $("#AddressNewForm");
            t.length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
                hideElement: "AddressProvinceContainerNew"
            }), $(".address-country-option").each((function() {
                var t = $(this).data("form-id");
                new Shopify.CountryProvinceSelector("AddressCountry_" + t, "AddressProvince_" + t, {
                    hideElement: "AddressProvinceContainer_" + t
                })
            })), $(".address-new-toggle").on("click", (function() {
                t.toggleClass("hide")
            })), $(".address-edit-toggle").on("click", (function() {
                var t = $(this).data("form-id");
                $("#EditAddress_" + t).toggleClass("hide")
            })), $(".address-delete").on("click", (function() {
                var t = $(this),
                    e = t.data("form-id"),
                    i = t.data("confirm-message");
                confirm(i || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + e, {
                    parameters: {
                        _method: "delete"
                    }
                })
            })))
        }
        return {
            init: function() {
                t(), e(), i()
            }
        }
    }(), window.theme = window.theme || {}, theme.HeaderSection = function() {
        return function() {
            theme.Header.init(), theme.Search.init(), theme.CurrencyPicker.init()
        }
    }(), theme.Maps = function() {
        function t(t) {
            this.$container = $(t), "loaded" === a ? this.createMap() : (n.push(this), "loading" != a && (a = "loading", "undefined" == typeof window.google && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + s).then((function() {
                a = "loaded", e()
            }))))
        }

        function e() {
            $.each(n, (function(t, e) {
                e.createMap()
            }))
        }

        function i(t) {
            var e = $.Deferred(),
                i = new google.maps.Geocoder,
                o = t.data("address-setting");
            return i.geocode({
                address: o
            }, (function(t, i) {
                i !== google.maps.GeocoderStatus.OK && e.reject(i), e.resolve(t)
            })), e
        }
        var o = {
                zoom: 14
            },
            a = null,
            n = [],
            s = theme.mapKey ? theme.mapKey : "";
        return t.prototype = _.assignIn({}, t.prototype, {
            createMap: function() {
                var t = this.$container.find(".map-section__container");
                return i(t).then(function(e) {
                    var i = {
                            mapTypeId: "terrain",
                            zoom: o.zoom,
                            center: e[0].geometry.location,
                            disableDefaultUI: !0
                        },
                        a = this.map = new google.maps.Map(t[0], i),
                        n = this.center = a.getCenter(),
                        s = new google.maps.Marker({
                            map: a,
                            position: a.getCenter()
                        });
                    google.maps.event.addDomListener(window, "resize", $.debounce(250, (function() {
                        google.maps.event.trigger(a, "resize"), a.setCenter(n)
                    })))
                }.bind(this)).fail((function() {
                    var e;
                    e = "ZERO_RESULTS" === status ? theme.strings.addressNoResults : "OVER_QUERY_LIMIT" === status ? theme.strings.addressQueryLimit : theme.strings.addressError, t.parent().addClass("map-section--load-error").html('<div class="errors text-center">' + e + "</div>")
                }))
            },
            onUnload: function() {
                google.maps.event.clearListeners(this.map, "resize")
            }
        }), t
    }(), theme.Product = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.settings = {
                mediaQueryMediumUp: "screen and (min-width: 750px)",
                mediaQuerySmall: "screen and (max-width: 749px)",
                bpSmall: !1,
                enableHistoryState: e.data("enable-history-state") || !1,
                imageSize: null,
                namespace: ".slideshow-" + i,
                sectionId: i,
                sliderActive: !1,
                swatch_color: e.attr("data-product_swatch_color"),
                swatch_color_advanced: e.attr("data-product_swatch_color_advanced"),
                swatch_size: e.attr("data-product_swatch_size"),
                product_design: e.attr("data-product_design"),
                product_mobile_variant: e.attr("data-product_mobile_variant")
            }, this.selectors = {
                product: "#ProductSection-" + i,
                addToCart: "#AddToCart-" + i,
                addToCartText: "#AddToCartText-" + i,
                stockText: ".stock-" + i,
                comparePrice: "#ComparePrice-" + i,
                originalPrice: "#ProductPrice-" + i,
                SKU: ".variant-sku",
                originalPriceWrapper: ".product-price__price-" + i,
                originalSelectorId: "#ProductSelect-" + i,
                productFeaturedImage: ".FeaturedImage-" + i,
                productImageWrap: "#FeaturedImageZoom-" + i,
                productPrices: ".product-single__price-" + i,
                productThumbImages: "#product-thumbnails-" + i,
                productMainImages: "#product-images-" + i,
                productPreviewMainImages: ".product-preview-images-" + i,
                saleLabel: ".product-price__sale-label-" + i,
                singleOptionSelector: ".single-option-selector-" + i,
                singleOptionSelectorId: "#single-option-selector-" + i,
                singleOptionSwatches: "tawcvs-swatches-" + i,
                instagramProduct: "#product-instagram-" + i,
                instagramProductNameSpace: "product-instagram-" + i,
                variationsSelector: "#variations-" + i,
                variationSelector: ".variation-select-" + i,
                qtyVariant: ".qty-variant-" + i,
                threedId: ".threed-id-" + i,
                countDownId: ".countdown-" + i,
                couponCode: "#coupon-code-" + i,
                couponBtn: "#coupon-btn-" + i,
                sidebarSlide: ".sidebar-slick-vertical-" + i
            }, $("#ProductJson-" + i).html() && (this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML), this.productSwatchSingleObject = JSON.parse(document.getElementById("ProductSwatchJson-" + i).innerHTML), this._stringOverrides(), this._initCountDown(), this._initCoupon(), this._initPopup(), this._initVariants(), this._initSwatches(), this._initFeature(), this._initCompact(), this._initStickyImages(), this._initThumbnailsGallery(), this._initImages(), this._initSidebar(), this._initZoom(), this._initGallery(), this._initTab(), this._initQuantity(), this._initReviewTab(), this._relatedProducts(), this._recentlyViewed(), this._instagramProducts())
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _stringOverrides: function() {
                theme.productStrings = theme.productStrings || {}, $.extend(theme.strings, theme.productStrings)
            },
            _initBreakpoints: function() {
                this,
                enquire.register(this.settings.mediaQuerySmall, {
                    match: function() {},
                    unmatch: function() {}
                }),
                enquire.register(this.settings.mediaQueryMediumUp, {
                    match: function() {}
                })
            },
            _initPopup: function() {
                $(".sizechart-btn").magnificPopup({
                    type: "image",
                    midClick: !0
                }), $(".return-btn").click((function() {
                    return $.magnificPopup.open({
                        items: {
                            src: "#delivery-return",
                            type: "inline"
                        },
                        tLoading: "",
                        mainClass: "popup-wrapper mfp-with-zoom",
                        removalDelay: 200
                    }), !1
                }))
            },
            _initCoupon: function() {
                0 < $(this.selectors.couponBtn).length && $(this.selectors.couponBtn).unbind("click") && $(this.selectors.couponBtn).click((function() {
                    var t = $("<input>");
                    $("body").append(t), t.val($(this).data("coupon")).select(), document.execCommand("copy"), t.remove(), jQuery("#rtp-message").html($(this).data("copied")), jQuery("#rt-unero-popup-message").css("margin-left", "-" + parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 + "px").fadeIn(), window.setTimeout((function() {
                        jQuery("#rt-unero-popup-message").fadeOut()
                    }), 2e3)
                }))
            },
            _initCountDown: function() {
                if (!(0 >= $(this.selectors.countDownId).length) && $().countdown && 0 < $(this.selectors.countDownId).length && "" != $(this.selectors.countDownId).data("countdown")) {
                    var t = new Date,
                        e = $(this.selectors.countDownId).data("countdown").split("-"),
                        e;
                    t < (e = new Date(e[2], parseInt(e[0]) - 1, e[1])) && $(this.selectors.countDownId).countdown({
                        until: e,
                        layout: '<span class="countdown-day">{dn}d</span><span class="countdown-hour">{hn}h</span><span class="countdown-minute">{mn}m</span><span class="countdown-second">{sn}s</span>'
                    })
                }
            },
            _initFeature: function() {
                if (0 < $(this.selectors.product + " .product-video-button a").length && $(this.selectors.product + " .product-video-button a").magnificPopup({
                        type: "iframe",
                        mainClass: "mfp-fade",
                        removalDelay: 160,
                        preloader: !1,
                        disableOn: !1,
                        fixedContentPos: !1
                    }), 0 < $(this.selectors.product + " .product-360-button a").length) {
                    for (var t, e = [], i = JSON.parse(document.getElementById("threed-id-" + this.sectionId).innerHTML), o = 1; 72 >= o; o++) i[t = "f" + o] && e.push(i[t]);
                    if (0 < e.length) {
                        var a = e.length;
                        $(this.selectors.threedId).ThreeSixty({
                            totalFrames: a,
                            endFrame: a,
                            currentFrame: 1,
                            imgList: ".threed-view-images",
                            progress: ".spinner",
                            imgArray: e,
                            height: null,
                            width: null,
                            responsive: !0,
                            navigation: !0,
                            onReady: function() {
                                $(".product-360-button a").magnificPopup({
                                    type: "inline",
                                    mainClass: "mfp-fade",
                                    removalDelay: 160,
                                    disableOn: !1,
                                    preloader: !1,
                                    fixedContentPos: !1,
                                    callbacks: {
                                        open: function() {
                                            $(window).resize()
                                        }
                                    }
                                })
                            }
                        })
                    }
                }
            },
            _initCompact: function() {
                if (0 < $(".product-accordion").length) {
                    var t = $(".product-accordion"),
                        e = $(".accordion-item");
                    e.each((function() {
                        var t = $(this),
                            e = t.find(".title"),
                            i = e.innerHeight(),
                            o = t.find(".content").outerHeight(),
                            a = e.parent(".accordion-item");
                        e.data("height", i), t.data("height", i + o)
                    })), e.each((function() {
                        var t = $(this),
                            e = t.find(".title"),
                            i = e.innerHeight(),
                            o = t.find(".content").outerHeight(),
                            a = e.parent(".accordion-item");
                        e.data("height", i), t.data("height", i + o), a.hasClass("active") && a.height(a.data("height"))
                    })), t.on("click", ".accordion-item > .title", (function() {
                        var t = $(this),
                            i = t.parent(".accordion-item");
                        i.hasClass("active") || e.closest(".active").removeClass("active").height(t.data("height")), i.toggleClass("active"), i.hasClass("active") ? i.height(i.data("height")) : i.height(t.data("height"))
                    }))
                }
            },
            _initStickyImages: function() {
                function t() {
                    d = $(window).height(), l.each((function() {
                        o = $(this).offset().top, f > o - d + 20 && $(this).addClass("animate-images")
                    }))
                }

                function e() {
                    f = $(window).scrollTop(), _ = f + p + m, r = n.width(), g = n.offset().left + 15, v = c.offset().top, y = v + u, r > h && (g += a = (r - h) / 2), f + p >= v ? (n.addClass("block-sticked"), s.css({
                        top: p,
                        left: g,
                        width: r,
                        position: "fixed",
                        transform: "translateY(-20px)"
                    })) : (n.removeClass("block-sticked"), s.css({
                        top: "auto",
                        left: "auto",
                        width: "auto",
                        position: "relative",
                        transform: "translateY(0px)"
                    })), _ > y + 50 ? n.addClass("hide-temporary") : n.removeClass("hide-temporary")
                }

                function i() {
                    d = $(window).height(), m = n.outerHeight(), u = c.outerHeight(), m < d - p ? n.addClass("in-viewport").removeClass("not-in-viewport") : n.removeClass("in-viewport").addClass("not-in-viewport"), e(), t()
                }
                if ($("body").hasClass("unero-product-design-sticky")) {
                    var o, a, n = $(".product-summary"),
                        s = n.find(".entry-summary"),
                        r = n.width(),
                        c = $(".unero-images"),
                        l = c.find(".shopify-product-gallery__wrapper a"),
                        d = $(window).height(),
                        u = c.outerHeight(),
                        p = 130,
                        h = 600,
                        m = n.outerHeight(),
                        f = $(window).scrollTop(),
                        v = c.offset().top,
                        g = n.offset().left + 15,
                        y = v + u,
                        _ = f + p + m;
                    n.css({
                        height: m
                    }), $(window).resize((function() {
                        i()
                    })), $(window).scroll((function() {
                        e(), t()
                    })), c.imagesLoaded((function() {
                        i()
                    }))
                }
            },
            _initThumbnailsGallery: function() {
                var t = $(this.selectors.productMainImages);
                "gallery" == this.settings.product_design && $(".thumbnail-gallery-item").on("click", (function() {
                    var e = $(this);
                    e.hasClass("active") || ($(".thumbnail-gallery-item").removeClass("active"), e.addClass("active"), $(".thumbnail-gallery-item").each((function(i) {
                        $(this).attr("id") != e.attr("id") || t.slick("slickGoTo", i, !0)
                    })))
                }))
            },
            _instagramProducts: function() {
                if (0 < $(this.selectors.instagramProduct).length) {
                    var t = $(this.selectors.instagramProduct),
                        e = this.selectors.instagramProductNameSpace,
                        i = t.attr("data-id"),
                        o = t.attr("data-token"),
                        a = t.attr("data-limit"),
                        n = t.data("per_view"),
                        s = t.data("auto"),
                        r = !1,
                        c = t.data("speed"),
                        l;
                    new Instafeed({
                        get: "user",
                        target: e,
                        accessToken: o,
                        userId: parseInt(i),
                        limit: parseInt(a),
                        resolution: "standard_resolution",
                        resolution2: "standard_resolution",
                        template: '<li class="product"><a class="insta-item" target="_blank" href="{{link}}" style="background-image:url({{image}});"><i class="social_instagram"></i></a></li>',
                        after: function() {
                            0 < s ? (r = !0, s = !0) : s = !1, t.not(".slick-initialized").slick({
                                slidesToShow: n,
                                slidesToScroll: 1,
                                autoplaySpeed: c,
                                autoplay: s,
                                infinite: r,
                                dots: !1,
                                prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                                nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
                                responsive: [{
                                    breakpoint: 1200,
                                    settings: {
                                        slidesToShow: 4,
                                        slidesToScroll: 1
                                    }
                                }, {
                                    breakpoint: 767,
                                    settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 1
                                    }
                                }]
                            })
                        }
                    }).run()
                }
            },
            _relatedProducts: function() {
                var t = $(this.selectors.product + " .related.products ul.products");
                0 < t.length && t.not(".slick-initialized").slick({
                    slidesToShow: t.data("per_view"),
                    slidesToScroll: t.data("per_view"),
                    arrows: !1,
                    lazyLoad: "ondemand",
                    dots: !0,
                    responsive: [{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }]
                })
            },
            _recentlyViewed: function() {
                var t = $(this.selectors.product + " .viewed.products ul.products"),
                    e = Currency.cookie.rtread("rt-recent"),
                    i = $(".template-product .viewed.products").data("handle"),
                    o = $(".template-product .viewed.products").data("id");
                var e;
                if (null != e) {
                    if ((1 < (e = (e = e.split(",")).reverse()).length || e != i) && $("#recently-viewed-products").show(), $.ajax({
                            url: "/search?view=viewed&q=" + e + "_sp_" + o,
                            dataType: "html",
                            type: "GET",
                            success: function(t) {
                                $("#recently_wrap").html(t)
                            },
                            error: function() {
                                console.log("ajax error")
                            },
                            complete: function() {
                                theme.roarApplication.initLoadMore(), theme.CurrencyPicker.convert(".viewed.products .money"), 0 < t.length && t.not(".slick-initialized").slick({
                                    slidesToShow: t.data("per_view"),
                                    slidesToScroll: t.data("per_view"),
                                    arrows: !1,
                                    lazyLoad: "ondemand",
                                    dots: !0,
                                    responsive: [{
                                        breakpoint: 1200,
                                        settings: {
                                            slidesToShow: 3,
                                            slidesToScroll: 1
                                        }
                                    }, {
                                        breakpoint: 767,
                                        settings: {
                                            slidesToShow: 2,
                                            slidesToScroll: 1
                                        }
                                    }]
                                }), $(".viewed.products").find("img.lazy").lazyload()
                            }
                        }), 0 > e.indexOf(i)) {
                        e.length >= theme.viewed_limit && e.pop(), e.push(i);
                        try {
                            e = e.join(",")
                        } catch (t) {}
                    }
                } else e = i;
                Currency.cookie.rtwrite("rt-recent", e)
            },
            _initReviewTab: function() {
                $(".rt-unero-product-rating").unbind("click"), $(".rt-unero-product-rating").click((function() {
                    0 < $('a[href="#tab-reviews"]').length && $('a[href="#tab-reviews"]').trigger("click"), $("html,body").animate({
                        scrollTop: $("#tab-reviews").offset().top
                    }, "slow")
                }))
            },
            _initQuantity: function() {
                var t = $(this.selectors.addToCart),
                    e = $(this.selectors.qtyVariant);
                $(".q_up").unbind("click"), $(".q_up").click((function() {
                    var i = $(this).data("product_id"),
                        o = parseInt($(".qty-" + i).val()) + 1;
                    if ($(".qty-" + i).val(o), 0 < e.length) {
                        var a = !1;
                        e.each((function() {
                            var t = parseInt($(this).val()),
                                e = $(this).data("variant_id");
                            0 == t ? !$("form#cart-variant-form-" + e).hasClass("not-submit") && $("form.variant-form-" + i).addClass("not-submit") : (a = !0, $("form#cart-variant-form-" + e).removeClass("not-submit"))
                        })), a ? t.removeClass("disabled") : !t.hasClass("disabled") && t.addClass("disabled")
                    }
                })), $(".q_down").unbind("click"), $(".q_down").click((function() {
                    var i = $(this).data("product_id"),
                        o = parseInt($(".qty-" + i).val());
                    if (0 < e.length) {
                        0 < o && $(".qty-" + i).val(o - 1);
                        var a = !1;
                        e.each((function() {
                            var t = parseInt($(this).val()),
                                e = $(this).data("variant_id");
                            0 == t ? !$("form#cart-variant-form-" + e).hasClass("not-submit") && $("form.variant-form-" + i).addClass("not-submit") : (a = !0, $("form#cart-variant-form-" + e).removeClass("not-submit"))
                        })), a ? t.removeClass("disabled") : !t.hasClass("disabled") && t.addClass("disabled")
                    } else 1 < o && $(".qty-" + i).val(o - 1)
                }))
            },
            _initTab: function() {
                $(this.selectors.product + " .product-tabs").off("click").on("click", "ul.tabs li a", (function(t) {
                    if (t.preventDefault(), $(this).parent("li").hasClass("active")) return !1;
                    var e = $(this),
                        i = e.closest(".product-tabs"),
                        o;
                    return i.find("ul.tabs").find("li").removeClass("active"), $(this).parent("li").addClass("active"), i.find(".panel:visible").fadeOut(300, (function() {
                        i.find(e.attr("href")).fadeIn(300)
                    })), !1
                }))
            },
            _initGallery: function() {
                ! function(t) {
                    function e(t, e) {
                        return -1 < (" " + t.className + " ").indexOf(" " + e + " ")
                    }
                    for (var i = function(t) {
                            for (var e, i, o, a, n = $(t).find(".photoswipe-item").get(), s = n.length, r = [], c = 0; c < s; c++)
                                if (1 === (e = n[c]).nodeType)
                                    if (o = (i = e.children[0]).getAttribute("data-size").split("x"), "video" == $(i).data("type")) {
                                        var l = $($(i).data("id")).html();
                                        r.push({
                                            html: l
                                        })
                                    } else a = {
                                        src: i.getAttribute("href"),
                                        w: parseInt(o[0], 10),
                                        h: parseInt(o[1], 10)
                                    }, 1 < e.children.length && (a.title = $(e).find(".caption").html()), 0 < i.children.length && (a.msrc = i.children[0].getAttribute("src")), a.el = e, r.push(a);
                            return r
                        }, o = function t(e, i) {
                            return e && (i(e) ? e : t(e.parentNode, i))
                        }, a = function(t) {
                            (t = t || window.event).preventDefault ? t.preventDefault() : t.returnValue = !1;
                            var i = t.target || t.srcElement,
                                a = o(i, (function(t) {
                                    return e(t, "photoswipe-item")
                                }));
                            if (a) {
                                for (var n, r = a.closest(".photoswipe-wrapper"), c = $(a.closest(".photoswipe-wrapper")).find(".photoswipe-item").get(), l = c.length, d = 0, u = 0; u < l; u++)
                                    if (1 === c[u].nodeType) {
                                        if (c[u] === a) {
                                            n = d;
                                            break
                                        }
                                        d++
                                    } return 0 <= n && s(n, r), !1
                            }
                        }, n = function() {
                            var t = window.location.hash.substring(1),
                                e = {};
                            if (5 > t.length) return e;
                            for (var i = t.split("&"), o = 0; o < i.length; o++)
                                if (i[o]) {
                                    var a = i[o].split("=");
                                    2 > a.length || (e[a[0]] = a[1])
                                } return e.gid && (e.gid = parseInt(e.gid, 10)), e
                        }, s = function(t, e, o, a) {
                            var n, s, r, c = document.querySelectorAll(".pswp")[0];
                            if (r = i(e), s = {
                                    closeOnScroll: !1,
                                    galleryUID: e.getAttribute("data-pswp-uid")
                                }, a)
                                if (s.galleryPIDs) {
                                    for (var l = 0; l < r.length; l++)
                                        if (r[l].pid == t) {
                                            s.index = l;
                                            break
                                        }
                                } else s.index = parseInt(t, 10) - 1;
                            else s.index = parseInt(t, 10);
                            isNaN(s.index) || (o && (s.showAnimationDuration = 0), (n = new PhotoSwipe(c, PhotoSwipeUI_Default, r, s)).init(), n.listen("beforeChange", (function() {
                                var t = $(n.currItem.container);
                                $(".pswp__video").removeClass("active"), t.find(".pswp__video").addClass("active"), $(".pswp__video").each((function() {
                                    $(this).hasClass("active") || $(this).attr("src", $(this).attr("src"))
                                }))
                            })), n.listen("close", (function() {
                                $(".pswp__video").each((function() {
                                    $(this).attr("src", $(this).attr("src"))
                                }))
                            })))
                        }, r = document.querySelectorAll(t), c = 0, l = r.length; c < l; c++) r[c].setAttribute("data-pswp-uid", c + 1), r[c].onclick = a;
                    var d = n();
                    d.pid && d.gid && s(d.pid, r[d.gid - 1], !0, !0)
                }(this.selectors.product + " .photoswipe-wrapper")
            },
            _initZoom: function() {
                if ($(".easyzoom").length)
                    if (1024 < $(window).width()) var t, e = $(".easyzoom:not(.feature-video)").easyZoom({
                        loadingNotice: "",
                        errorNotice: "",
                        preventClicks: !1
                    }).data("easyZoom");
                    else $(".easyzoom a").click((function(t) {
                        t.preventDefault()
                    }))
            },
            _initImages: function() {
                var t = this,
                    e = $(t.selectors.productMainImages);
                if ("left" != this.settings.product_design && "bottom" != this.settings.product_design && "sidebar" != this.settings.product_design && "full-screen" != this.settings.product_design) "carousel" == this.settings.product_design ? e.not(".slick-initialized").slick({
                    centerMode: !0,
                    centerPadding: "500px",
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                    nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
                    responsive: [{
                        breakpoint: 1680,
                        settings: {
                            centerMode: !0,
                            centerPadding: "400px",
                            slidesToShow: 1
                        }
                    }, {
                        breakpoint: 1440,
                        settings: {
                            centerMode: !0,
                            centerPadding: "350px",
                            slidesToShow: 1
                        }
                    }, {
                        breakpoint: 1200,
                        settings: {
                            centerMode: !0,
                            centerPadding: "300px",
                            slidesToShow: 1
                        }
                    }, {
                        breakpoint: 1024,
                        settings: {
                            arrows: !1,
                            centerMode: !0,
                            centerPadding: "250px",
                            slidesToShow: 1
                        }
                    }, {
                        breakpoint: 992,
                        settings: {
                            centerMode: !0,
                            centerPadding: "200px",
                            slidesToShow: 1
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            arrows: !1,
                            centerMode: !0,
                            centerPadding: "125px",
                            slidesToShow: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            arrows: !1,
                            centerMode: !0,
                            centerPadding: "50px",
                            slidesToShow: 1
                        }
                    }]
                }) : e.not(".slick-initialized").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: !1,
                    asNavFor: i,
                    prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                    nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
                });
                else if (0 < $(t.selectors.productThumbImages).length) {
                    var i = $(t.selectors.productThumbImages).find(".thumbnails");
                    e.not(".slick-initialized").slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: !1,
                        asNavFor: i,
                        prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                        nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
                    });
                    var o = "0" != $(t.selectors.productThumbImages).data("vertical");
                    i.not(".slick-initialized").slick({
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        asNavFor: e,
                        focusOnSelect: !0,
                        vertical: o,
                        infinite: !1,
                        prevArrow: '<span class="icon-chevron-up slick-prev-arrow"></span>',
                        nextArrow: '<span class="icon-chevron-down slick-next-arrow"></span>'
                    })
                }
                e.imagesLoaded((function() {
                    e.addClass("loaded")
                }))
            },
            _initSidebar: function() {
                var t;
                $sidebarSlide = $(this.selectors.sidebarSlide), 0 < $sidebarSlide.length && $sidebarSlide.each((function() {
                    var t = $(this),
                        e = $(this).data("per_view");
                    $(this).not(".slick-initialized").slick({
                        slidesToShow: e,
                        slidesToScroll: 1,
                        vertical: !0,
                        focusOnSelect: !0,
                        infinite: !1,
                        prevArrow: '<span class="icon-chevron-up slick-prev-arrow"></span>',
                        nextArrow: '<span class="icon-chevron-down slick-next-arrow"></span>'
                    }), t.imagesLoaded((function() {
                        t.addClass("loaded")
                    }))
                }))
            },
            _initForceHeight: function() {
                0 < $(this.selectors.productPreviewMainImages).length && $(this.selectors.productPreviewMainImages).not(".slick-initialized").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: !1,
                    prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                    nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
                })
            },
            _initSwatches: function() {
                function t(t) {
                    let e = t.replace("https:", "").replace("http:", "").split("?v=")[0].split("/"),
                        i = e[e.length - 1].split("."),
                        o = i.pop(),
                        a = i.join(".") + "_100x." + o;
                    return t.replace(e[e.length - 1], a)
                }

                function e(t, e, a) {
                    for (i = 0; i < t.options.length; i++) i != e && $(o + "-" + i + " option").each((function() {
                        var o = "unavailable",
                            n = $(this).attr("value");
                        for (j = 0; j < t.variants.length; j++) {
                            var s = t.variants[j];
                            if (s.options[e] == a && s.options[i] == n) {
                                o = !0 == s.available ? "available" : "sold_out";
                                break
                            }
                        }
                        var r = "#swatch-" + i + "-" + n.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
                        $(r).removeClass("available").removeClass("sold_out").removeClass("unavailable").addClass(o)
                    }))
                }
                var o = this.selectors.singleOptionSelectorId,
                    a = this.productSingleObject,
                    n = this.productSwatchSingleObject,
                    s = [];
                if ("1" == this.settings.swatch_size && s.push("Size"), s.push("size"), "1" == this.settings.swatch_color && (s.push("Color"), s.push("Colour"), s.push("color"), s.push("colour")), 0 < s.length) {
                    var r = !1,
                        c = !1,
                        l = 0,
                        d = theme.asset_url.substring(0, theme.asset_url.lastIndexOf("?")),
                        u = theme.asset_url.substring(theme.asset_url.lastIndexOf("?"), theme.asset_url.length);
                    for (i = 0; i < a.options.length; i++) {
                        var p = "",
                            h = "",
                            m = "",
                            f = "",
                            v = "",
                            g = "",
                            y = "",
                            _ = "",
                            w = "";
                        if (p = "object" == typeof a.options[i] ? a.options[i].name : a.options[i], r = !1, c = !1, -1 < s.indexOf(p)) {
                            r = !0, l = i;
                            var b = p.toLowerCase();
                            if (/color|colour/i.test(b) && (c = !0), r) {
                                var C = [];
                                for (j = 0; j < a.variants.length; j++) {
                                    var k = a.variants[j],
                                        S = this.htmlEntities(k.options[l]),
                                        T = this.convertToSlug(S);
                                    0 > C.indexOf(S) && (w = "color" != b && "colour" != b ? "swatch-label " : "", g = $(this.selectors.singleOptionSelectorId + "-" + l).val() == S ? "selected " : "", "color" != b && "colour" != b ? _ = "background-color:" + S + "; background-image: url(" + d + T + ".png" + u + ")" : "1" == this.settings.swatch_color_advanced ? (y = "advanced", _ = null !== n[T] && void 0 !== n[T] && "" != n[T] ? "background-image: url(" + d + n[T] + ".png" + u + ")" : null === k.featured_image ? "background-color:" + S + "; background-image: url(" + d + T + ".png" + u + ")" : "background-image: url(" + t(k.featured_image.src) + ")") : (y = "", _ = "background-color:" + S + "; background-image: url(" + d + T + ".png" + u + ")"), m = m + '<span id="swatch-' + l + "-" + T + '" data-id="' + this.selectors.singleOptionSelectorId + "-" + l + '" data-original-title="' + S + '" class="' + "available" + " " + g + "swatch " + y + " " + w + " swatch-" + b + " swatch-" + S + '" title="' + S + '" data-value="' + S + '" data-poption="' + l + '" style="' + _ + '">' + S + "<span class='soldout-image'></span><span class='unero-tooltip '><span class='unero-tooltip-label'>" + S + "</span></span></span>", C.push(S))
                                }
                                h = '<div class="' + this.selectors.singleOptionSwatches + ' tawcvs-swatches" data-attribute_name="attribute_pa_' + b + '">' + m + "</div>", f = $(this.selectors.singleOptionSelectorId + "-" + l), v = $(this.selectors.variationSelector + "-" + l), "" != h && (f.after(h), f.hide(), v.addClass("hide-choose-option"))
                            }
                        }
                    }
                }
                var I = "";
                0 < $("." + this.selectors.singleOptionSwatches).length && ((I = $("." + this.selectors.singleOptionSwatches + " > span")).unbind("click"), I.on("click", (function() {
                    var t = $(this).data("id"),
                        i = $(this).data("poption"),
                        o = $(this).data("value");
                    $(this).data("value") != $(t).val() && ($(t).val($(this).data("value")).trigger("change"), $(t).closest("td").find("span.swatch").removeClass("selected"), $(this).addClass("selected")), e(a, i, o)
                }))), $(".swatch.selected").trigger("click")
            },
            htmlEntities: function(t) {
                return (t + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
            },
            convertToSlug: function(t) {
                t = t.toLowerCase();
                for (var e = ['"', "'", "\\", "(", ")", "[", "]"], i = 0; i < e.length; ++i) t = t.replace(e[i], "");
                return "-" == (t = t.replace(/\W+/g, "-")).charAt(t.length - 1) && (t = t.replace(/-+\z/, "")), "-" == t.charAt(0) && (t = t.replace(/\A-+/, "")), t
            },
            convertToSlug1: function(t) {
                return t.replace("/", "-").toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
            },
            _initVariants: function() {
                var t = {
                    $container: this.$container,
                    enableHistoryState: this.$container.data("enable-history-state") || !1,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.productSingleObject
                };
                this.variants = new slate.Variants(t), this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this))
            },
            _updateAddToCart: function(t) {
                var e = t.variant;
                e ? ($(this.selectors.productPrices).removeClass("invisible").attr("aria-hidden", "true"), e.available ? ($(".variations_button").removeClass("hide"), $(this.selectors.addToCart).prop("disabled", !1).toggleClass("hide", !1), $(this.selectors.addToCartText).text(theme.strings.addToCart), $(this.selectors.stockText).html(theme.strings.available + "<span>" + theme.strings.inStock + "</span>").removeClass("out-of-stock").addClass("in-stock"), "shopify" == e.inventory_management && "continue" != e.inventory_policy && (0 < e.inventory_quantity && 1 == parseInt(theme.inventory) ? $(this.selectors.stockText).html(theme.strings.available + "<span>" + e.inventory_quantity + " " + theme.strings.inStock + "</span>") : $(this.selectors.stockText).html(theme.strings.available + "<span>" + theme.strings.inStock + "</span>"))) : ($(".variations_button").addClass("hide"), $(this.selectors.addToCart).prop("disabled", !0).toggleClass("hide", !0), $(this.selectors.addToCartText).text(theme.strings.soldOut), $(this.selectors.stockText).html(theme.strings.available + "<span>" + theme.strings.outStock + "</span>").removeClass("in-stock").addClass("out-of-stock"))) : ($(".variations_button").addClass("hide"), $(this.selectors.addToCart).prop("disabled", !0).toggleClass("hide", !0), $(this.selectors.addToCartText).text(theme.strings.unavailable), $(this.selectors.stockText).html("<span>" + theme.strings.unavailable + "</span>").removeClass("in-stock").addClass("out-of-stock"), $(this.selectors.productPrices).addClass("invisible").attr("aria-hidden", "false"))
            },
            _updateImages: function(t) {
                var e = t.variant,
                    i = this,
                    o = this.settings.product_design,
                    a = e.featured_image.src.replace("https:", "").replace("http:", "").split("?v=")[0];
                $(this.selectors.productFeaturedImage).each((function() {
                    var t = $(this),
                        e;
                    if (0 <= t.attr("href").indexOf(a) && !t.closest(".slick-slide").hasClass("slick-cloned")) {
                        var n = $(i.selectors.productMainImages),
                            s = t.closest(".slick-slide").attr("data-slick-index");
                        if ("carousel" == o ? n.slick("slickGoTo", s) : n.slick("slickGoTo", s, !0), "scroll" == o) {
                            var r = parseInt(t.closest(".shopify-product-gallery__image").offset().top) - 50;
                            $("html,body").animate({
                                scrollTop: r
                            }, "slow")
                        }
                        "gallery" == o && 0 < $(".thumbnails .thumbnail-gallery-item").length && $(".thumbnails .thumbnail-gallery-item").each((function() {
                            var t;
                            0 <= $(this).data("href").indexOf(a) && $(this).trigger("click")
                        }))
                    } else;
                }))
            },
            _updatePrice: function(t) {
                var e = t.variant;
                if ($(this.selectors.originalPrice).html('<span class="money">' + theme.Currency.formatMoney(e.price, theme.moneyFormat) + "</span>"), e.compare_at_price > e.price) {
                    if ($(this.selectors.productPrices).addClass("has-sale"), $(this.selectors.productPrices).removeClass("not-sale"), $(this.selectors.comparePrice).html('<span class="money">' + theme.Currency.formatMoney(e.compare_at_price, theme.moneyFormat) + "</span>").removeClass("hide"), $(this.selectors.saleLabel).find("span").text(theme.strings.sale), "" != theme.sale_percentages) {
                        var i = Math.round(100 * (e.compare_at_price - e.price) / e.compare_at_price);
                        $(this.selectors.saleLabel).find("span").text("-" + i + "%")
                    }
                    $(this.selectors.saleLabel).addClass("hide")
                } else $(this.selectors.productPrices).removeClass("has-sale"), $(this.selectors.productPrices).addClass("not-sale"), $(this.selectors.comparePrice).addClass("hide"), $(this.selectors.saleLabel).addClass("hide");
                theme.CurrencyPicker.convert(this.selectors.product + " .money")
            },
            _updateSKU: function(t) {
                var e = t.variant;
                "" == e.sku ? $(this.selectors.SKU).addClass("hide") : $(this.selectors.SKU).removeClass("hide").find(".sku").text(e.sku)
            },
            onUnload: function() {
                this.$container.off(this.settings.namespace)
            }
        }), t
    }(), theme.Cart = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.cartId = $("#shopify-section-" + i), this.cart = $("#cart-" + i), this.cartNamespace = "#cart-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                Shopify.Cart.ShippingCalculator.show({
                    submitButton: theme.strings.shippingCalcSubmitButton,
                    submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
                    customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
                    moneyFormat: theme.strings.shippingCalcMoneyFormat
                }), this._initQuantity()
            },
            _initQuantity: function() {
                $(".q_up").unbind("click"), $(".q_up").click((function() {
                    var t = $(this).data("product_id"),
                        e = parseInt($(".qty-" + t).val()) + 1;
                    $(".qty-" + t).val(e)
                })), $(".q_down").unbind("click"), $(".q_down").click((function() {
                    var t = $(this).data("product_id"),
                        e = parseInt($(".qty-" + t).val());
                    0 < e && $(".qty-" + t).val(e - 1)
                }))
            },
            onUnload: function() {
                this.$container.off(this.cartNamespace)
            }
        }), t
    }(), theme.SearchTemplate = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.SearchId = $("#search-" + i), this.Search = $("#search-" + i), this.SearchNamspace = "#search-" + i, this.collection_infinite_scoll = this.Search.data("collection_infinite_scoll"), this.collection_infinite_scoll_auto = this.Search.data("collection_infinite_scoll_auto"), this.pInfScrLoading = !1, this.pInfScrMore = !0, this.flagScroll = !0, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initCollectionControl()
            },
            _initCollectionControl: function() {
                var t = this;
                "1" == this.collection_infinite_scoll && ("1" == this.collection_infinite_scoll_auto && $(window).scroll((function() {
                    var e = $(".load_more");
                    if (0 < e.length) {
                        var i = $(window),
                            o = i.scrollTop(),
                            a = o + i.height(),
                            n = e.offset().top,
                            s;
                        n + e.height() <= a && n >= o && t.flagScroll && (t.flagScroll = !1, e.find("a").trigger("click"))
                    }
                })), jQuery(".load_more a").click((function(e) {
                    return t._pInfScrExecute(), e.stopPropagation(), !1
                })))
            },
            _pInfScrExecute: function() {
                var t = this,
                    e = $(".load_more").last(),
                    i = $(".load_more a").last().attr("href");
                0 < e.length && t.pInfScrMore && $.ajax({
                    type: "GET",
                    url: i,
                    beforeSend: function() {
                        jQuery(".load_more").hide(), jQuery("#un-products-loading").toggleClass("hide").fadeIn()
                    },
                    success: function(e) {
                        var i = jQuery(e).find(".products .product");
                        if (jQuery(".products").append(i), jQuery("#un-products-loading").toggleClass("hide").fadeOut(), $(document.body).find("img.lazy").lazyload(), jQuery(e).find(".load_more a").length) {
                            jQuery(".load_more a").last().attr("href", jQuery(e).find(".load_more a").last().attr("href")), jQuery(".load_more").show(), t.flagScroll = !0;
                            var o = parseInt(jQuery(e).find(".load_more a").last().data("page"));
                            if (0 < o) {
                                var a, n, s = o * parseInt($(".page-num-offset").data("page_size"));
                                parseInt($(".page-num-offset").data("total_result")) > s && $(".result-offset").html(s).css("padding-right", "5px")
                            } else $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                        } else t.pInfScrMore = !1, jQuery(".load_more").remove(), $(".page-num-offset").html($(".page-num-offset").data("total_result"));
                        t._initReviews(), t._initCountDown(), $('[data-toggle="tooltip"]').tooltip(), theme.CurrencyPicker.convert(".un-shop-content .money")
                    },
                    dataType: "html"
                })
            },
            _initCountDown: function() {
                $().countdown && 0 < $(".countdown-item:not(.is-countdown)").length && $(".countdown-item:not(.is-countdown)").each((function() {
                    if ("" != $(this).data("countdown")) {
                        var t = new Date,
                            e = $(this).data("countdown").split("-"),
                            e;
                        t < (e = new Date(e[2], parseInt(e[0]) - 1, e[1])) && $(this).countdown({
                            until: e,
                            layout: '<span class="countdown-day">{dn}d</span><span class="countdown-hour">{hn}h</span><span class="countdown-minute">{mn}m</span><span class="countdown-second">{sn}s</span>'
                        })
                    }
                }))
            },
            _initReviews: function() {
                "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
            },
            onUnload: function() {
                this.$container.off(this.SearchNamspace)
            }
        }), t
    }(), theme.footerSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.footerId = $("#shopify-section-" + i), this.footer = $("#site-" + i), this.footerNamespace = "#site-" + i, this.footerNewsletterForm = $("#mc-form-" + i), this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initFooter(), 0 < this.footerNewsletterForm.length && this._initMailChimp()
            },
            _initFooter: function() {
                var t;
                "1" == $("#site-footer").data("parallax") ? ($(document.body).removeClass("footer-no-parallax").addClass("footer-parallax"), $(window).on("resize", (function() {
                    var t = $("#site-footer .footer-layout").outerHeight(!0);
                    if ($(document.body).css("padding-bottom", t), $(document.body).hasClass("page-header-layout-3") && "1" == $(".page-header").data("parallax")) {
                        $("#site-footer").addClass("has-parallax");
                        var e = $(".page-header").height();
                        $(window).on("scroll", (function() {
                            $(window).scrollTop() > e ? $("#site-footer").addClass("active") : $("#site-footer").removeClass("active")
                        }))
                    }
                })).trigger("resize")) : $(document.body).removeClass("footer-parallax").addClass("footer-no-parallax")
            },
            _initMailChimp: function() {
                var t = this.footerNewsletterForm,
                    e = t.attr("action");
                t.ajaxChimp({
                    url: e,
                    callback: function(e) {
                        "success" == e.result ? (jQuery("#rtp-message").html(e.msg), jQuery("#rt-unero-popup-message").css("margin-left", "-" + parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 + "px").fadeIn(), window.setTimeout((function() {
                            jQuery("#rt-unero-popup-message").fadeOut()
                        }), 2e3), t.find(".mc4wp-response").removeClass("error").hide()) : t.find(".mc4wp-response").addClass("error").html(e.msg).show()
                    }
                })
            },
            onUnload: function() {
                this.$container.off(this.footerNamespace)
            }
        }), t
    }(), theme.sideBarSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.sidebarId = $("#shopify-section-" + i), this.sidebar = $("#menu-sidebar-" + i), this.sidebarNamespace = "#menu-sidebar-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initMenu()
            },
            _initMenu: function() {
                $(".sidebar-child-menu").unbind("click"), $(".sidebar-child-menu").click((function(t) {
                    t.preventDefault(), $(this).closest("li").siblings().find("ul").slideUp(), $(this).closest("li").siblings().removeClass("active"), $(this).closest("li").siblings().find("li").removeClass("active"), $(this).closest("li").children("ul").slideToggle(), $(this).closest("li").toggleClass("active"), $(this).toggleClass("active")
                }))
            },
            onUnload: function() {
                this.$container.off(this.sidebarNamespace)
            }
        }), t
    }(), theme.mobileNavSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.mobileNavId = $("#shopify-section-" + i), this.mobileNav = $("#primary-" + i), this.mobilenavNamespace = "#primary-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initMobile()
            },
            _initMobile: function() {
                function t() {
                    $(document.body).removeClass("open-canvas-panel"), $(".unero-off-canvas-panel, #primary-mobile-nav").removeClass("open")
                }
                var e = this.mobileNav;
                $("#header-header").on("click", "#un-navbar-toggle", (function(t) {
                    t.preventDefault(), e.toggleClass("open"), $(document.body).toggleClass("open-canvas-panel")
                })), e.on("click", ".mobile-child-menu", (function(t) {
                    t.preventDefault(), $(this).closest("li").siblings().find("ul").slideUp(), $(this).closest("li").siblings().removeClass("active"), $(this).closest("li").siblings().find("li").removeClass("active"), $(this).closest("li").children("ul").slideToggle(), $(this).closest("li").toggleClass("active")
                })), 0 < $(".mobile-nav-footer").length && $(".mobile-nav-footer").on("click", ".toggle-children", (function(t) {
                    t.preventDefault(), $(this).closest("li").siblings().find("ul").slideUp(), $(this).closest("li").siblings().removeClass("active"), $(this).closest("li").siblings().find("li").removeClass("active"), $(this).closest("li").children("ul").slideToggle(), $(this).closest("li").toggleClass("active")
                })), e.on("click", ".close-canvas-mobile-panel", (function(e) {
                    e.preventDefault(), t()
                })), $(window).on("resize", (function() {
                    991 < $(window).width() && e.hasClass("open") && (e.removeClass("open"), $(document.body).removeClass("open-canvas-panel"))
                }))
            },
            onUnload: function() {
                this.$container.off(this.mobilenavNamespace)
            }
        }), t
    }(), theme.CollectionTemplate = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.CollectionId = $("#collection-" + i), this.Collection = $("#collection-" + i), this.CollectionNamspace = "#collection-" + i, this.collection_infinite_scoll = this.Collection.data("collection_infinite_scoll"), this.collection_infinite_scoll_auto = this.Collection.data("collection_infinite_scoll_auto"), this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initCollectionFilter()
            },
            _initCollectionFilter: function() {
                function t() {
                    var t = $(".load_more").last(),
                        e = $(".load_more a").last().attr("href");
                    0 < t.length && a && $.ajax({
                        type: "GET",
                        url: e,
                        beforeSend: function() {
                            jQuery(".load_more").hide(), jQuery("#un-products-loading").toggleClass("hide").fadeIn()
                        },
                        success: function(t) {
                            var e = jQuery(".products"),
                                i = jQuery(t).find(".products .product");
                            if ($(document.body).hasClass("catalog-board-content") || $(document.body).hasClass("collection-metro-content") ? i.imagesLoaded((function() {
                                    e.isotope("insert", i), theme.roarApplication.initLoadMore()
                                })) : (e.append(i), theme.roarApplication.initLoadMore()), jQuery("#un-products-loading").toggleClass("hide").fadeOut(), $(document.body).find("img.lazy").lazyload(), jQuery(t).find(".load_more a").length) {
                                jQuery(".load_more a").last().attr("href", jQuery(t).find(".load_more a").last().attr("href")), jQuery(".load_more").show(), n = !0;
                                var o = parseInt(jQuery(t).find(".load_more a").last().data("page"));
                                if (0 < o) {
                                    var s, r, c = o * parseInt($(".page-num-offset").data("page_size"));
                                    parseInt($(".page-num-offset").data("total_result")) > c && $(".result-offset").html(c).css("padding-right", "5px")
                                } else $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                            } else a = !1, jQuery(".load_more").remove(), $(".page-num-offset").html($(".page-num-offset").data("total_result"));
                            theme.CurrencyPicker.convert(".un-shop-content .money")
                        },
                        dataType: "html"
                    })
                }

                function e(t) {
                    var e;
                    delete Shopify.queryParams.page, o(i(t))
                }

                function i(t) {
                    var e = $.param(Shopify.queryParams).replace(/%2B/g, "+");
                    return t ? "" == e ? t : t + "?" + e : location.pathname + "?" + e
                }

                function o(t) {
                    var e = $("#un-shop-content"),
                        i = $("#primary-sidebar"),
                        o = $("#primary-offcanvas"),
                        s = $("#un-categories-filter"),
                        r = $("#un-shop-topbar"),
                        c = $(".product-found > span"),
                        l = $(".shop-toolbar .rt-unero-ordering");
                    if (0 < $("#un-shop-toolbar").length) {
                        var d = $("#un-shop-toolbar").offset().top - 200;
                        $("html, body").stop().animate({
                            scrollTop: d
                        }, 1200)
                    }
                    $("#un-shop-loading").addClass("show"), $.ajax({
                        type: "get",
                        url: t,
                        beforeSend: function() {
                            ($("#un-shop-toolbar").hasClass("on-mobile") || $("#un-shop-topbar").hasClass("on-mobile")) && ($("#un-categories-filter").slideUp(), $("#un-shop-topbar").slideUp(), $("#un-toggle-cats-filter").removeClass("active"), $(".un-filter").removeClass("active"))
                        },
                        success: function(d) {
                            e.replaceWith($(d).find("#un-shop-content")), i.html($(d).find(".catalog-sidebar").html()), o.html($(d).find(".catalog-offcanvas").html()), s.html($(d).find("#un-categories-filter").html()), r.html($(d).find("#un-shop-topbar").html()), c.html($(d).find(".product-found > span").html()), l.html($(d).find(".shop-toolbar .rt-unero-ordering").html()), "?" == t.slice(-1) && (t = t.slice(0, -1)), t = t.replace(/%2C/g, ","), history.pushState(null, null, t), theme.roarApplication.initLoadMore(), a = !0, n = !0, theme.CurrencyPicker.convert(".un-shop-content .money"), $("#un-shop-loading").removeClass("show"), 0 < $(".wc-layered-nav-term.chosen").length ? $("#remove-filter-actived").removeClass("hide") : $("#remove-filter-actived").addClass("hide")
                        },
                        error: function() {
                            $("#un-shop-loading").removeClass("show")
                        }
                    })
                }
                if (0 < $(".shop-bottombar").length && $(window).on("scroll", (function() {
                        $(document.body).find("#un-shop-footer").is(":in-viewport") ? $(".shop-bottombar").find(".un-filter").addClass("not-viewport") : $(".shop-bottombar").find(".un-filter").removeClass("not-viewport")
                    })).trigger("scroll"), $("body").on("click", ".wc-layered-nav-term a", (function(t) {
                        var t = $(this).parent(),
                            i = $(this).data("value"),
                            o = [];
                        if (Shopify.queryParams.constraint && (o = Shopify.queryParams.constraint.split("+")), !window.enable_filter_multiple_choice && !t.hasClass("chosen")) {
                            var a = t.parents(".wc-layered-nav-term").find(".chosen");
                            0 < a.length && a.each((function() {
                                var t = $(this).data("handle");
                                if ($(this).removeClass("chosen"), t) {
                                    var e = o.indexOf(t);
                                    0 <= e && o.splice(e, 1)
                                }
                            }))
                        }
                        if (i) {
                            var n = o.indexOf(i);
                            0 > n ? (o.push(i), t.addClass("chosen")) : (o.splice(n, 1), t.removeClass("chosen"))
                        }
                        o.length ? Shopify.queryParams.constraint = o.join("+") : delete Shopify.queryParams.constraint, e()
                    })), $("body").on("click", ".rt-unero-pagination a", (function(t) {
                        var i = $(this);
                        delete Shopify.queryParams.page, delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, delete Shopify.queryParams.sort_by, e(i.attr("href")), t.preventDefault()
                    })), $("body").on("click", ".rt-unero-ordering a", (function(t) {
                        var i = $(this),
                            o = i.data("sort");
                        $(".rt-unero-ordering a").removeClass("active"), i.addClass("active"), Shopify.queryParams.sort_by = o, e(), t.preventDefault()
                    })), $("body").on("click", "#unero_product_tag_cloud a", (function(t) {
                        var t = $(this),
                            i = $(this).data("value"),
                            o = [];
                        if (Shopify.queryParams.constraint && (o = Shopify.queryParams.constraint.split("+")), !window.enable_filter_multiple_choice && !t.hasClass("selected")) {
                            var a = t.parents(".tagcloud").find(".selected");
                            0 < a.length && a.each((function() {
                                var t = $(this).data("handle");
                                if ($(this).removeClass("selected"), t) {
                                    var e = o.indexOf(t);
                                    0 <= e && o.splice(e, 1)
                                }
                            }))
                        }
                        if (i) {
                            var n = o.indexOf(i);
                            0 > n ? (o.push(i), t.addClass("selected")) : (o.splice(n, 1), t.removeClass("selected"))
                        }
                        o.length ? Shopify.queryParams.constraint = o.join("+") : delete Shopify.queryParams.constraint, e()
                    })), "1" == this.collection_infinite_scoll) {
                    var a = !0,
                        n = !0;
                    "1" == this.collection_infinite_scoll_auto && $(window).scroll((function() {
                        var t = $(".load_more");
                        if (0 < t.length) {
                            var e = $(window),
                                i = e.scrollTop(),
                                o = i + e.height(),
                                a = t.offset().top,
                                s;
                            a + t.height() <= o && a >= i && n && (n = !1, t.find("a").trigger("click"))
                        }
                    })), $("body").on("click", ".load_more a", (function(e) {
                        return t(), e.stopPropagation(), !1
                    }))
                }
                $("body").on("click", "#remove-filter-actived", (function(t) {
                    delete Shopify.queryParams.page, delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, e(), t.preventDefault()
                }))
            },
            _initReviews: function() {
                "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
            },
            onUnload: function() {
                this.$container.off(this.SearchNamspace)
            }
        }), t
    }(), theme.CollectionInstagramTemplate = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.collectionId = $("#shopify-section-" + i), this.collection = $("#collection-" + i), this.collectionNamespace = "#collection-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initInstafeed()
            },
            _initInstafeed: function() {
                var t = "shop-instagram-" + this.sectionId,
                    e = this.collection.data("token"),
                    i = this.collection.data("id"),
                    o = this.collection.data("limit"),
                    a;
                new Instafeed({
                    get: "user",
                    target: t,
                    accessToken: e,
                    userId: i,
                    limit: o,
                    resolution: "standard_resolution",
                    resolution2: "standard_resolution",
                    template: '<div class="wrap animated"><a class="fauximg-bin" target="_blank" href="{{link}}"><figure class="snpt__fauximg" style="background-image: url({{image}})"></figure><i class="t-icon icon-bag2 snptlinked-item-ico"></i></a><div class="snptcrd__ovrly"><div class="ovrly_content snpt-atm sfx-scale-up"><div class="snpt-atm-el sfx__animated"><div class="snptcrd__button"><i class="t-icon icon-bag2"></i></div></div></div></div></div>'
                }).run()
            },
            onUnload: function() {
                this.$container.off(this.collectionNamespace)
            }
        }), t
    }(), theme.CollectionsTemplate = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.CollectionsId = $("#shopify-section-" + i), this.Collections = $("#unero-site-content"), this.CollectionsNamspace = "#unero-site-content", this.collection_infinite_scoll = this.Collections.data("collection_infinite_scoll"), this.collection_infinite_scoll_auto = this.Collections.data("collection_infinite_scoll_auto"), this.pInfScrLoading = !1, this.pInfScrMore = !0, this.flagScroll = !0, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initCollectionControl()
            },
            _initCollectionControl: function() {
                var t = this;
                "1" == this.collection_infinite_scoll && ("1" == this.collection_infinite_scoll_auto && $(window).scroll((function() {
                    var e = $(".load_more");
                    if (0 < e.length) {
                        var i = $(window),
                            o = i.scrollTop(),
                            a = o + i.height(),
                            n = e.offset().top,
                            s;
                        n + e.height() <= a && n >= o && t.flagScroll && (t.flagScroll = !1, e.find("a").trigger("click"))
                    }
                })), jQuery(".load_more a").click((function(e) {
                    return t._pInfScrExecute(), e.stopPropagation(), !1
                })))
            },
            _pInfScrExecute: function() {
                var t = this,
                    e = $(".load_more").last(),
                    i = $(".load_more a").last().attr("href");
                0 < e.length && t.pInfScrMore && $.ajax({
                    type: "GET",
                    url: i,
                    beforeSend: function() {
                        jQuery(".load_more").hide(), jQuery("#un-products-loading").toggleClass("hide").fadeIn()
                    },
                    success: function(e) {
                        var i = $(e).find(".unero-post-list").children(".un-post-item");
                        if (i.imagesLoaded((function() {
                                $(".unero-post-list").append(i).isotope("insert", i)
                            })), jQuery("#un-products-loading").toggleClass("hide").fadeOut(), $(document.body).find("img.lazy").lazyload(), jQuery(e).find(".load_more a").length) {
                            jQuery(".load_more a").last().attr("href", jQuery(e).find(".load_more a").last().attr("href")), jQuery(".load_more").show(), t.flagScroll = !0;
                            var o = parseInt(jQuery(e).find(".load_more a").last().data("page"));
                            if (0 < o) {
                                var a, n, s = o * parseInt($(".page-num-offset").data("page_size"));
                                parseInt($(".page-num-offset").data("total_result")) > s && $(".result-offset").html(s).css("padding-right", "5px")
                            } else $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                        } else t.pInfScrMore = !1, jQuery(".load_more").remove(), $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                    },
                    dataType: "html"
                })
            },
            _initReviews: function() {
                "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
            },
            onUnload: function() {
                this.$container.off(this.CollectionsNamspace)
            }
        }), t
    }(), theme.BlogTemplate = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.BlogId = $("#shopify-section-" + i), this.Blog = $("#unero-site-content"), this.BlogNamspace = "#unero-site-content", this.collection_infinite_scoll = this.Blog.data("collection_infinite_scoll"), this.collection_infinite_scoll_auto = this.Blog.data("collection_infinite_scoll_auto"), this.sidebar = this.Blog.data("sidebar"), this.pInfScrLoading = !1, this.pInfScrMore = !0, this.flagScroll = !0, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initCollectionControl(), "" != this.sidebar && $(document.body).removeClass("full-content").addClass(this.sidebar)
            },
            _initCollectionControl: function() {
                var t = this;
                "1" == this.collection_infinite_scoll && ("1" == this.collection_infinite_scoll_auto && $(window).scroll((function() {
                    var e = $(".load_more");
                    if (0 < e.length) {
                        var i = $(window),
                            o = i.scrollTop(),
                            a = o + i.height(),
                            n = e.offset().top,
                            s;
                        n + e.height() <= a && n >= o && t.flagScroll && (t.flagScroll = !1, e.find("a").trigger("click"))
                    }
                })), jQuery(".load_more a").click((function(e) {
                    return t._pInfScrExecute(), e.stopPropagation(), !1
                })))
            },
            _pInfScrExecute: function() {
                var t = this,
                    e = $(".load_more").last(),
                    i = $(".load_more a").last().attr("href");
                0 < e.length && t.pInfScrMore && $.ajax({
                    type: "GET",
                    url: i,
                    beforeSend: function() {
                        jQuery(".load_more").hide(), jQuery("#un-products-loading").toggleClass("hide").fadeIn()
                    },
                    success: function(e) {
                        var i = $(e).find(".unero-post-list").children(".un-post-item");
                        if ($("#unero-site-content").hasClass("blog-layout-masonry") ? i.imagesLoaded((function() {
                                $(".unero-post-list").append(i).isotope("insert", i)
                            })) : $(".unero-post-list").append(i), jQuery("#un-products-loading").toggleClass("hide").fadeOut(), $(document.body).find("img.lazy").lazyload(), jQuery(e).find(".load_more a").length) {
                            jQuery(".load_more a").last().attr("href", jQuery(e).find(".load_more a").last().attr("href")), jQuery(".load_more").show(), t.flagScroll = !0;
                            var o = parseInt(jQuery(e).find(".load_more a").last().data("page"));
                            if (0 < o) {
                                var a, n, s = o * parseInt($(".page-num-offset").data("page_size"));
                                parseInt($(".page-num-offset").data("total_result")) > s && $(".result-offset").html(s).css("padding-right", "5px")
                            } else $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                        } else t.pInfScrMore = !1, jQuery(".load_more").remove(), $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                    },
                    dataType: "html"
                })
            },
            onUnload: function() {
                this.$container.off(this.BlogNamspace)
            }
        }), t
    }(), theme.portfolioMasonry = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.portfolioId = $("#shopify-section-" + i), this.portfolio = $("#unero-site-content"), this.portfolioNamspace = "#unero-site-content", this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {},
            onUnload: function() {
                this.$container.off(this.portfolioNamspace)
            }
        }), t
    }(), theme.portfolioCarousel = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.portfolioId = $("#shopify-section-" + i), this.portfolio = $("#unero-site-content"), this.portfolioNamspace = "#unero-site-content", this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {},
            onUnload: function() {
                this.$container.off(this.portfolioNamspace)
            }
        }), t
    }(), theme.ArticleTemplate = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.articleId = $("#shopify-section-" + i), this.article = $(".article-" + i), this.articleNamspace = ".article-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initRecommended()
            },
            _initRecommended: function() {
                var t = $(this.articleNamspace + " .related.products ul.products");
                0 < t.length && "1" == t.data("slide_enable") && t.not(".slick-initialized").slick({
                    slidesToShow: t.data("per_view"),
                    slidesToScroll: t.data("per_view"),
                    arrows: !1,
                    lazyLoad: "ondemand",
                    dots: !0,
                    responsive: [{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }]
                })
            },
            onUnload: function() {
                this.$container.off(this.articleNamspace)
            }
        }), t
    }(), theme.faqsTemplate = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.faqsId = $("#shopify-section-" + i), this.faqs = $("#content"), this.faqsNamspace = "#content", this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {},
            onUnload: function() {
                this.$container.off(this.faqsNamspace)
            }
        }), t
    }(), theme.aboutTemplate = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.aboutId = $("#shopify-section-" + i), this.about = $("#content"), this.aboutNamspace = "#content", this.aboutSlide = $("#slide-" + i), this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initSlide()
            },
            _initSlide: function() {
                var t = this.aboutSlide;
                t.not(".slick-initialized").slick({
                    slidesToShow: parseInt(t.data("per_view")),
                    slidesToScroll: 1,
                    lazyLoad: "ondemand",
                    dots: !1,
                    arrows: !1,
                    responsive: [{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    }]
                })
            },
            onUnload: function() {
                this.$container.off(this.aboutNamspace)
            }
        }), t
    }(), theme.SliderSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.sliderId = $("#shopify-section-" + i), this.slider = $("#" + i), this.sliderNamspace = "#" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                "1" == this.slider.data("parallax") ? ($(document.body).hasClass("header-slider-top") && $(document.body).removeClass("header-slider-noparallax"), $(document.body).removeClass("page-header-layout-1").addClass("page-header-layout-3"), function() {
                    if ($(".page-header").hasClass("page-header-sliders")) {
                        var t = $(".page-header-sliders"),
                            e = t.data("speed"),
                            i = !1,
                            o = t.data("auto"),
                            a = t.data("parallax");
                        if ("1" == a && (i = !0), t.find("ul").not(".slick-initialized").slick({
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: !0,
                                autoplaySpeed: e,
                                autoplay: o,
                                fade: i,
                                cssEase: "linear",
                                prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                                nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
                            }), "0" == a) $(".page-header-sliders.parallax").find("li").parallax("50%", .6);
                        else {
                            var n = t.height();
                            $(document.body).hasClass("admin-bar") && (n -= 32), $("#content").css("margin-top", n), t.addClass("parallax-2"), $(window).on("scroll", (function() {
                                var t = $(window).scrollTop();
                                0 < t ? $(".page-header-sliders.parallax-2").css({
                                    opacity: (n - t) / n
                                }) : $(".page-header-sliders.parallax-2").css({
                                    opacity: 1
                                })
                            }))
                        }
                    } else $(".page-header.parallax").parallax("50%", .6)
                }()) : ($(document.body).hasClass("header-slider-top") && $(document.body).addClass("header-slider-noparallax"), $(document.body).addClass("page-header-layout-1")), this._initSlider()
            },
            _initSlider: function() {
                if (this.slider.hasClass("page-header-sliders")) {
                    var t = this.slider,
                        e = t.data("speed"),
                        i = !1,
                        o = t.data("auto"),
                        a = t.data("parallax");
                    if ("1" == a && (i = !0), t.find("ul").not(".slick-initialized").slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: !0,
                            autoplaySpeed: e,
                            autoplay: o,
                            fade: i || "1" == t.data("fade"),
                            cssEase: "linear",
                            prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                            nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
                        }), "" == a) $(".page-header-sliders.parallax").find("li").parallax("50%", .6);
                    else {
                        var n = t.height();
                        $(document.body).hasClass("admin-bar") && (n -= 32), $("#content").css("margin-top", n), t.addClass("parallax-2"), $(window).on("scroll", (function() {
                            var t = $(window).scrollTop();
                            0 < t ? $(".page-header-sliders.parallax-2").css({
                                opacity: (n - t) / n
                            }) : $(".page-header-sliders.parallax-2").css({
                                opacity: 1
                            })
                        }))
                    }
                    isFacebookApp() && $("#slider-ul").slick("slickPause")
                } else $(".page-header.parallax").parallax("50%", .6)
            },
            onUnload: function() {
                this.$container.off(this.sliderNamspace)
            }
        }), t
    }(), theme.uneroSliderSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.uneroSliderId = $("#unero-sliders-wrapper-" + i), this.uneroSlider = $("#unero-sliders-" + i), this.uneroSliderNamspace = "#unero-sliders-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initUneroSlide()
            },
            _initUneroSlide: function() {
                var t = !1,
                    e = !1,
                    i = !1,
                    o = parseInt(this.uneroSliderId.data("height")),
                    a = parseInt(this.uneroSliderId.data("parallax")),
                    n = this.uneroSliderId.data("speed"),
                    s = this.uneroSliderId.data("autoplay"),
                    r = "1" == this.uneroSliderId.data("dots"),
                    c = this.uneroSlider;
                "1" == this.uneroSliderId.data("autoplay") && (t = !0), "1" == a && (e = !0), "1" == this.uneroSliderId.data("direction") && (i = !0), c.not(".slick-initialized").slick({
                    rtl: i,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplaySpeed: n,
                    dots: r,
                    autoplay: s,
                    infinite: t,
                    fade: e,
                    lazyLoad: "ondemand",
                    prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                    nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
                }), $(window).on("resize", (function() {
                    if (0 < o) {
                        var t = $(window).width();
                        c.height(t * o / 1903)
                    }
                })).trigger("resize"), "1" == a && c.find(".featured-img").parallax("50%", .6), c.imagesLoaded((function() {
                    c.addClass("loaded")
                }));
                var l = c.find(".unvideo-bg").find("video");
                0 < l.length && l[0].play(), c.on("afterChange", (function(t, e, i) {
                    var o = c.find('.slick-slide[data-slick-index="' + i + '"]').find("video");
                    0 < o.length && o[0].play()
                })), c.on("beforeChange", (function(t, e, i) {
                    var o = c.find('.slick-slide[data-slick-index="' + i + '"]').find("video");
                    0 < o.length && o[0].pause()
                }))
            },
            onUnload: function() {
                this.$container.off(this.uneroSliderNamspace)
            }
        }), t
    }(), theme.uneroHeroSliderSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.uneroHeroSliderId = $("#shopify-section-" + i), this.uneroHeroSlider = $("#unero-hero-slider-" + i), this.uneroHeroSliderNamspace = "#unero-hero-slider-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initUneroHeroSlide()
            },
            _initUneroHeroSlide: function() {
                $(".unero-hero-slider").on("mouseover touchstart", ".item-content", (function() {
                    var t = $(this),
                        e = t.index(),
                        i = t.closest(".unero-hero-slider").find(".item-image");
                    i.removeClass("active"), t.siblings().removeClass("active"), t.addClass("active"), i.filter(":eq(" + e + ")").addClass("active")
                }))
            },
            onUnload: function() {
                this.$container.off(this.uneroHeroSliderNamspace)
            }
        }), t
    }(), theme.uneroCollectionsSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.uneroCollectionsId = $("#unero-banners-carousel-" + i), this.uneroCollections = $("#banners-carousel-" + i), this.uneroCollectionsNamspace = "#banners-carousel-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                "1" == this.uneroCollectionsId.data("slide_enable") && this._initUneroCollections()
            },
            _initUneroCollections: function() {
                var t = !1,
                    e = !1,
                    i = this.uneroCollectionsId.data("speed"),
                    o = this.uneroCollectionsId.data("autoplay"),
                    a = this.uneroCollectionsId.data("perview"),
                    n = this.uneroCollections;
                "1" == this.uneroCollectionsId.data("autoplay") && (t = !0), "1" == this.uneroCollectionsId.data("direction") && (e = !0), n.not(".slick-initialized").slick({
                    rtl: e,
                    slidesToShow: a,
                    slidesToScroll: 1,
                    autoplaySpeed: i,
                    autoplay: o,
                    infinite: t,
                    lazyLoad: "ondemand",
                    prevArrow: '<span class="icon-arrow-left slick-prev-arrow"></span>',
                    nextArrow: '<span class="icon-arrow-right slick-next-arrow"></span>',
                    responsive: [{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                }), n.imagesLoaded((function() {
                    n.addClass("loaded")
                }))
            },
            onUnload: function() {
                this.$container.off(this.uneroCollectionsNamspace)
            }
        }), t
    }(), theme.uneroCollectionsMasonrySection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.uneroCollectionsId = $("#shopify-section-" + i), this.uneroCollections = $("#unero-collections-masonry-wrapper-" + i), this.uneroCollectionsNamspace = "#unero-collections-masonry-wrapper-" + i, this.uneroBanner = $(".unero-banner-" + i), this.uneroNewsletter = $("#mc-form.newsletter-" + i), this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                0 < this.uneroBanner.length && this.uneroBanner.each((function() {
                    var t = $(this).find(".text").width(),
                        e = -1 * (t / 2 + 25),
                        i = $(this).find(".data-height").data("height");
                    $(this).hasClass("text-align-left") ? $(this).find(".text").css("left", e) : $(this).find(".text").css("right", e), $(this).hasClass("text-position-center") && $(this).find(".text").css("top", (i - t) / 2)
                })), 0 < this.uneroNewsletter.length && this._initNewsletter()
            },
            _initNewsletter: function() {
                function t() {}
                var e = this.uneroNewsletter,
                    i = e.attr("action");
                e.ajaxChimp({
                    url: i,
                    callback: function(e) {
                        "success" === e.result && t()
                    }
                })
            },
            onUnload: function() {
                this.$container.off(this.uneroCollectionsNamspace)
            }
        }), t
    }(), theme.uneroBannerSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.uneroBannerId = $("#shopify-section-" + i), this.uneroBanner = $("#unero-banners-grid-" + i), this.uneroBannerNamspace = "#unero-banners-grid-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {},
            onUnload: function() {
                this.$container.off(this.uneroBannerNamspace)
            }
        }), t
    }(), theme.uneroBannerMetroSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.uneroBannerId = $("#shopify-section-" + i), this.uneroBanner = $("#unero-banners-metro-" + i), this.uneroBannerNamspace = "#unero-banners-metro-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initMasonry()
            },
            _initMasonry: function() {
                var t = this.uneroBanner;
                t.find(".unero-banners-metro-content").imagesLoaded((function() {
                    t.find(".unero-banners-metro-content").isotope({
                        itemSelector: ".banner-item",
                        layoutMode: "packery"
                    })
                }))
            },
            onUnload: function() {
                this.$container.off(this.uneroBannerNamspace)
            }
        }), t
    }(), theme.uneroAboutSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.uneroAboutId = $("#shopify-section-" + i), this.uneroAbout = $("#unero-about-wrapper-" + i), this.uneroAboutNamspace = "#unero-about-wrapper-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {},
            onUnload: function() {
                this.$container.off(this.uneroAboutNamspace)
            }
        }), t
    }(), theme.uneroProductsCarouselSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.carouselId = $("#unero-products-carousel-wrapper-" + i), this.carousel = $(".unero-products-carousel-" + i), this.carouselNamspace = "#unero-products-carousel-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                0 < this.carousel.length && this.carousel.each((function() {
                    if ("1" == $(this).data("slide")) {
                        var t = $(this),
                            e = $(this).data("perview"),
                            i = $(this).data("autoplay"),
                            o = $(this).data("speed"),
                            a = !1;
                        "1" == i && (a = !0), t.not(".slick-initialized").slick({
                            rtl: !1,
                            slidesToShow: e,
                            slidesToScroll: 1,
                            autoplaySpeed: o,
                            autoplay: i,
                            infinite: a,
                            lazyLoad: "ondemand",
                            prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                            nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
                            responsive: [{
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1
                                }
                            }, {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1
                                }
                            }]
                        })
                    }
                }))
            },
            onUnload: function() {
                this.$container.off(this.carouselNamspace)
            }
        }), t
    }(), theme.uneroInstagramSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.uneroInstagramId = $("#unero-instagram-wrapper-" + i), this.uneroInstagram = $("#unero-instagram-" + i), this.uneroInstagramNamspace = "#unero-instagram-" + i, this.uneroInstagramTarget = "unero-instagram-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                "carousel" == this.uneroInstagram.data("type") ? this._initCarousel() : this._initGrid()
            },
            _initGrid: function() {
                var t = this.uneroInstagram,
                    e = this.uneroInstagramTarget,
                    i = t.attr("data-id"),
                    o = t.attr("data-token"),
                    a = t.attr("data-limit"),
                    n;
                new Instafeed({
                    get: "user",
                    target: e,
                    accessToken: o,
                    userId: parseInt(i),
                    limit: parseInt(a),
                    resolution: "standard_resolution",
                    resolution2: "standard_resolution",
                    template: '<div class="wrap animated"><a class="fauximg-bin" target="_blank" href="{{link}}"><figure class="snpt__fauximg" style="background-image: url({{image}})"></figure><i class="t-icon icon-bag2 snptlinked-item-ico"></i></a><div class="snptcrd__ovrly"><div class="ovrly_content snpt-atm sfx-scale-up"><div class="snpt-atm-el sfx__animated"><div class="snptcrd__button"><i class="t-icon icon-bag2"></i></div></div></div></div></div>'
                }).run()
            },
            _initCarousel: function() {
                var t = this.uneroInstagram,
                    e = this.uneroInstagramTarget,
                    i = t.attr("data-id"),
                    o = t.attr("data-token"),
                    a = t.attr("data-limit"),
                    n = t.data("perview"),
                    s = t.data("autoplay"),
                    r = !1,
                    c = t.data("speed"),
                    l;
                new Instafeed({
                    get: "user",
                    target: e,
                    accessToken: o,
                    userId: parseInt(i),
                    limit: parseInt(a),
                    resolution: "standard_resolution",
                    resolution2: "standard_resolution",
                    template: '<li class="product"><a class="insta-item" target="_blank" href="{{link}}" style="background-image:url({{image}});"><i class="social_instagram"></i></a></li>',
                    after: function() {
                        0 < s ? (r = !0, s = !0) : s = !1, t.not(".slick-initialized").slick({
                            slidesToShow: n,
                            slidesToScroll: 1,
                            autoplaySpeed: c,
                            autoplay: s,
                            infinite: r,
                            dots: !1,
                            prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                            nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
                            responsive: [{
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1
                                }
                            }, {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1
                                }
                            }]
                        })
                    }
                }).run()
            },
            onUnload: function() {
                this.$container.off(this.uneroInstagramNamspace)
            }
        }), t
    }(), theme.unseroBlogSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.unseroBlogId = $("#shopify-section-" + i), this.unseroBlog = $("#unero-posts-" + i), this.unseroBlogNamspace = "#unero-posts-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {},
            onUnload: function() {
                this.$container.off(this.unseroBlogNamspace)
            }
        }), t
    }(), theme.toTopSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.toTopId = $("#shopify-section-" + i), this.toTop = $("#to-top-" + i), this.toTopNamespace = "#to-top-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initToTop()
            },
            _initToTop: function() {
                var t = $(".cd-top");
                $(window).scroll((function() {
                    $(this).scrollTop() > 300 ? t.addClass("cd-is-visible") : t.removeClass("cd-is-visible cd-fade-out"), $(this).scrollTop() > 1200 && t.addClass("cd-fade-out")
                })), t.on("click", (function(t) {
                    t.preventDefault(), $("body,html").animate({
                        scrollTop: 0
                    }, 700)
                }))
            },
            onUnload: function() {
                this.$container.off(this.toTopNamespace)
            }
        }), t
    }(), theme.unseroNewsletterSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.unseroNewsletterId = $("#shopify-section-" + i), this.unseroNewsletter = $("#unero-newsletter-" + i), this.unseroNewsletterNamspace = "#unero-newsletter-" + i, this.uneroNewsletterForm = $("#mc-form.newsletter-" + i), this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                function t() {}
                var e = this.uneroNewsletterForm,
                    i = e.attr("action");
                e.ajaxChimp({
                    url: i,
                    callback: function(e) {
                        "success" === e.result && t()
                    }
                })
            },
            onUnload: function() {
                this.$container.off(this.unseroNewsletterNamspace)
            }
        }), t
    }(), theme.uneroProductTabsSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.productTabsId = $("#product-tabs-wrapper-" + i), this.productTabs = $("#product-tabs-wrapper-" + i), this.productTabsNamspace = "#product-tabs-wrapper-" + i, this.productTabsShop = $("#product-tabs-wrapper-" + i + " .product-tabs-masonry-2"), this.productTabsBlog = $("#product-tabs-wrapper-" + i + " .product-tabs-masonry-3"), this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this._initTab(), 0 < this.productTabsShop.length && this._initShopLayout(), "1" == this.productTabs.data("animation") && this._animationProduct()
            },
            _initTab: function() {
                $(this.productTabsNamspace + " .product-tabs").off("click").on("click", "ul.tabs li a", (function(t) {
                    if (t.preventDefault(), $(this).parent("li").hasClass("active")) return !1;
                    var e = $(this),
                        i = e.closest(".product-tabs"),
                        o = i.find("ul.tabs"),
                        a = $(e.attr("href")).find("ul.products");
                    return o.find("li").removeClass("active"), $(this).parent("li").addClass("active"), i.find(".panel:visible").fadeOut(300, (function() {
                        i.find(e.attr("href")).fadeIn(300, (function() {
                            $(e.attr("href")).hasClass("product-tabs-masonry-2") && new Isotope(".product-tabs-masonry-2 .products")
                        }))
                    })), !1
                }))
            },
            _initShopLayout: function() {
                var t = this.productTabsShop;
                $(document.body).imagesLoaded((function() {
                    t.each((function() {
                        $(this).find("ul.products").isotope({
                            itemSelector: "li.product",
                            layoutMode: "masonry"
                        })
                    }))
                }))
            },
            _animationProduct: function() {
                var t = $(document.body).find(".un-shop-content .product-inner");
                t.removeAttr("data-sr-id").removeAttr("style"), window.sr = new ScrollReveal({
                    viewFactor: .15,
                    duration: 1e3,
                    scale: .9,
                    opacity: 1,
                    easing: "ease"
                }), sr.reveal(t, {
                    reset: !0,
                    viewOffset: {
                        top: 64
                    }
                })
            },
            onUnload: function() {
                this.$container.off(this.productTabsNamspace)
            }
        }), t
    }(), theme.unseroStaticBlockSection = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.unseroStaticBlockId = $("#shopify-section-" + i), this.unseroStaticBlock = $("#static-block-" + i), this.unseroStaticBlockNamspace = "#static-block-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                0 == this.unseroStaticBlockId.prev().length && ("1" == this.unseroStaticBlock.data("mix_header") ? $(document.body).addClass("mix-header") : $(document.body).removeClass("mix-header"))
            },
            onUnload: function() {
                this.$container.off(this.unseroStaticBlockNamspace)
            }
        }), t
    }(), theme.uneroTestimonial = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = this.sectionId = e.attr("data-section-id"),
                o = e.attr("data-section-type");
            this.uneroTestimonialId = $("#shopify-section-" + i), this.uneroTestimonial = $("#testimonial-" + i), this.uneroTestimonialNamspace = "#testimonial-" + i, this._init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _init: function() {
                this.uneroTestimonial.not(".slick-initialized").slick({
                    rtl: !1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplaySpeed: 5e3,
                    autoplay: !0,
                    infinite: !0,
                    lazyLoad: "ondemand",
                    prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                    nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
                    responsive: []
                })
            },
            onUnload: function() {
                this.$container.off(this.uneroTestimonialNamspace)
            }
        }), t
    }();
theme.YouTubeVideos = function() {
    function t(t) {
        return n[t.target.h.id]
    }

    function e() {
        $(".home_video_bg").each((function(t, e) {
            i($(e))
        }))
    }

    function i(t) {
        var e = t.closest(".home-video"),
            i = t,
            o = e.width(),
            a = e.height(),
            n = i.width(),
            s = i.height();
        o / r.ratio < s ? (n = Math.ceil(s * r.ratio), t.width(n).height(s).css({
            left: (o - n) / 2,
            top: 0
        })) : (s = Math.ceil(o / r.ratio), t.width(o).height(s).css({
            left: 0,
            top: (s - s) / 2
        })), e.height(s), t.addClass("home_video_loaded")
    }

    function o() {
        $(window).on("resize.videoPlayer", $.debounce(250, (function() {})))
    }
    var a = !1,
        n = {},
        s = [],
        r = {
            ratio: 16 / 9,
            playerVars: {
                modestbranding: 1,
                autoplay: 1,
                controls: 0,
                showinfo: 0,
                branding: 0,
                rel: 0,
                autohide: 1,
                cc_load_policy: 1,
                disablekb: 0,
                fs: 1,
                iv_load_policy: 3,
                start: 0,
                end: 0,
                loop: 1,
                rel: 0
            },
            events: {
                onReady: function(i) {
                    var o;
                    t(i).playerId.addClass("home_video_bg"), i.target.setPlaybackQuality("hd1080"), i.target.mute(), i.target.setLoop(!0), e()
                },
                onStateChange: function(e) {
                    var i = t(e);
                    switch (e.data) {
                        case 0:
                            s[i.id].seekTo(i.playerVars.start);
                            break;
                        case 1:
                            break;
                        case 2:
                    }
                }
            }
        };
    return {
        init: function(t) {
            if (t.id && (n[t.id] = {
                    id: t.id,
                    playerId: t.player_id,
                    videoId: t.video_id,
                    homeVideo: t.home_video,
                    videoSelector: t.id,
                    playerVars: t.playerDefaults
                }, !a)) {
                var e = document.createElement("script");
                e.src = "https://www.youtube.com/iframe_api";
                var i = document.getElementsByTagName("script")[0];
                i.parentNode.insertBefore(e, i)
            }
        },
        loadVideos: function() {
            for (var t in n)
                if (n.hasOwnProperty(t)) {
                    var i = $.extend({}, r, n[t]);
                    i.playerId.addClass("home_video_bg"), s[t] = new YT.Player(t, i)
                } e(), o(), a = !0
        },
        loadVideo: function(t) {
            if (a) {
                var e = $.extend({}, r, n[t]);
                s[t] = new YT.Player(t, e), o()
            }
        }
    }
}(), theme.uneroVideos = function() {
    function t(t) {
        var e = this.$container = $(t),
            i = this.sectionId = e.attr("data-section-id"),
            o = e.attr("data-section-type");
        this.videoId = $("#shopify-section-" + i), this.videoNamspace = "#home-video-" + i, this.VideoHomeId = $(this.videoNamspace), this.PlayerNamespace = "playerYoutube-" + i, this.PlayerId = $("#playerYoutube-" + i), this.VideoHomeWidth = $(this.videoNamspace + " .video_width"), this.options = {
            video_type: this.VideoHomeId.data("video_type")
        }, this.video_start = this.VideoHomeId.data("video_start");
        var a = this.VideoHomeId.data("video_duration");
        this.video_end = parseInt(this.video_start) + parseInt(a), "yt-video" == this.options.video_type && this._handleYoutubeVideo()
    }
    return t.prototype = _.assignIn({}, t.prototype, {
        _handleYoutubeVideo: function() {
            var t = {
                id: this.PlayerNamespace,
                video_id: this.PlayerId.data("video_id"),
                home_video: this.VideoHomeId,
                player_id: this.PlayerId,
                playerDefaults: {
                    modestbranding: 1,
                    autoplay: 1,
                    controls: 0,
                    showinfo: 0,
                    branding: 0,
                    rel: 0,
                    autohide: 1,
                    start: this.video_start,
                    end: this.video_end
                }
            };
            window.home_video_list[t.id] = t, theme.YouTubeVideos.init(t), theme.YouTubeVideos.loadVideo(t.id)
        },
        onUnload: function() {
            this.$container.off(this.videoNamspace)
        },
        onSelect: function() {},
        onBlockSelect: function() {},
        onBlockDeselect: function() {}
    }), t
}(), theme.uneroBrands = function() {
    function t(t) {
        var e = this.$container = $(t),
            i = this.sectionId = e.attr("data-section-id"),
            o = e.attr("data-section-type");
        this.brandsId = $("#brands-" + i), this.brands = $(".brands-" + i), this.featuredBrands = $(".featured-brands-" + i), this.brandsNamspace = "#brands-" + i, this._init()
    }
    return t.prototype = _.assignIn({}, t.prototype, {
        _init: function() {
            var t = this.featuredBrands.data("perview"),
                e = this.featuredBrands.data("autoplay"),
                i = this.featuredBrands.data("speed"),
                o = !1;
            "1" == e && (o = !0), this.featuredBrands.not(".slick-initialized").slick({
                rtl: !1,
                slidesToShow: t,
                slidesToScroll: 1,
                autoplaySpeed: i,
                autoplay: e,
                infinite: !0,
                lazyLoad: "ondemand",
                prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }]
            })
        },
        onUnload: function() {
            this.$container.off(this.brandsNamspace)
        }
    }), t
}(), theme.gridsSection = function() {
    function t(t) {
        var e = this.$container = $(t),
            i = this.sectionId = e.attr("data-section-id"),
            o = e.attr("data-section-type");
        this.gridsId = $("#grid-wrapper-" + i), this.grids = $("#grid-wrapper-" + i), this.gridsNamspace = "#grid-wrapper-" + i, this._init()
    }
    return t.prototype = _.assignIn({}, t.prototype, {
        _init: function() {
            var t = this.sectionId,
                e = function() {
                    function e(t) {
                        d.each((function() {
                            var e = $(this);
                            e.data("offsetTop", e.offset().top), t && e.data("height", e.height())
                        }))
                    }

                    function i() {
                        o(d), f.on("debouncedresize", (function() {
                            var t;
                            h = 0, p = -1, e(), a(), "undefined" != typeof $.data(this, "preview") && s()
                        }))
                    }

                    function o(t) {
                        t.on("click", "span.og-close", (function() {
                            return s(), !1
                        })).children("a").on("click", (function() {
                            var t = $(this).parent();
                            return u === t.index() ? s() : n(t), !1
                        }))
                    }

                    function a() {
                        c = {
                            width: f.width(),
                            height: f.height()
                        }
                    }

                    function n(t) {
                        var e = $.data(this, "preview"),
                            i = t.data("offsetTop");
                        if (h = 0, "undefined" != typeof e) {
                            if (p === i) return e.update(t), !1;
                            i > p && (h = e.height), s()
                        }
                        p = i, (e = $.data(this, "preview", new r(t))).open()
                    }

                    function s() {
                        var t;
                        u = -1, $.data(this, "preview").close(), $.removeData(this, "preview")
                    }

                    function r(t) {
                        this.$item = t, this.expandedIdx = this.$item.index(), this.create(), this.update()
                    }
                    var c, l = $("#og-grid-" + t),
                        d = l.children("li"),
                        u = -1,
                        p = -1,
                        h = 0,
                        m = 10,
                        f = $(window),
                        v = $("html, body"),
                        g = {
                            WebkitTransition: "webkitTransitionEnd",
                            MozTransition: "transitionend",
                            OTransition: "oTransitionEnd",
                            msTransition: "MSTransitionEnd",
                            transition: "transitionend"
                        } [Modernizr.prefixed("transition")],
                        y = Modernizr.csstransitions,
                        _ = {
                            minHeight: 500,
                            speed: 350,
                            easing: "ease"
                        };
                    return r.prototype = {
                        create: function() {
                            this.$title = $("<h3></h3>"), this.$description = $("<p></p>"), this.$href = $('<a class="button" href="#"><span></span></a>'), this.$details = $('<div class="og-details"></div>').append(this.$title, this.$description, this.$href), this.$loading = $('<div class="og-loading"></div>'), this.$fullimage = $('<div class="og-fullimg"></div>').append(this.$loading), this.$closePreview = $('<span class="og-close"></span>'), this.$previewInner = $('<div class="og-expander-inner"></div>').append(this.$closePreview, this.$fullimage, this.$details), this.$previewEl = $('<div class="og-expander"></div>').append(this.$previewInner), this.$item.append(this.getEl()), y && this.setTransition()
                        },
                        update: function(t) {
                            var e;
                            (t && (this.$item = t), -1 != u) && (d.eq(u).removeClass("og-expanded"), this.$item.addClass("og-expanded"), this.positionPreview());
                            u = this.$item.index();
                            var i = this.$item.children("a"),
                                o = {
                                    href: i.attr("href"),
                                    largesrc: i.data("largesrc"),
                                    title: i.data("title"),
                                    cta: i.data("cta"),
                                    description: i.data("description")
                                };
                            this.$title.html(o.title), this.$description.html(o.description), this.$href.html("<span>" + o.cta + "</span>"), this.$href.attr("href", o.href);
                            var a = this;
                            "undefined" != typeof a.$largeImg && a.$largeImg.remove(), a.$fullimage.is(":visible") && (this.$loading.show(), $("<img/>").load((function() {
                                var t = $(this);
                                t.attr("src") === a.$item.children("a").data("largesrc") && (a.$loading.hide(), a.$fullimage.find("img").remove(), a.$largeImg = t.fadeIn(350), a.$fullimage.append(a.$largeImg))
                            })).attr("src", o.largesrc))
                        },
                        open: function() {
                            setTimeout($.proxy((function() {
                                this.setHeights(), this.positionPreview()
                            }), this), 25)
                        },
                        close: function() {
                            var t = this,
                                e = function() {
                                    y && $(this).off(g), t.$item.removeClass("og-expanded"), t.$previewEl.remove()
                                };
                            return setTimeout($.proxy((function() {
                                "undefined" != typeof this.$largeImg && this.$largeImg.fadeOut("fast"), this.$previewEl.css("height", 0);
                                var t = d.eq(this.expandedIdx);
                                t.css("height", t.data("height")).on(g, e), y || e.call()
                            }), this), 25), !1
                        },
                        calcHeight: function() {
                            var t = c.height - this.$item.data("height") - m,
                                e = c.height;
                            t < _.minHeight && (t = _.minHeight, e = _.minHeight + this.$item.data("height") + m), this.height = t, this.itemHeight = e
                        },
                        setHeights: function() {
                            var t = this,
                                e = function() {
                                    y && t.$item.off(g), t.$item.addClass("og-expanded")
                                };
                            this.calcHeight(), this.$previewEl.css("height", this.height), this.$item.css("height", this.itemHeight).on(g, e), y || e.call()
                        },
                        positionPreview: function() {
                            var t = this.$item.data("offsetTop"),
                                e = this.$previewEl.offset().top - h,
                                i = this.height + this.$item.data("height") + m <= c.height ? t : this.height < c.height ? e - (c.height - this.height) : e;
                            v.animate({
                                scrollTop: i
                            }, _.speed)
                        },
                        setTransition: function() {
                            this.$previewEl.css("transition", "height " + _.speed + "ms " + _.easing), this.$item.css("transition", "height " + _.speed + "ms " + _.easing)
                        },
                        getEl: function() {
                            return this.$previewEl
                        }
                    }, {
                        init: function(t) {
                            _ = $.extend(!0, {}, _, t), l.imagesLoaded((function() {
                                e(!0), a(), i()
                            }))
                        },
                        addItems: function(t) {
                            d = d.add(t), t.each((function() {
                                var t = $(this);
                                t.data({
                                    offsetTop: t.offset().top,
                                    height: t.height()
                                })
                            })), o(t)
                        }
                    }
                }();
            $((function() {
                e.init()
            }))
        },
        onUnload: function() {
            this.$container.off(this.gridsNamspace)
        }
    }), t
}(), theme.CollectionCarouselTemplate = function() {
    function t(t) {
        var e = this.$container = $(t),
            i = this.sectionId = e.attr("data-section-id"),
            o = e.attr("data-section-type");
        this.CollectionId = $("#collection-" + i), this.Collection = $("#collection-" + i), this.CollectionNamspace = "#collection-" + i, this.carouselSlide = $(".unero-products-carousel-" + i), this._init()
    }
    return t.prototype = _.assignIn({}, t.prototype, {
        _init: function() {
            0 < this.carouselSlide.length && this.carouselSlide.each((function() {
                var t = $(this),
                    e = $(this).data("per_view"),
                    i = $(this).data("autoplay"),
                    o = $(this).data("speed"),
                    a = !1;
                "1" == i && (a = !0), t.find(".unero-products-carousel-slide").not(".slick-initialized").slick({
                    rtl: !1,
                    slidesToShow: e,
                    slidesToScroll: 1,
                    autoplaySpeed: o,
                    autoplay: i,
                    infinite: a,
                    lazyLoad: "ondemand",
                    prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                    nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
                    responsive: [{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }]
                })
            }))
        },
        onUnload: function() {
            this.$container.off(this.CollectionNamspace)
        }
    }), t
}(), theme.ProductVariantMobile = function() {
    function t(t) {
        var e = this.$container = $(t),
            i = this.sectionId = e.attr("data-section-id"),
            o = e.attr("data-section-type");
        this.wrapperId = $("#" + i), this.wrapper = $("#" + i), this.wrapperNamspace = "#" + i, this.addCartId = $("#btn-" + i + ".m-allow-cart"), this.addCartClass = $(".variant-item-" + i + ".m-allow-cart"), this._init()
    }
    return t.prototype = _.assignIn({}, t.prototype, {
        _init: function() {
            var t = this;
            t._initCompact(), t._initEvents(), $(window).resize((function() {
                767 >= $(window).width() && t._initCompact()
            }))
        },
        _initCompact: function() {
            if (0 < $(".product-variant-mobile-section").length) {
                var t = $(".product-variant-mobile-section"),
                    e = $(".product-variants-mobile");
                e.each((function() {
                    var t = $(this),
                        e = t.find(".variants-header"),
                        i = e.innerHeight(),
                        o = t.find(".variants-content").outerHeight(),
                        a = e.closest(".product-variants-mobile");
                    e.data("height", i), t.data("height", i + o)
                })), e.each((function() {
                    var t = $(this),
                        e = t.find(".variants-header"),
                        i = e.innerHeight(),
                        o = t.find(".variants-content").outerHeight(),
                        a = e.closest(".product-variants-mobile");
                    e.data("height", i), t.data("height", i + o), a.hasClass("active") && a.height(a.data("height"))
                })), t.unbind("click") && t.on("click", ".variants-header .title", (function() {
                    var t = $(this),
                        i = t.closest(".variants-header"),
                        o = t.closest(".product-variants-mobile");
                    o.hasClass("active") || e.closest(".active").removeClass("active").height(t.data("height")), o.toggleClass("active"), o.hasClass("active") ? o.height(o.data("height")) : o.height(i.data("height"))
                }))
            }
        },
        _initEvents: function() {
            var t = $("#ProductSelect-product-template.variation-select").val();
            0 < this.addCartId.length && (this.addCartId.unbind("click"), this.addCartId.on("click", (function() {
                $("#ProductSelect-product-template.variation-select").val(t), $("#AddToCart-product-template").trigger("click")
            }))), 0 < this.addCartClass.length && (this.addCartClass.unbind("click"), this.addCartClass.on("click", (function() {
                var t = $(this).data("id");
                $("#ProductSelect-product-template.variation-select").val(t), $("#AddToCart-product-template").trigger("click")
            })))
        },
        onUnload: function() {
            this.$container.off(this.wrapperNamspace)
        }
    }), t
}(), $(document).ready((function() {
    var t = new theme.Sections;
    t.register("product-template", theme.Product), t.register("product-template-variant", theme.Product), t.register("product-variant-mobile", theme.ProductVariantMobile), t.register("cart-template", theme.Cart), t.register("search-template", theme.SearchTemplate), t.register("blog-template", theme.BlogTemplate), t.register("article-template", theme.ArticleTemplate), t.register("collection-template", theme.CollectionTemplate), t.register("collection-carousel-template", theme.CollectionCarouselTemplate), t.register("collections-template", theme.CollectionsTemplate), t.register("portfolio-masonry-template", theme.portfolioMasonry), t.register("collection-instagram-template", theme.CollectionInstagramTemplate), t.register("faqs-template", theme.faqsTemplate), t.register("contact-template", theme.Maps), t.register("about-template", theme.aboutTemplate), t.register("footer-section", theme.footerSection), t.register("menu-sidebar-section", theme.sideBarSection), t.register("mobile-nav-section", theme.mobileNavSection), t.register("header-section", theme.HeaderSection), t.register("totop-section", theme.toTopSection), t.register("header-slider", theme.SliderSection), t.register("unero-slider-section", theme.uneroSliderSection), t.register("unero-hero-slider-section", theme.uneroHeroSliderSection), t.register("unero-collections-section", theme.uneroCollectionsSection), t.register("unero-collections-masonry-section", theme.uneroCollectionsMasonrySection), t.register("unero-featured-collections-section", theme.uneroProductsCarouselSection), t.register("unero-product-tabs-section", theme.uneroProductTabsSection), t.register("unero-about-section", theme.uneroAboutSection), t.register("unero-banner-grid-section", theme.uneroBannerSection), t.register("unero-banner-metro-section", theme.uneroBannerMetroSection), t.register("unero-instagram-section", theme.uneroInstagramSection), t.register("unero-blog-section", theme.unseroBlogSection), t.register("unero-newsletter-section", theme.unseroNewsletterSection), t.register("unero-static-block", theme.unseroStaticBlockSection), t.register("unero-testimonial-section", theme.uneroTestimonial), t.register("unero-video-section", theme.uneroVideos), t.register("unero-brand-section", theme.uneroBrands), t.register("slideshow-section", theme.SlideshowSection), t.register("products", theme.Products), t.register("blog", theme.Blog), t.register("collections", theme.Collections), t.register("grid-view", theme.gridsSection)
})), window.theme = theme || {}, theme.roarApplication = function() {
    function t() {
        "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
    }

    function e() {
        $.ajax({
            url: "/search",
            beforeSend: function() {
                $("#cart-panel").addClass("loading")
            },
            success: function(t) {
                var e = "#icon-cart-contents .mini-cart-counter",
                    i = "div#cart-panel";
                $(e).html($(t).find(e).html()), $(i).html($(t).filter(i).html()), theme.CurrencyPicker.convert("#cart-panel .money")
            },
            error: function(t) {
                console.log(t)
            }
        }).done((function() {
            $("#cart-panel").removeClass("loading")
        }))
    }

    function i() {
        0 < $(".add_to_cart_variant_button").length && $(".add_to_cart_variant_button").unbind("click"), $(document).on("click", ".add_to_cart_variant_button", (function() {
            var t = $(this);
            return t.hasClass("disabled") ? alert(theme.strings.alert_variant) : (Shopify.queue = [], jQuery(".qty-variant").each((function() {
                Shopify.queue.push({
                    variantId: jQuery(this).data("variant_id"),
                    quantity: parseInt(jQuery(this).val(), 10) || 0
                })
            })), Shopify.moveAlong = function() {
                if (Shopify.queue.length) var i = Shopify.queue.shift(),
                    o = $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        async: !0,
                        cache: !1,
                        data: {
                            quantity: i.quantity,
                            id: i.variantId
                        },
                        dataType: "json",
                        beforeSend: function() {
                            t.addClass("loading")
                        },
                        complete: function() {
                            e()
                        },
                        error: function(t) {
                            var e = $.parseJSON(t.responseText),
                                i = e.message + ": " + e.description;
                            alert(i)
                        },
                        success: function() {
                            Shopify.moveAlong()
                        }
                    });
                else "" == theme.cart_ajax ? window.location.href = "/cart" : (t.removeClass("loading"), r(), $(document.body).toggleClass("display-cart"), w($("#cart-panel")))
            }, Shopify.moveAlong()), !1
        }))
    }

    function o() {
        $(document).on("click", ".custom-quantity .increase", (function() {
            var t = $(this);
            var i = $(this).closest(".custom-quantity").find("input");
            var o = parseInt(i.val());
            var a = parseInt(i.attr("max"));
            if (o >= a) return alert("Apologies, we currently have " + a + " left in stock."), !1;
            $(".mini-cart-counter-circle").addClass("pulsating-cart"), t.addClass("ajax-disabled"), t.css("opacity", "0.3");
            var n = parseInt(i.val()) + 1;
            var s = i.data("variant_id");
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + n + "&id=" + s,
                dataType: "json",
                async: !1,
                beforeSend: function() {
                    console.log("addingco"), i.val(n)
                },
                success: function(o) {
                    console.log(o), e(), i.val(n), $(".qty-variant-" + s).val(n), setTimeout((function() {
                        $(".mini-cart-counter-circle").removeClass("pulsating-cart"), t.removeClass("disabled")
                    }), 1e3), setTimeout((function() {
                        t.removeClass("ajax-disabled"), t.css("opacity", "1")
                    }), 500)
                },
                error: function(e, i) {
                    t.removeClass("disabled"), Shopify.onError(e, i), console.log("error")
                }
            })
        })), $(document).on("click", ".custom-quantity .decrease", (function() {
            var t = $(this);
            t.addClass("ajax-disabled"), t.css("opacity", "0.3"), $(".mini-cart-counter-circle").addClass("pulsating-cart");
            var i = $(this).closest(".custom-quantity").find("input");
            var o = parseInt(i.val()) - 1;
            var a = i.data("variant_id");
            var n = $(this).closest(".add-to-cart-custom");
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + o + "&id=" + a,
                dataType: "json",
                async: !1,
                beforeSend: function() {
                    console.log("reducing"), o > 0 && i.val(o)
                },
                success: function() {
                    e(), setTimeout((function() {
                        $(".mini-cart-counter-circle").removeClass("pulsating-cart"), $(".qty-variant-" + a).val(o), o < 1 && (n.find(".custom-cart-form").removeClass("hide"), n.find(".custom-quantity").addClass("hide"), n.find(".custom-quantity").parent().parent().removeClass("pro_img_bg"), $(".custom-quantity-" + a).addClass("hide"), $(".custom-cart-form-" + a).removeClass("hide"), $(".overlay-" + a).removeClass("pro_img_bg")), t.removeClass("disabled")
                    }), 500), setTimeout((function() {
                        t.removeClass("ajax-disabled"), t.css("opacity", "1")
                    }), 500)
                },
                error: function(e, i) {
                    t.removeClass("disabled"), Shopify.onError(e, i)
                }
            })
        })), $(document).on("keyup", ".add-to-cart-custom .qty-variant", (function() {
            var t = $(this);
            var i = $(this).closest(".custom-quantity").find("input");
            var o = parseInt(i.val());
            var a = parseInt(i.attr("max"));
            if (o > a) return alert("Apologies, we currently have " + a + " left in stock."), jQuery.getJSON("/cart.js", (function(t) {
                for (var e in t.items) t.items[e].id == i.data("variant_id") && i.val(t.items[e].quantity)
            })), !1;
            if ("" != i.val()) {
                $(".mini-cart-counter-circle").addClass("pulsating-cart");
                var n = parseInt(i.val());
                0 == n && ($(this).closest(".custom-quantity").siblings(".custom-cart-form").removeClass("hide"), $(this).closest(".custom-quantity").addClass("hide"), $(this).closest(".product-images").removeClass("pro_img_bg"));
                var s = i.data("variant_id");
                $.ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    data: "quantity=" + n + "&id=" + s,
                    dataType: "json",
                    async: !1,
                    beforeSend: function() {
                        i.val(n)
                    },
                    success: function(o) {
                        console.log(o), e(), i.val(n), setTimeout((function() {
                            $(".mini-cart-counter-circle").removeClass("pulsating-cart"), t.removeClass("disabled")
                        }), 1e3)
                    },
                    error: function(e, i) {
                        t.removeClass("disabled"), Shopify.onError(e, i), console.log("error")
                    }
                })
            }
        })), $(document).on("click", ".add_to_cart_button", (function() {
            var t = $(this),
                i = t.closest("form");
            var o = i.find('input[name="id"]').val();
            return console.log("entered Ajax"), $(".mini-cart-counter-circle").addClass("pulsating-cart"), "" == theme.cart_ajax ? (i.submit(), !1) : ($.ajax({
                type: "POST",
                url: "/cart/add.js",
                async: !0,
                cache: !1,
                data: i.serialize(),
                dataType: "json",
                beforeSend: function() {
                    t.addClass("loading")
                },
                complete: function() {
                    e()
                },
                error: function(e) {
                    var i = $.parseJSON(e.responseText),
                        o = i.message + ": " + i.description;
                    t.removeClass("loading"), alert(o)
                },
                success: function() {
                    t.closest(".add-to-cart-custom").find(".qty-variant").val("1"), t.hasClass("custom-add-to-cart") && (t.closest(".custom-cart-form").addClass("hide"), t.closest(".add-to-cart-custom").find(".custom-quantity").removeClass("hide"), t.closest(".add-to-cart-custom").find(".custom-quantity").parent().parent().addClass("pro_img_bg"), $(".custom-quantity-" + o).removeClass("hide"), $(".custom-cart-form-" + o).addClass("hide"), $(".overlay-" + o).addClass("pro_img_bg"), console.log("xxx"))
                }
            }).done((function() {
                t.removeClass("loading"), r(), setTimeout((function() {
                    $(".mini-cart-counter-circle").removeClass("pulsating-cart")
                }), 2e3)
            })), !1)
        })), $(document).on("click", ".add_to_cart_button_product", (function() {
            var t = $(this),
                i = t.closest("form");
            var o;
            console.log("Ajaxing Product to Cart");
            var a = $(this).closest(".variations_button").find("input").attr("data-variant_id");
            var n = 1;
            var s = event.keyCode ? event.keyCode : event.which;
            return $(".mini-cart-counter-circle").addClass("pulsating-cart"), "" == theme.cart_ajax ? (i.submit(), !1) : ($.ajax({
                type: "POST",
                url: "/cart/add.js",
                async: !0,
                cache: !1,
                data: i.serialize(),
                dataType: "json",
                beforeSend: function() {
                    t.addClass("loading")
                },
                complete: function() {
                    e()
                },
                error: function(e) {
                    var i = $.parseJSON(e.responseText),
                        o = i.message + ": " + i.description;
                    t.removeClass("loading"), alert(o)
                },
                success: function() {
                    var t = $(".products .product-inner .custom-quantity").find("[data-variant_id='" + a + "'].qty-variant");
                    t.closest(".add-to-cart-custom").find(".custom-cart-form").addClass("hide"), t.closest(".add-to-cart-custom").find(".custom-quantity").removeClass("hide"), t.closest(".product-images").addClass("pro_img_bg"), t.closest(".add-to-cart-custom").find(".qty-variant").val(n)
                }
            }).done((function() {
                t.removeClass("loading"), r(), t.closest(".variations_button").find(".quantity").removeClass("hide"), t.closest(".variations_button").find(".single-add-to-cart-btn").addClass("hide"), setTimeout((function() {
                    $(".mini-cart-counter-circle").removeClass("pulsating-cart")
                }), 100)
            })), !1)
        })),


        /* Direct copy of the above, but with boost class and as selector under body as its replaced frequently and click event would be lost  */
        $(document).on("click", ".boost-pfs-addtocart-btnXXXX", (function() {
            var t = $(this),
                i = t.closest("form");
            var o;
            var productItem = $(this);
            console.log("Ajaxing Boost Product to Cart");
            var a = $(this).closest(".variations_button").find("input").attr("data-variant_id");
            var n = 1;
            var s = event.keyCode ? event.keyCode : event.which;
            return $(".mini-cart-counter-circle").addClass("pulsating-cart"), "" == theme.cart_ajax ? (i.submit(), !1) : ($.ajax({
                type: "POST",
                url: "/cart/add.js",
                async: !0,
                cache: !1,
                data: i.serialize(),
                dataType: "json",
                beforeSend: function() {
                    t.addClass("loading"),
                    productItem.parents('.boost-pfs-filter-product-item').addClass('boost-pfs-adding');
                    productItem.find('.boost-pfs-addtocart-btn-text').text('Adding...')
                },
                complete: function() {
                    e()
                },
                error: function(e) {
                    var i = $.parseJSON(e.responseText),
                        o = i.message + ": " + i.description;
                    t.removeClass("loading"), alert(o)
                },
                success: function() {
                  	
                    productItem.find('.boost-pfs-addtocart-btn-text').text('Added');
                    setTimeout((function() {
                        productItem.find('.boost-pfs-addtocart-btn-text').text('Add To Parcel')
                    }), 1000)
                    setTimeout((function() {
                        productItem.parents('.boost-pfs-filter-product-item').addClass('boost-pfs-added');
                        productItem.parents('.boost-pfs-filter-product-item').removeClass('boost-pfs-adding');
                    }), 1000)

                    
                    var t = $(".products .product-inner .custom-quantity").find("[data-variant_id='" + a + "'].qty-variant");
                    t.closest(".add-to-cart-custom").find(".custom-cart-form").addClass("hide"), t.closest(".add-to-cart-custom").find(".custom-quantity").removeClass("hide"), t.closest(".product-images").addClass("pro_img_bg"), t.closest(".add-to-cart-custom").find(".qty-variant").val(n)
                }
            }).done((function() {
                t.removeClass("loading"), r(), t.closest(".variations_button").find(".quantity").removeClass("hide"), t.closest(".variations_button").find(".single-add-to-cart-btn").addClass("hide"), 
                setTimeout((function() {
                    $(".mini-cart-counter-circle").removeClass("pulsating-cart")
                }), 100)

                if (this.cart) {
                formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
                }


            })), !1)
        })), 

        /* $(document).on("click", ".boost-pfs-addtocart-custom-quantity .increase", (function() {
            var t = $(this);
            var i = $(this).closest(".boost-pfs-addtocart-custom-quantity").find("input");
            var o = parseInt(i.val());
            var a = parseInt(i.attr("max"));
            if (o >= a) return alert("Apologies, we currently have " + a + " left in stock."), !1;
            $(".mini-cart-counter-circle").addClass("pulsating-cart"), t.addClass("ajax-disabled"), t.css("opacity", "0.3");
            var n = parseInt(i.val()) + 1;
            var s = t.parents('.boost-pfs-addtocart-product-form').find("input[name=\"id\"]").val();
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + n + "&id=" + s,
                dataType: "json",
                async: !1,
                beforeSend: function() {
                    console.log("addingco"), i.val(n)
                },
                success: function(o) {
                    console.log(o), e(), i.val(n), $(".qty-variant-" + s).val(n), setTimeout((function() {
                        $(".mini-cart-counter-circle").removeClass("pulsating-cart"), t.removeClass("disabled")
                    }), 1e3), setTimeout((function() {
                        t.removeClass("ajax-disabled"), t.css("opacity", "1")
                    }), 500)
                },
                error: function(e, i) {
                    t.removeClass("disabled"), Shopify.onError(e, i), console.log("error")
                }
            })
        })),
          
        $(document).on("click", ".boost-pfs-addtocart-custom-quantity .decrease", (function() {
            var t = $(this);
            t.addClass("ajax-disabled"), t.css("opacity", "0.3"), $(".mini-cart-counter-circle").addClass("pulsating-cart");
            var i = $(this).closest(".boost-pfs-addtocart-custom-quantity").find("input");
            var o = parseInt(i.val()) - 1;
            var a = t.parents('.boost-pfs-addtocart-product-form').find("input[name=\"id\"]").val();
            var n = $(this).closest(".add-to-cart-custom");
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + o + "&id=" + a,
                dataType: "json",
                async: !1,
                beforeSend: function() {
                    console.log("reducing"), o > 0 && i.val(o)
                },
                success: function() {
                    e(), setTimeout((function() {
                        $(".mini-cart-counter-circle").removeClass("pulsating-cart"), $(".qty-variant-" + a).val(o), o < 1 && (n.find(".custom-cart-form").removeClass("hide"), n.find(".custom-quantity").addClass("hide"), n.find(".custom-quantity").parent().parent().removeClass("pro_img_bg"), $(".custom-quantity-" + a).addClass("hide"), $(".custom-cart-form-" + a).removeClass("hide"), $(".overlay-" + a).removeClass("pro_img_bg")), t.removeClass("disabled")
                    }), 500), setTimeout((function() {
                        t.removeClass("ajax-disabled"), t.css("opacity", "1")
                        
                        
                    }), 500),
                    o==0 && (t.parents('.boost-pfs-filter-product-item').removeClass('boost-pfs-added'))
                    
                    
                },
                error: function(e, i) {
                    t.removeClass("disabled"), Shopify.onError(e, i)
                }
            })
        })), */

 
        

        
        
        
        
        
        
        
        
        $(document).on("click", ".product-summary .quantity .increase", (function() {
            var t = $(this);
            var i = $(this).closest(".quantity").find("input");
            var o = parseInt(i.val());
            var a = parseInt(i.attr("max"));
            if (o >= a) return alert("Apologies, we currently have " + a + " left in stock."), !1;
            t.addClass("ajax-disabled"), t.css("opacity", "0.3"), $(".mini-cart-counter-circle").addClass("pulsating-cart");
            var n = parseInt(i.val()) + 1;
            var s = i.data("variant_id");
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + n + "&id=" + s,
                dataType: "json",
                async: !1,
                beforeSend: function() {
                    console.log("addingco"), i.val(n)
                },
                success: function() {
                    var i;
                    e(), setTimeout((function() {
                        $(".mini-cart-counter-circle").removeClass("pulsating-cart")
                    }), 500), $(".products .product-inner .custom-quantity").find("[data-variant_id='" + s + "'].qty-variant").closest(".add-to-cart-custom").find(".qty-variant").val(n), t.removeClass("disabled"), setTimeout((function() {
                        t.removeClass("ajax-disabled"), t.css("opacity", "1")
                    }), 500)
                },
                error: function(e, i) {
                    t.removeClass("disabled"), Shopify.onError(e, i), console.log("error")
                }
            })
        })), $(document).on("click", ".product-summary .quantity .decrease", (function() {
            $(".mini-cart-counter-circle").addClass("pulsating-cart");
            var t = $(this);
            t.addClass("ajax-disabled"), t.css("opacity", "0.3");
            var i = t.closest(".quantity").find("input");
            var o = parseInt(i.val()) - 1;
            var a = i.data("variant_id");
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + o + "&id=" + a,
                dataType: "json",
                async: !1,
                beforeSend: function() {
                    console.log("reducing"), o > 0 && i.val(o)
                },
                success: function() {
                    e(), setTimeout((function() {
                        $(".mini-cart-counter-circle").removeClass("pulsating-cart");
                        var e = $(".products .product-inner .custom-quantity").find("[data-variant_id='" + a + "'].qty-variant");
                        o < 1 ? (t.closest(".variations_button").find(".quantity").addClass("hide"), t.closest(".variations_button").find(".single-add-to-cart-btn").removeClass("hide"), e.closest(".add-to-cart-custom").find(".custom-cart-form").removeClass("hide"), e.closest(".add-to-cart-custom").find(".custom-quantity").addClass("hide"), e.closest(".product-images").removeClass("pro_img_bg")) : e.closest(".add-to-cart-custom").find(".qty-variant").val(o)
                    }), 100), t.removeClass("disabled"), setTimeout((function() {
                        t.removeClass("ajax-disabled"), t.css("opacity", "1")
                    }), 500)
                },
                error: function(e, i) {
                    t.removeClass("disabled"), Shopify.onError(e, i)
                }
            })
        })), $(document).on("keyup", ".product-summary .quantity .input-text.qty", (function() {
            var t = $(this);
            var i = $(this).closest(".quantity").find("input");
            var o = parseInt(i.val());
            var a = parseInt(i.attr("max"));
            if (o > a) return alert("Apologies, we currently have " + a + " left in stock."), jQuery.getJSON("/cart.js", (function(t) {
                for (var e in t.items) t.items[e].id == i.data("variant_id") && i.val(t.items[e].quantity)
            })), !1;
            if ("" != i.val()) {
                $(".mini-cart-counter-circle").addClass("pulsating-cart");
                var n = parseInt(i.val());
                0 == n && ($(".variations_button .quantity").addClass("hide"), $(".single-add-to-cart-btn").removeClass("hide"), $(".variations_button .input-text.qty").val(1));
                var s = i.data("variant_id");
                $.ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    data: "quantity=" + n + "&id=" + s,
                    dataType: "json",
                    async: !1,
                    beforeSend: function() {
                        console.log("addingco")
                    },
                    success: function() {
                        var i;
                        e(), setTimeout((function() {
                            $(".mini-cart-counter-circle").removeClass("pulsating-cart")
                        }), 500), $(".products .product-inner .custom-quantity").find("[data-variant_id='" + s + "'].qty-variant").closest(".add-to-cart-custom").find(".qty-variant").val(n), t.removeClass("disabled")
                    },
                    error: function(e, i) {
                        t.removeClass("disabled"), Shopify.onError(e, i), console.log("error")
                    }
                })
            }
        })), $(document).on("keyup", ".rt-unero table.shop_table tbody td .quantity .qty", (function() {
            var t = $(this),
                i = t.val(),
                o = t.attr("data-id");
            var a = parseInt(i);
            var n = parseInt(t.attr("max"));
            if (a > n) return alert("Apologies, we currently have " + n + " left in stock."), jQuery.getJSON("/cart.js", (function(e) {
                for (var i in e.items) e.items[i].id == o && t.val(e.items[i].quantity)
            })), !1;
            "" != i && ($(".mini-cart-counter-circle").addClass("pulsating-cart"), t.addClass("ajax-disabled"), $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + i + "&id=" + o,
                dataType: "json",
                beforeSend: function() {
                    $(".cart-tload").addClass("loadin"), $("#sl_" + o).closest("td").addClass("loadin")
                },
                complete: function() {
                    e()
                },
                success: function() {
                    function e(t) {
                        return t.items.forEach((function(t) {
                            $.ajax({
                                url: "/products/" + t.handle + ".js",
                                dataType: "json",
                                async: 0,
                                success: function(e) {
                                    e.variants.forEach((function(e) {
                                        null != e.compare_at_price && e.id == t.variant_id ? t["compare_at_price"] = e.compare_at_price : t["compare_at_price"] = 0
                                    }))
                                }
                            })
                        })), t
                    }
                    jQuery.getJSON("/cart.js", (function(t) {
                        $(".cart-subtotal .money").html("$" + (t.total_price / 100).toFixed(2));
                        var i = 0;
                        for (var o in (t = e(t)).items)
                            if (t.items[o].compare_at_price > t.items[o].price) {
                                var a = "#psub_" + t.items[o].variant_id;
                                var n = t.items[o].price * t.items[o].quantity;
                                $(a).html("$" + (n / 100).toFixed(2)), i += (t.items[o].compare_at_price - t.items[o].price) * t.items[o].quantity
                            } console.log((i / 100).toFixed(2)), $(".cart-savings .money").html("$" + (i / 100).toFixed(2))
                    })), t.val() < 1 && t.parent().parent().parent().remove(), setTimeout((function() {
                        $(".cart-tload").removeClass("loadin"), $("#sl_" + o).closest("td").removeClass("loadin")
                    }), 500), setTimeout((function() {
                        $(".mini-cart-counter-circle").removeClass("pulsating-cart")
                    }), 2e3), setTimeout((function() {
                        t.removeClass("ajax-disabled"), t.css("opacity", "1")
                    }), 500)
                },
                error: function(t, e) {
                    Shopify.onError(t, e)
                }
            }))
        }))
    }

    function a() {
        function t(t) {
            return t.items.forEach((function(t) {
                $.ajax({
                    url: "/products/" + t.handle + ".js",
                    dataType: "json",
                    async: 0,
                    success: function(e) {
                        e.variants.forEach((function(e) {
                            null != e.compare_at_price && e.id == t.variant_id ? t["compare_at_price"] = e.compare_at_price : t["compare_at_price"] = 0
                        }))
                    }
                })
            })), t
        }
        $(document).on("focus", "#cart-panel .update", (function() {
            $(this).select()
        })).on("blur", "#cart-panel .update", (function() {
            var i = $(this),
                o = i.val(),
                a = i.attr("data-id");
            $(".icon_plus.q_up, .q_down").addClass("ajax-disabled"), $(".icon_plus.q_up, .q_down").css("opacity", "0.3"), $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + o + "&id=" + a,
                dataType: "json",
                beforeSend: function() {
                    $("#cart-panel").addClass("loading"), i.closest("li").find(".singleLoad").addClass("loadon")
                },
                success: function(n) {
                    var s;
                    0 == n["item_count"] && ($("#cart-cart-template form.shopping-cart").remove(), $("#cart-cart-template .rt-unero").html("<div class='empty'><p>No items in your parcel.</p></div>")), e(), setTimeout((function() {
                        $("#cart-panel").removeClass("loading"), $("#cart-panel .singleLoad").removeClass("loadon"), $(".mini-cart-counter-circle").removeClass("pulsating-cart");
                        var e = $(".product-summary .quantity .qty").data("variant_id");
                        var i = $(".products .product-inner .custom-quantity").find("[data-variant_id='" + a + "'].qty-variant");
                        var n = o;
                        0 == n && (n = 1, $(".products .product-inner .custom-quantity").find('[data-variant_id="' + a + '"]').parent().parent().addClass("hide"), $(".products .product-inner .custom-quantity").find('[data-variant_id="' + a + '"]').parent().removeClass("hide"), $(".products .product-inner .custom-quantity").find('[data-variant_id="' + a + '"]').parents().removeClass("pro_img_bg"), $(".products .product-inner .custom-quantity").find('[data-variant_id="' + a + '"]').parent().parent().parent().find(".custom-cart-form").removeClass("hide"), $(".shopping-cart .cart_item[data-id=" + a + "]").remove(), e == a && ($(".product-summary .quantity").addClass("hide"), $(".single-add-to-cart-btn").removeClass("hide"))), i.val(n), e == a && $(".product-summary .quantity .qty").val(n), $(".cart_item .product-quantity input.qty-" + a).val(n), jQuery.getJSON("/cart.js", (function(e) {
                            $(".cart-subtotal .money").html("$" + (e.total_price / 100).toFixed(2));
                            var i = 0;
                            for (var o in (e = t(e)).items)
                                if (e.items[o].compare_at_price > e.items[o].price) {
                                    var a = "#psub_" + e.items[o].variant_id;
                                    var n = e.items[o].price * e.items[o].quantity;
                                    $(a).html("$" + (n / 100).toFixed(2)), i += (e.items[o].compare_at_price - e.items[o].price) * e.items[o].quantity
                                } $(".cart-savings .money").html("$" + (i / 100).toFixed(2))
                        }))
                    }), 1e3), i.closest(".quantity-number").find("span").removeClass("disabled"), setTimeout((function() {
                        $(".icon_plus.q_up, .q_down").addClass("ajax-disabled"), $(".icon_plus.q_up, .q_down").css("opacity", "1")
                    }), 500)
                },
                error: function(t, e) {
                    i.closest(".quantity-number").find("span").removeClass("disabled"), Shopify.onError(t, e)
                }
            })
        })), $(document).on("click", "#cart-cart-template .cart_item .q_up", (function() {
            var i = $(this),
                o = i.closest("div").find(".qty").val(),
                a = i.attr("data-product_id");
            var n = parseInt(o);
            var s = parseInt(i.closest("div").find(".qty").attr("max"));
            if (n > s) return alert("Apologies, we currently have " + s + " left in stock."), i.closest("div").find(".qty").val(parseInt(o) - 1), !1;
            $(".mini-cart-counter-circle").addClass("pulsating-cart"), $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + o + "&id=" + a,
                dataType: "json",
                beforeSend: function() {
                    $(".cart-tload").addClass("loadin"), $("#sl_" + a).closest("td").addClass("loadin")
                },
                success: function() {
                    i.val() < 1 && e(), jQuery.getJSON("/cart.js", (function(e) {
                        $(".cart-subtotal .money").html("$" + (e.total_price / 100).toFixed(2));
                        var i = 0;
                        for (var o in (e = t(e)).items)
                            if (e.items[o].compare_at_price > e.items[o].price) {
                                var a = "#psub_" + e.items[o].variant_id;
                                var n = e.items[o].price * e.items[o].quantity;
                                $(a).html("$" + (n / 100).toFixed(2)), i += (e.items[o].compare_at_price - e.items[o].price) * e.items[o].quantity
                            } $(".cart-savings .money").html("$" + (i / 100).toFixed(2))
                    })), setTimeout((function() {
                        $(".cart-tload").removeClass("loadin"), $("#sl_" + a).closest("td").removeClass("loadin")
                    }), 500), setTimeout((function() {
                        $(".mini-cart-counter-circle").removeClass("pulsating-cart")
                    }), 2e3)
                },
                error: function(t, e) {
                    Shopify.onError(t, e)
                }
            })
        })), $(document).on("click", "#cart-cart-template .cart_item .q_down", (function() {
            $(".mini-cart-counter-circle").addClass("pulsating-cart");
            var i = $(this),
                o = i.closest("div").find(".qty").val(),
                a = i.attr("data-product_id");
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + o + "&id=" + a,
                dataType: "json",
                beforeSend: function() {
                    $(".cart-tload").addClass("loadin"), $("#sl_" + a).closest("td").addClass("loadin")
                },
                success: function() {
                    jQuery.getJSON("/cart.js", (function(e) {
                        $(".cart-subtotal .money").html("$" + (e.total_price / 100).toFixed(2));
                        var i = 0;
                        for (var o in (e = t(e)).items)
                            if (e.items[o].compare_at_price > e.items[o].price) {
                                var a = "#psub_" + e.items[o].variant_id;
                                var n = e.items[o].price * e.items[o].quantity;
                                $(a).html("$" + (n / 100).toFixed(2)), i += (e.items[o].compare_at_price - e.items[o].price) * e.items[o].quantity
                            } $(".cart-savings .money").html("$" + (i / 100).toFixed(2))
                    })), o < 1 && (i.parent().parent().parent().remove(), e()), setTimeout((function() {
                        $(".cart-tload").removeClass("loadin"), $("#sl_" + a).closest("td").removeClass("loadin")
                    }), 500), setTimeout((function() {
                        $(".mini-cart-counter-circle").removeClass("pulsating-cart")
                    }), 2e3)
                },
                error: function(t, e) {
                    Shopify.onError(t, e)
                }
            })
        }))
    }

    function n() {
        $(document).on("click", "#cart-panel .remove", (function(t) {
            t.preventDefault();
            var i = $(this),
                o = i.attr("data-id");
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=0&id=" + o,
                dataType: "json",
                beforeSend: function() {
                    i.closest("#cart-panel").addClass("loading"), i.closest("li").find(".singleLoad").addClass("loadon")
                },
                success: function(t) {
                    var i;
                    e(), 0 == t["item_count"] && ($("#cart-cart-template form.shopping-cart").remove(), $("#cart-cart-template .rt-unero").html("<div class='empty'><p>No items in your parcel.</p></div>")), jQuery.getJSON("/cart.js", (function(t) {
                        $(".cart-subtotal .money").html("$" + (t.total_price / 100).toFixed(2));
                        var e = 0;
                        for (var i in (t = addCompareAtPrice(t)).items)
                            if (t.items[i].compare_at_price > t.items[i].price) {
                                var o = "#psub_" + t.items[i].variant_id;
                                var a = t.items[i].price * t.items[i].quantity;
                                $(o).html("$" + (a / 100).toFixed(2)), e += (t.items[i].compare_at_price - t.items[i].price) * t.items[i].quantity
                            } $(".cart-savings .money").html("$" + (e / 100).toFixed(2))
                    })), setTimeout((function() {
                        var t;
                        $("#cart-panel .singleLoad").removeClass("loadon"), $(".product-summary .quantity .qty").data("variant_id") == o && ($(".product-summary .quantity .qty").val("1"), $(".product-summary .quantity").addClass("hide"), $(".single-add-to-cart-btn").removeClass("hide")), setTimeout((function() {
                            $(".cart_item[data-id=" + o + "]").remove();
                            var t = $(".un-cart-panel-footer p.totalsavings .amount .money").text();
                            $(".cart-collaterals .shop_table .cart-savings span.money.amount").text(t)
                        }), 2e3)
                    }), 500)
                },
                error: function(t, e) {
                    Shopify.onError(t, e)
                }
            })
        }))
    }

    function s(t) {
        $(document.body).addClass("modal-open"), t.fadeIn(), t.addClass("open")
    }

    function r() {
        $(document.body).removeClass("modal-open"), $(".unero-modal").fadeOut((function() {
            $(document.body).find("#menu-extra-search, #menu-extra-login").removeClass("show"), $(this).removeClass("open")
        }))
    }

    function c() {
        $(document.body).on("click", ".product-quick-view, .un-product-link", (function(e) {
            e.preventDefault();
            var i = $(this),
                o = i.attr("href"),
                a = $("#quick-view-modal"),
                n = a.find(".container"),
                r = a.find(".modal-header .close-modal").first().clone(),
                c = $(this).data("ptnamespace");
            i.addClass("loading"), n.hide().html("").addClass("invisible"), a.addClass("loading"), s(a), $.get(o, (function(e) {
                var o;
                n.html($(e)), a.removeClass("loading"), i.removeClass("loading"), n.show().removeClass("invisible"), _(), t(), (new theme.Sections).register(c, theme.Product), theme.CurrencyPicker.convert("#ProductSection-" + c + " .money")
            }), "html")
        })), $("#quick-view-modal").on("click", (function(t) {
            var e = t.target;
            0 >= $(e).closest("div.product").length && r()
        }))
    }

    function l() {
        i(), o(), n(), a(), c()
    }

    function d() {
        $(document).on("click", ".add_to_wishlist:not(.added)", (function(t) {
            if (!$(this).hasClass("need-login")) {
                t.preventDefault();
                var e = $(this),
                    i = e.data("product_id"),
                    o, a = {
                        action: "add_wishlist"
                    },
                    a = e.closest("form").serialize() + "&" + $.param(a);
                return $.ajax({
                    type: "POST",
                    url: "/a/wishlist",
                    async: !0,
                    cache: !1,
                    data: a,
                    dataType: "json",
                    beforeSend: function() {
                        e.addClass("loading"), e.attr("data-original-title", e.attr("data-loading-text")).tooltip("fixTitle").tooltip("show")
                    },
                    error: function(t) {
                        console.log(t)
                    },
                    complete: function() {
                        e.attr("data-original-title", e.attr("data-added")).tooltip("fixTitle").tooltip("show"), e.attr("data-original-title", e.attr("data-success")), e.addClass("added"), $(".wishlist" + i).addClass("added"), $(".wishlist" + i).attr("data-original-title", e.attr("data-success")), setTimeout((function() {
                            e.tooltip("hide")
                        }), 500)
                    },
                    success: function(t) {
                        e.removeClass("loading"), $(".wishlist" + i + " > span").html($(".wishlist" + i).attr("data-success")), $(".wishlist" + e.prev().val()), 0 < $(".menu-item-wishlist .mini-cart-counter").length && $(".menu-item-wishlist .mini-cart-counter").html(parseInt($(".menu-item-wishlist .mini-cart-counter").html()) + 1), 1 == t.code ? ($(".wishlist_items_number").text(t.json), jQuery("#rtp-message").html(e.attr("data-added")), jQuery("#rt-unero-popup-message").css("margin-left", "-" + parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 + "px").fadeIn(), window.setTimeout((function() {
                            jQuery("#rt-unero-popup-message").fadeOut()
                        }), 2e3)) : (alert(t.json), console.log(t.json))
                    }
                }), !1
            }
        }))
    }

    function u() {
        $(".to-top").on("click", (function() {
            return $("html, body").animate({
                scrollTop: 0
            }, 800), !1
        }))
    }

    function p() {
        $(document).on("click", ".remove_from_wishlist", (function(t) {
            t.preventDefault();
            var e = $(this),
                i, o = {
                    action: "remove_wishlist"
                };
            return o = e.closest("form").serialize() + "&" + $.param(o), $.ajax({
                type: "POST",
                url: "/a/wishlist",
                async: !0,
                cache: !1,
                data: o,
                dataType: "json",
                beforeSend: function() {
                    $(".page-wishlist-content").addClass("loading")
                },
                error: function(t) {
                    console.log(t), $(".page-wishlist-content").removeClass("loading")
                },
                success: function(t) {
                    1 == t.code ? e.closest("tr").slideUp("fast", (function() {
                        e.closest("tr").remove(), $(".page-wishlist-content .infos").removeClass("hide"), $(".wishlist_items_number").text(t.json), 0 == t.json && $(".wishlist-empty").removeClass("hide")
                    })) : (alert(t.json), console.log(t.json)), $(".page-wishlist-content").removeClass("loading"), 0 < $(".menu-item-wishlist .mini-cart-counter").length && $(".menu-item-wishlist .mini-cart-counter").html(parseInt($(".menu-item-wishlist .mini-cart-counter").html()) - 1)
                }
            }), !1
        }))
    }

    function h() {
        jQuery("#be_compare_features_table").on("scroll", (function() {
            var t = jQuery(this).parent();
            jQuery(this).scrollLeft() + jQuery(this).innerWidth() >= jQuery(this)[0].scrollWidth ? t.hasClass("scroll-right") && t.removeClass("scroll-right") : 0 === jQuery(this).scrollLeft() ? t.hasClass("scroll-left") && t.removeClass("scroll-left") : (!t.hasClass("scroll-right") && t.addClass("scroll-right"), !t.hasClass("scroll-left") && t.addClass("scroll-left"))
        })), be_compare_container = document.getElementById("be_compare_features_table"), null !== be_compare_container && be_compare_container.offsetWidth < be_compare_container.scrollWidth && !jQuery("#be_compare_features_table_inner").hasClass("scroll-right") && jQuery("#be_compare_features_table_inner").addClass("scroll-right"), jQuery(window).on("resize", (function() {
            m()
        })), jQuery("#be_compare_features_table_inner").hasClass("scroll-left") || jQuery("#be_compare_features_table_inner").hasClass("scroll-right") ? $(".compare-preview").addClass("no-flex") : $(".compare-preview").removeClass("no-flex")
    }

    function m() {
        be_compare_container = document.getElementById("be_compare_features_table"), null === be_compare_container || (be_compare_container.offsetWidth < be_compare_container.scrollWidth ? !jQuery("#be_compare_features_table_inner").hasClass("scroll-right") && jQuery("#be_compare_features_table_inner").addClass("scroll-right") : (jQuery("#be_compare_features_table_inner").hasClass("scroll-right") && jQuery("#be_compare_features_table_inner").removeClass("scroll-right"), jQuery("#be_compare_features_table_inner").hasClass("scroll-left") && jQuery("#be_compare_features_table_inner").removeClass("scroll-left")), jQuery("#be_compare_features_table_inner").hasClass("scroll-left") || jQuery("#be_compare_features_table_inner").hasClass("scroll-right") ? $(".compare-preview").addClass("no-flex") : $(".compare-preview").removeClass("no-flex"))
    }

    function f() {
        var e = $("body"),
            i = $("a.add_to_compare"),
            o = "",
            a = !1;
        e.on("click", "a.add_to_compare", (function() {
            var e = $(this),
                i = e.data("pid"),
                n = Currency.cookie.rtread("rt-compare"),
                s = !1;
            if (a = !1, e.addClass("loading"), n = null != n && "" != n ? n.split(",") : [], e.hasClass("reach-limit") && (a = !0, !1 === $(this).hasClass("added") && (s = !0, jQuery("#rtp-message").html(theme.strings.c_msg), jQuery("#rt-unero-popup-message").css("margin-left", "-" + parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 + "px").fadeIn(), window.setTimeout((function() {
                    jQuery("#rt-unero-popup-message").fadeOut()
                }), 2e3))), 0 > n.indexOf(i) && !1 === $(this).hasClass("added") && !1 == a) {
                n.push(i);
                var r = n.join(",");
                "," == r.substring(0, 1) && (r = r.substring(1)), Currency.cookie.rtwrite("rt-compare", r)
            }!1 === $(this).hasClass("added") || "" == o ? (o = "", $.ajax({
                url: "/search?view=compare&q=" + n,
                dataType: "html",
                type: "GET",
                success: function(t) {
                    o = t
                },
                error: function() {
                    console.log("ajax error"), e.removeClass("loading")
                },
                complete: function() {
                    n.length >= parseInt(theme.compare_limit) && 0 < $("a.add_to_compare").length && $("a.add_to_compare").each((function() {
                        $(this).addClass("reach-limit")
                    })), $.magnificPopup.open({
                        items: {
                            src: o,
                            type: "inline"
                        },
                        preloader: !0,
                        tLoading: "",
                        mainClass: "compare-preview",
                        removalDelay: 200,
                        gallery: {
                            enabled: !0
                        },
                        callbacks: {
                            open: function() {
                                !1 == s && ($('[data-pid="' + i + '"]').addClass("added").attr("data-original-title", $('[data-pid="' + i + '"]').attr("data-added")), $('[data-pid="' + i + '"]').find("span").html($('[data-pid="' + i + '"]').attr("data-added"))), e.removeClass("loading"), theme.CurrencyPicker.convert(".compare-content .money"), t(), h()
                            }
                        }
                    })
                }
            })) : $.ajax({
                url: "/search?view=compare&q=" + n,
                dataType: "html",
                type: "GET",
                success: function(t) {
                    o = t
                },
                error: function() {
                    console.log("ajax error"), e.removeClass("loading")
                },
                complete: function() {
                    $.magnificPopup.open({
                        items: {
                            src: o,
                            type: "inline"
                        },
                        preloader: !0,
                        tLoading: "",
                        mainClass: "compare-preview",
                        removalDelay: 200,
                        gallery: {
                            enabled: !0
                        },
                        callbacks: {
                            open: function() {
                                e.removeClass("loading"), theme.CurrencyPicker.convert(".compare-content .money"), t(), h()
                            }
                        }
                    })
                }
            })
        })), e.on("click", ".remove_from_compare", (function(t) {
            t.preventDefault();
            var e, i = $(this).attr("data-rev"),
                o = $(".compare-content");
            $('[data-pid="' + i + '"]').removeClass("added").attr("data-original-title", $('[data-pid="' + i + '"]').attr("data-title")), $('[data-pid="' + i + '"]').find("span").html($('[data-pid="' + i + '"]').attr("data-title"));
            var a = decodeURI(Currency.cookie.rtread("rt-compare"));
            null != a && ((a = a.split(",")).length <= theme.compare_limit && 0 < $("a.add_to_compare").length && $("a.add_to_compare").each((function() {
                $(this).removeClass("reach-limit")
            }))), a = jQuery.grep(a, (function(t) {
                return t != i
            })), a = $.trim(a), Currency.cookie.rtwrite("rt-compare", a), h(), $(".unero_" + i).remove(), 0 >= a.length && $(".mfp-close").trigger("click")
        }))
    }

    function v() {
        if (0 != parseInt(theme.compare)) {
            var t = Currency.cookie.rtread("rt-compare");
            null == t ? t = [] : ((t = t.split(",")).length >= parseInt(theme.compare_limit) && $(".add_to_compare").addClass("reach-limit"), t.map((function(t) {
                $('[data-pid="' + t + '"]').addClass("added").attr("data-original-title", $('[data-pid="' + t + '"]').attr("data-added")), $('[data-pid="' + t + '"]').find("span").html($('[data-pid="' + t + '"]').attr("data-added"))
            })))
        }
    }

    function g() {
        "1" == theme.compare && (f(), v(), h())
    }

    function y() {
        $(document.body).find("img.lazy").lazyload({
            threshold: 1e3
        })
    }

    function _() {
        $(".add_to_wishlist").attr("data-original-title", $(".add_to_wishlist").html()).attr("rel", "tooltip"), $("[rel=tooltip]").tooltip({
            offsetTop: -15
        })
    }

    function w(t) {
        $(document.body).addClass("open-canvas-panel"), t.addClass("open")
    }

    function b() {
        $(document.body).removeClass("open-canvas-panel"), $(".unero-off-canvas-panel, #primary-mobile-nav, #primary-offcanvas-wrapper").removeClass("open")
    }

    function C() {
        $(document.body).on("click", ".cart-contents", (function(t) {
            t.preventDefault(), w($("#cart-panel"))
        })), $(document.body).on("click", "#icon-menu-sidebar", (function(t) {
            t.preventDefault(), w($("#menu-sidebar-menu-sidebar"))
        })), $(document.body).on("click", "#off-canvas-layer, .close-canvas-panel", (function(t) {
            t.preventDefault(), b()
        }))
    }

    function k() {
        $(document.body).on("click", "#menu-extra-search", (function(t) {
            t.preventDefault(), s($("#search-modal")), $(this).addClass("show"), setTimeout((function() {
                document.getElementById("product-search-field").focus()
            }), 1e3)
        })), $(document.body).on("click", ".close-modal", (function(t) {
            t.preventDefault(), r()
        }))
    }

    function S() {
        0 < $(".un-attr-swatches").length && $(".un-attr-swatches").each((function() {
            1 == $(this).find(".swatch").length && $(this).addClass("hide")
        })), $(".un-swatch-variation-image").click((function() {
            $(this).hasClass("selected") || ("" != $(this).attr("data-src") && $(this).closest(".product-inner").find(".product-item-image").attr("src", $(this).attr("data-src")).attr("srcset", $(this).attr("data-srcset")), $(this).closest(".un-attr-swatches").find(".un-swatch-variation-image").removeClass("selected"), $(this).addClass("selected"))
        }))
    }

    function T() {
        $(document.body).on("click", ".un-shop-view", (function(t) {
            t.preventDefault();
            var e = $(this),
                i = e.data("view");
            e.hasClass("current") || ($(document.body).find(".un-shop-view").removeClass("current"), e.addClass("current"), $(document.body).removeClass("shop-view-grid shop-view-list").addClass("shop-view-" + i), $(document.body).trigger("unero_shop_view_after_change"))
        })), $(document.body).on("unero_shop_view_after_change", (function() {
            y()
        }))
    }

    function I() {
        var t = $("#un-shop-toolbar"),
            e = $("#un-shop-topbar"),
            i = $("#un-categories-filter"),
            o = t.find(".rt-unero-ordering"),
            a = $(".catalog-sidebar"),
            n = $(".catalog-offcanvas");
        $(window).on("resize", (function() {
            991 > $(window).width() ? (t.addClass("on-mobile"), e.addClass("on-mobile"), a.addClass("on-mobile"), n.addClass("on-mobile")) : (i.removeAttr("style"), $("#un-toggle-cats-filter").removeClass("active"), t.removeClass("on-mobile"), e.removeClass("on-mobile"), a.removeClass("on-mobile"), n.removeClass("on-mobile"), e.find(".widget-title").next().removeAttr("style"), a.find(".widget-title").next().removeAttr("style"))
        })).trigger("resize"), $(document.body).find(".shop-toolbar, .shop-bottombar").on("click", ".un-filter.filter-canvas", (function(t) {
            t.preventDefault(), $("#primary-offcanvas-wrapper").toggleClass("open"), $(document.body).toggleClass("open-canvas-panel"), $(this).closest(".shop-toolbar").hasClass("on-mobile") && (i.slideUp(200), o.slideUp(200), $("#un-toggle-cats-filter").removeClass("active"), $("#un-ordering").removeClass("active"), setTimeout((function() {
                e.slideToggle(200)
            }), 200)), $(document.body).toggleClass("show-filters-content")
        })), 0 < $("#primary-offcanvas-wrapper").length && $("#primary-offcanvas-wrapper").on("click", ".close-canvas-shop-panel", (function(t) {
            t.preventDefault(), b()
        })), $(document.body).find(".shop-toolbar, .shop-bottombar").on("click", ".un-filter:not(.filter-canvas)", (function(t) {
            t.preventDefault(), $(this).closest(".shop-toolbar").hasClass("on-mobile") ? (i.slideUp(200), o.slideUp(200), $("#un-toggle-cats-filter").removeClass("active"), $("#un-ordering").removeClass("active"), setTimeout((function() {
                e.slideToggle(200)
            }), 200)) : e.slideToggle(), e.toggleClass("active"), $(this).toggleClass("active"), e.closest(".shop-bottombar").toggleClass("show"), $("#un-filter-overlay").toggleClass("show"), $(document.body).toggleClass("show-filters-content")
        })), $(document.body).on("click", "#un-filter-overlay", (function(t) {
            t.preventDefault(), e.slideToggle(), $(".un-filter").removeClass("active"), e.closest(".shop-bottombar").toggleClass("show"), $("#un-filter-overlay").toggleClass("show"), e.removeClass("active"), $(document.body).removeClass("show-filters-content")
        })), $(document.body).on("click", "#un-toggle-cats-filter", (function(t) {
            t.preventDefault(), $(this).closest(".shop-toolbar").hasClass("on-mobile") && (e.slideUp(200), setTimeout((function() {
                i.slideToggle(200)
            }), 200), $(this).toggleClass("active"), $(".un-filter").removeClass("active"), e.removeClass("active"))
        })), $(document.body).on("click", "#un-ordering", (function(t) {
            t.preventDefault(), $(this).closest(".shop-toolbar").hasClass("on-mobile") && (e.slideUp(200), setTimeout((function() {
                o.slideToggle(200)
            }), 200), $(this).toggleClass("active"), $(".un-filter").removeClass("active"), e.removeClass("active"))
        })), e.on("click", ".widget-title", (function(t) {
            $(this).closest(".shop-topbar").hasClass("on-mobile") && (t.preventDefault(), $(this).closest(".widget").siblings().find(".widget-title").next().slideUp(200), $(this).closest(".widget").siblings().removeClass("active"), $(this).next().slideToggle(200), $(this).closest(".widget").toggleClass("active"))
        })), a.on("click", ".widget-title", (function(t) {
            $(this).closest(".catalog-sidebar").hasClass("on-mobile") && (t.preventDefault(), $(this).closest(".widget").siblings().find(".widget-title").next().slideUp(200), $(this).closest(".widget").siblings().removeClass("active"), $(this).next().slideToggle(200), $(this).closest(".widget").toggleClass("active"))
        })), n.on("click", ".widget-title", (function(t) {
            $(this).closest(".catalog-offcanvas").hasClass("on-mobile") && (t.preventDefault(), $(this).closest(".widget").siblings().find(".widget-title").next().slideUp(200), $(this).closest(".widget").siblings().removeClass("active"), $(this).next().slideToggle(200), $(this).closest(".widget").toggleClass("active"))
        }))
    }

    function x() {
        $(document.body).hasClass("catalog-board-content") && $(document.body).imagesLoaded((function() {
            $("#un-shop-content").find("ul.products").isotope({
                itemSelector: "li.product",
                layoutMode: "masonry"
            })
        }))
    }

    function P() {
        $(document.body).hasClass("collection-metro-content") && $(document.body).imagesLoaded((function() {
            $("#un-shop-content").find("ul.products").isotope({
                itemSelector: "li.product",
                layoutMode: "masonry"
            })
        }))
    }

    function j() {
        $("#unero-site-content").hasClass("blog-layout-masonry") && $(document.body).imagesLoaded((function() {
            $("#unero-site-content").find(".unero-post-list").isotope({
                itemSelector: ".un-post-item",
                layoutMode: "fitRows"
            })
        }))
    }

    function q() {
        if ($(document.body).hasClass("portfolio-layout-carousel")) {
            var t = $("#unero-site-content"),
                e = t.find(".unero-post-frame"),
                i = 2,
                o = 0,
                a = 5e3;
            0 < i && --i, 0 < o ? (a = o, o = 1) : o = 0;
            var n = {
                    horizontal: 1,
                    smart: 1,
                    itemNav: "forceCentered",
                    activateOn: "click",
                    touchDragging: 1,
                    mouseDragging: 1,
                    releaseSwing: 1,
                    startAt: i,
                    scrollBar: t.find(".scrollbar"),
                    speed: 1e3,
                    elasticBounds: 1,
                    dragHandle: 1,
                    dynamicHandle: 1,
                    clickBar: 1,
                    cycleBy: "items",
                    cycleInterval: a,
                    pauseOnHover: o
                },
                s = new Sly(e, n);
            s.on("load move", (function() {
                t.addClass("loaded")
            })), s.init(), $(window).resize((function() {
                var t = $(window).width(),
                    e = t - 60;
                $(document.body).hasClass("boxed") && (t = $(".site").width()), 1024 > t && (e = t - 30), 1200 > t ? $(".portfolio-layout-carousel").find(".portfolio-wapper").width(e) : $(".portfolio-layout-carousel").find(".portfolio-wapper").removeAttr("style"), s.reload()
            })).trigger("resize")
        }
    }

    function N() {
        if ($("#content").hasClass("animation-product")) {
            var t = $(document.body).find("#un-shop-content .product-inner");
            t.removeAttr("data-sr-id").removeAttr("style"), window.sr = new ScrollReveal({
                viewFactor: .15,
                duration: 1e3,
                scale: .9,
                opacity: 1,
                easing: "ease"
            }), sr.reveal(t, {
                reset: !0,
                viewOffset: {
                    top: 64
                }
            })
        }
    }

    function O() {
        if ($(".page-header").hasClass("page-header-sliders")) {
            var t = $(".page-header-sliders"),
                e = t.data("speed"),
                i = !1,
                o = t.data("auto"),
                a = t.data("parallax");
            if ("1" == a && (i = !0), t.find("ul").not(".slick-initialized").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: !0,
                    autoplaySpeed: e,
                    autoplay: o,
                    fade: i,
                    cssEase: "linear",
                    prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                    nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
                }), "0" == a) $(".page-header-sliders.parallax").find("li").parallax("50%", .6);
            else {
                var n = t.height();
                $(document.body).hasClass("admin-bar") && (n -= 32), $("#content").css("margin-top", n), t.addClass("parallax-2"), $(window).on("scroll", (function() {
                    var t = $(window).scrollTop();
                    0 < t ? $(".page-header-sliders.parallax-2").css({
                        opacity: (n - t) / n
                    }) : $(".page-header-sliders.parallax-2").css({
                        opacity: 1
                    })
                }))
            }
        } else $(".page-header.parallax").parallax("50%", .6)
    }

    function A() {
        if ($("#popup-mailchimp").length) {
            function t() {
                $(document.body).removeClass("modal-open");
                var t = $(".popup-modal.open");
                t.fadeOut((function() {
                    $(this).removeClass("open")
                })), $(document.body).trigger("roar_modal_closed", [t])
            }
            var e = parseInt(theme.popup_mailchimp_period),
                i = parseInt(theme.popup_mailchimp_delay);
            if (0 < e && document.cookie.match(/^(.*;)?\s*unero_popup\s*=\s*[^;]+(.*)?$/)) return;
            i = Math.max(i, 0), $(window).on("load", (function() {
                setTimeout((function() {
                    $(document.body).addClass("modal-open"), $(".popup-modal").fadeIn(), $(".popup-modal").addClass("open")
                }), 1e3 * i)
            })), $(document.body).on("roar_modal_closed", (function(t, i) {
                if (i.hasClass("roar-popup")) {
                    var o = new Date,
                        a = o.getTime();
                    o.setTime(o.getTime() + 1e3 * (60 * (60 * (24 * e)))), document.cookie = "unero_popup=" + a + ";expires=" + o.toGMTString() + ";path=/"
                }
            }));
            var o = $("#mc-form.newsletter"),
                a = o.attr("action");
            o.ajaxChimp({
                url: a,
                callback: function(e) {
                    "success" === e.result && t()
                }
            }), $(document.body).on("click", ".close-modal, .popup-backdrop", (function(e) {
                e.preventDefault(), t()
            })), $(document).on("keyup", (function(e) {
                27 === e.keyCode && t()
            }))
        }
    }

    function z() {
        $(window).on("load", (function() {
            "undefined" != typeof window.notifySettings && (notifyProIO.settings = {}, notifyProIO.settings.message = window.notifySettings.message, notifyProIO.settings.hideMobile = !0, notifyProIO.settings.initialDelay = 3e3, notifyProIO.settings.displayInterval = window.notifySettings.displayInterval, notifyProIO.settings.displayHold = window.notifySettings.displayHold, notifyProIO.settings.totalPerPage = window.notifySettings.totalPerPage, notifyProIO.settings.totalDisplayed = 0, notifyProIO.settings.loop = !0, notifyProIO.setup(window.notifyProducts))
        }))
    }

    function B() {
        return document.cookie.match(/^(.*;)?\s*unero_cookie\s*=\s*[^;]+(.*)?$/) ? void $(".cc_container").remove() : ($(window).on("load", (function() {
            setTimeout((function() {
                $(".cc_container").addClass("open")
            }), 5e3)
        })), void $(".cc_btn").click((function(t) {
            t.preventDefault();
            var e = new Date,
                i = e.getTime();
            e.setTime(e.getTime() + 31536e6), document.cookie = "unero_cookie=" + i + ";expires=" + e.toGMTString() + ";path=/", $(".cc_container").removeClass("open")
        })))
    }

    function D() {
        $().countdown && 0 < $(".countdown-item:not(.is-countdown)").length && $(".countdown-item:not(.is-countdown)").each((function() {
            if ("" != $(this).data("countdown")) {
                var t = new Date,
                    e = $(this).data("countdown").split("-"),
                    e;
                t < (e = new Date(e[2], parseInt(e[0]) - 1, e[1])) && $(this).countdown({
                    until: e,
                    layout: '<span class="countdown-day">{dn}d</span><span class="countdown-hour">{hn}h</span><span class="countdown-minute">{mn}m</span><span class="countdown-second">{sn}s</span>'
                })
            }
        }))
    }

    function Q() {
        $(document.body).hasClass("header-mixed-content") && $(".site-content .shopify-section").first().css("margin-top", -$(".site-header").height())
    }

    function L() {
        $(".more-details-btn").on("click", (function(t) {
            t.preventDefault(), $(this).closest(".hover-content").addClass("show-full-description");
            var e = $(this).closest(".unero-fade-in-block").height() + 15;
            $(this).closest(".product-item-details").find(".unero-product-item-imagin").css("margin-bottom", "-" + e + "px")
        }))
    }
    return {
        init: function() {
            I(), T(), y(), _(), d(), p(), t(), D(), S(), l(), k(), C(), N(), x(), P(), j(), q(), O(), u(), A(), z(), B(), g(), Q(), L()
        },
        pageHeader: function() {
            O()
        },
        initLoadMore: function() {
            y(), _(), t(), D(), N(), S(), x(), P(), j(), L()
        }
    }
}(), theme.init = function() {
    theme.roarApplication.init(), theme.customerTemplates.init(), slate.rte.wrapTable(), slate.rte.iframeReset(), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", (function(t) {
        slate.a11y.pageLinkFocus($(t.currentTarget.hash))
    })), $('a[href="#"]').on("click", (function(t) {
        t.preventDefault()
    }))
};
var roarLookbook = {
    getSizedImageUrl: function(t, e) {
        var i;
        if ((i = document.createElement("a")).href = t, "cdn.shopify.com" != i.hostname) return t;
        if (null == e) return t;
        if ("master" == e) return roarLookbook.removeProtocol(t);
        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != o) {
            var i = t.split(o[0]),
                a = o[0];
            return roarLookbook.removeProtocol(i[0] + "_" + e + a)
        }
        return null
    },
    removeProtocol: function(t) {
        return t.replace(/http(s)?:/, "")
    },
    isProductUrl: function(t) {
        var e = window.location.hostname,
            i = document.createElement("a");
        return i.href = t, i.hostname == e
    },
    buildLookbook: function() {
        $(".roarlookbook").each((function(t) {
            var e = $(this);
            if (!e.hasClass("roarlookbook_init")) {
                var i = e.attr("data-lookbook"),
                    o = {
                        lookbook: i,
                        action: "lookbook_get"
                    };
                o = $.param(o), $.ajax({
                    type: "POST",
                    url: "/apps/roarlookbook",
                    async: !0,
                    cache: !1,
                    data: o,
                    dataType: "json",
                    beforeSend: function() {},
                    error: function() {},
                    success: function(o) {
                        e.append(o);
                        var a = e.find(".media__blank-preview");
                        a.imagesLoaded((function() {
                            e.addClass("roarlookbook_init").attr("data-lookbook", i + t), a.addClass("sfx-fadeIn")
                        }))
                    }
                })
            }
        }))
    },
    resetHotspots: function(t) {
        var e = $(".hotspot", t),
            i = t.attr("data-lookbook");
        e.each((function() {
            var e = $(this),
                o = e.attr("data-id"),
                a = $("#" + i + "-" + o, t);
            a.fadeOut("fast", (function() {
                a.remove(), e.removeClass("hotspot_init")
            }))
        }))
    },
    hotspotPopup: function() {
        $(".roarlookbook").on("click", ".hotspot", (function() {
            var t = $(this);
            if (t.hasClass("hotspot_init")) {
                var e = t.closest(".roarlookbook");
                roarLookbook.resetHotspots(e)
            } else {
                var e = t.closest(".roarlookbook"),
                    i = t.attr("data-id"),
                    o = t.closest(".roarlookbook").attr("data-lookbook") + "-" + i,
                    a = "#" + t.closest(".roarlookbook").attr("data-lookbook") + "-" + i,
                    n = t.attr("data-title"),
                    s = t.attr("data-image"),
                    r = t.attr("data-price"),
                    c = t.attr("data-url"),
                    l = "";
                if ("" == n && "" == c) return !1;
                if (roarLookbook.resetHotspots(e), l += '<div id="' + o + '" class="hotspot-widget hotspot-loading">', l += '<div class="hotspot-content">', l += '<span class="hotspot-close">×</span>', l += '<div class="hotspot-inner">', "" != s) {
                    var d = '<img src="' + roarLookbook.getSizedImageUrl(s, "80x") + '" src="' + roarLookbook.getSizedImageUrl(s, "300x") + '" data-srcset="' + roarLookbook.getSizedImageUrl(s, "300x") + " 1x, " + roarLookbook.getSizedImageUrl(s, "600x") + ' 2x" alt="" />';
                    l += "" == c ? d : '<a href="' + c + '">' + d + "</a>"
                }
                if ("" != n && (l += "<h3>", l += "" == c ? n : '<a href="' + c + '">' + n + "</a>", l += "</h3>"), "" != r && (l += '<div class="price"><span class="money">' + r + "</span></div>", roarLookbook.isProductUrl(c) && (l += '<div class="hotspot-btns">', l += '<div class="hotspot-btn"><a href="' + c + '">' + theme.apps.details + "</a></div>", l += '<div class="hotspot-btn"><a class="roar_add_to_cart" href="' + c + '?add-to-cart=true">' + theme.apps.buyNow + "</a></div>", l += "</div>")), l += "</div>", l += "</div>", l += "</div>", $(a).length || e.append(l), $(a).imagesLoaded((function() {
                        var i = $(a),
                            o = t.offset().left,
                            n = t.offset().top,
                            s = i.outerWidth(),
                            r = i.outerHeight(),
                            c = e.offset().left,
                            l = e.offset().top,
                            d, u = "hotspot-right";
                        50 > e.outerWidth() - (o + s) ? (o = o - s - 5, u = "hotspot-left") : o = o + t.outerWidth() + 5, n = n + t.outerHeight() / 2 - r / 2, i.css({
                            left: o - c,
                            top: n - l
                        }).removeClass("hotspot-left").removeClass("hotspot-right").addClass(u), t.addClass("hotspot_init"), i.removeClass("hotspot-loading").fadeIn("fast")
                    })), $(a).find("img").length) {
                    var u = $(a).find("img");
                    u.attr("src", u.attr("data-src")).removeAttr("data-src").attr("srcset", u.attr("data-srcset")).removeAttr("data-srcset")
                }
            }
        })), $(document).on("click", ".hotspot-close", (function() {
            var t, e = $(this).closest(".hotspot-widget"),
                i, o, a = e.attr("id").split("-")[1];
            $('.roarlookbook .hotspot[data-id="' + a + '"]').removeClass("hotspot_init"), e.fadeOut("fast", (function() {
                e.remove()
            }))
        })), $(".roarlookbook").on("click", ".image-preview", (function() {
            var t = $(this).closest(".roarlookbook");
            roarLookbook.resetHotspots(t)
        })), $(window).resize((function() {
            $(".roarlookbook .hotspot_init").length && $(".roarlookbook .hotspot_init").each((function() {
                var t;
                $(this).removeClass("hotspot_init").trigger("click")
            }))
        }))
    },
    addToCart: function() {
        $(document).on("click", ".roar_add_to_cart", (function(t) {
            t.preventDefault();
            var e = $(this),
                i = e.closest(".roarlookbook"),
                o = e.attr("href");
            $.ajax({
                type: "GET",
                url: o,
                beforeSend: function() {},
                success: function(t) {
                    var e;
                    $(t).find('form[action="/cart/add"]').appendTo(i).submit().remove()
                },
                dataType: "html"
            })
        }))
    },
    init: function() {
        $(".roarlookbook").length && (roarLookbook.buildLookbook(), roarLookbook.hotspotPopup(), roarLookbook.addToCart())
    }
};
try {
    $(theme.init), roarLookbook.init()
} finally {
    var $unloader = $("#un-before-unloader");
    $(window).on("beforeunload", (function() {
        $unloader.removeClass("out").fadeIn(500, (function() {
            $unloader.addClass("loading")
        }))
    })), $unloader.fadeOut(200, (function() {
        $unloader.addClass("out")
    }))
}

function AMScroll() {
    $(document.body).on("click", ".cart-contents", (function(t) {
        var e = window.scrollY;
        console.log(e), document.body.style.top = "-" + e + "px", document.body.style.position = "fixed", window.cart_content_clicked = !0, window.cart_content_opened = !0, setTimeout((function() {
            e > 10 && $(document.body).find("#header-header").addClass("minimized")
        }), 10)
    })), $(document.body).on("click", "#icon-menu-sidebar", (function(t) {
        var e = window.scrollY;
        document.body.style.top = "-" + e + "px", document.body.style.position = "fixed", setTimeout((function() {
            e > 10 && $(document.body).find("#header-header").addClass("minimized")
        }), 10)
    })), $(document.body).on("click", "#off-canvas-layer, .close-canvas-panel", (function(t) {
        if ($(".sidebar__inner").hasClass("aisles-open"));
        else {
            const t = document.body.style.top;
            document.body.style.position = "", document.body.style.top = "", window.scrollTo(0, -1 * parseInt(t || "0"))
        }
        window.cart_content_opened = !1
    }))
}
if (jQuery(document).ready((function() {
        $(document).ready((function() {
            var t;
            ! function t() {
                var e = !1;

                function i() {
                    !1 === e && (document.documentElement.classList.add("mouse"), document.body.removeEventListener("mousemove", i))
                }

                function o() {
                    try {
                        return document.createEvent("TouchEvent"), !0
                    } catch (t) {
                        return !1
                    }
                }
                document.body.addEventListener("mousemove", i), document.body.addEventListener("touchstart", (function() {
                    e = !0
                })), document.body.addEventListener("touchend", (function() {
                    e = !1
                })), document.body.addEventListener("click", (function() {
                    e && (e = !1)
                })), o() && document.documentElement.classList.add("touch")
            }(), jQuery(document).scrollTop() > 10 && jQuery(".site-header").addClass("minimized")
        })), $("body").on("click", ".widget_shopping_cart_content .mini_cart_item .q_up", (function() {
            var t = $(this);
            var e = $(this).parent(".quantity-number").find(".update-product");
            var i = parseInt(e.val());
            var o = parseInt(e.attr("max"));
            if (i >= o) return alert("Apologies, we currently have " + o + " left in stock."), jQuery.getJSON("/cart.js", (function(t) {
                for (var i in t.items) t.items[i].id == e.attr("data-id") && e.val(t.items[i].quantity)
            })), !1;
            e.val(Number(e.val()) + 1), e.trigger("focusout");
            var a = e.attr("data-id");
            var n;
            var s;
            $(".products .product-inner .custom-quantity").find("[data-variant_id='" + a + "'].qty-variant").val(e.val()), $(".product-summary .quantity .qty").data("variant_id") == a && $(".product-summary .quantity .qty").val(e.val())
        })), $("body").on("click", ".widget_shopping_cart_content .mini_cart_item .q_down", (function() {
            var t = $(this);
            var e = $(this).parent(".quantity-number").find(".update-product");
            var i = Number(e.val());
            i >= 1 && e.val(i - 1), e.trigger("focusout");
            var o = e.attr("data-id");
            var a = $(".products .product-inner .custom-quantity").find("[data-variant_id='" + o + "'].qty-variant");
            var n = e.val();
            var s;
            if (0 == n && (n = 1, $(".products .product-inner .custom-quantity").find('[data-variant_id="' + o + '"]').parent().parent().addClass("hide"), $(".products .product-inner .custom-quantity").find('[data-variant_id="' + o + '"]').parent().removeClass("hide"), $(".products .product-inner .custom-quantity").find('[data-variant_id="' + o + '"]').parents().removeClass("pro_img_bg"), $(".products .product-inner .custom-quantity").find('[data-variant_id="' + o + '"]').parent().parent().parent().find(".custom-cart-form").removeClass("hide")), a.val(n), $(".product-summary .quantity .qty").data("variant_id") == o) {
                if (0 == e.val()) {
                    var r = "1";
                    $(".product-summary .quantity").addClass("hide"), $(".single-add-to-cart-btn").removeClass("hide")
                } else var r = e.val();
                $(".product-summary .quantity .qty").val(r)
            }
        })), $("body").on("keyup", ".widget_shopping_cart_content .mini_cart_item .update-product", (function() {
            var t = $(this),
                e = t.val(),
                i = t.attr("data-id");
            var o = parseInt(e);
            var a = parseInt(t.attr("max"));
            if (o > a) return alert("Apologies, we currently have " + a + " left in stock."), jQuery.getJSON("/cart.js", (function(e) {
                for (var o in e.items) e.items[o].id == i && t.val(e.items[o].quantity)
            })), !1;
            $(this).trigger("focusout")
        }))
    })), this.reorder = new function() {
        var t = this;
        this.pushQueue = function(e, i, o) {
            i[e].check_inventory && (i[e].quantity = Math.min(parseInt(i[e].inventory), parseInt(i[e].quantity))), $.ajax({
                url: "/cart/add.js",
                method: "POST",
                data: {
                    quantity: i[e].quantity,
                    id: i[e].id
                },
                complete: function(a) {
                    if (e >= i.length - 1) return o.removeClass("loading"), window.location.href = "/?s=1", void 0;
                    t.pushQueue(e + 1, i, o)
                }
            })
        }, this.listen = function() {
            var e = $(this);
            $.ajax({
                type: "POST",
                url: "/cart/clear.js",
                async: !0,
                cache: !1,
                data: {},
                dataType: "json",
                error: function(t) {
                    var e = $.parseJSON(t.responseText),
                        i = e.message + ": " + e.description;
                    alert(i)
                },
                complete: function() {
                    var i = e;
                    var o = i.attr("data-variant-ids").split(",");
                    var a = i.attr("data-variant-quantities").split(",");
                    var n = i.attr("data-variant-inventories").split(",");
                    var s = i.attr("data-variant-inventory-policies").split(",");
                    var r = i.attr("data-variant-inventory-trackers").split(",");
                    o.splice(-1, 1), a.splice(-1, 1), n.splice(-1, 1), s.splice(-1, 1), r.splice(-1, 1);
                    var c = [];
                    for (var l = 0; l < o.length; l++) c.push({
                        id: o[l],
                        quantity: a[l],
                        inventory: n[l],
                        check_inventory: "deny" == s[l] && "" != r[l]
                    });
                    i.addClass("loading"), t.pushQueue(0, c, i)
                }
            })
        }, this.init = function() {
            $(".reorder-btn").on("click", t.listen)
        }
    }, $(reorder.init), $.fn.isInViewport = function() {
        var t = $(window);
        var e = {
            top: t.scrollTop(),
            left: t.scrollLeft()
        };
        e.right = e.left + t.width(), e.bottom = e.top + t.height();
        var i = this.offset();
        return i.right = i.left + this.outerWidth(), i.bottom = i.top + this.outerHeight(), !(e.right < i.left || e.left > i.right || e.bottom < i.top || e.top > i.bottom)
    }, $(window).on("resize scroll", (function() {
        clearTimeout($.data(this, "scrollTimer")), $.data(this, "scrollTimer", setTimeout((function() {
            $(".product-tabs-grid").each((function() {
                var t = $(this).attr("id");
                $(this).isInViewport() ? ($("#li-" + t).addClass("active"), $("#li-" + t).find("a").attr("style", "color: #e66c6a !important"), $("#li-" + t).siblings().removeClass("active"), $("#li-" + t).siblings().find("a").attr("style", "color: #000 !important"), $("#li-" + t).siblings().find("a").hover((function() {
                    $(this).attr("style", "color: #e66c6a !important")
                }), (function() {
                    $(this).attr("style", "color: #000 !important")
                })), $("#li-" + t).find("a").hover((function() {
                    $(this).attr("style", "color: #e66c6a !important")
                }))) : ($("#li-" + t).removeClass("active"), $("#li-" + t).find("a").attr("style", "color: #000 !important"), $("#li-" + t).find("a").hover((function() {
                    $(this).attr("style", "color: #e66c6a !important")
                }), (function() {
                    $(this).attr("style", "color: #000 !important")
                })))
            }))
        }), 150))
    })), $(document).ready((function() {
        $(".product").each((function() {
            $(this).find(".custom-quantity").hasClass("hide") || $(this).find(".product-images").addClass("pro_img_bg")
        }))
    })), $("body").on("click", ".mini_cart_item .remove-product", (function() {
        var t = $(this).attr("data-id");
        setTimeout((function() {
            $(".products .product-inner .custom-quantity").find('[data-variant_id="' + t + '"]').parent().parent().addClass("hide"), $(".products .product-inner .custom-quantity").find('[data-variant_id="' + t + '"]').parent().removeClass("hide"), $(".products .product-inner .custom-quantity").find('[data-variant_id="' + t + '"]').parents().removeClass("pro_img_bg"), $(".products .product-inner .custom-quantity").find('[data-variant_id="' + t + '"]').parent().parent().parent().find(".custom-cart-form").removeClass("hide")
        }), 1e3)
    })), $("#search-modal-content").click((function(t) {
        t.stopPropagation()
    })), $("#search-modal").click((function() {
        $(document.body).removeClass("modal-open"), $(".unero-modal").fadeOut((function() {
            $(document.body).find("#menu-extra-search, #menu-extra-login").removeClass("show"), $(this).removeClass("open")
        }))
    })), $(".close-modal").click((function() {
        $(document.body).removeClass("modal-open"), $(".unero-modal").fadeOut((function() {
            $(document.body).find("#menu-extra-search, #menu-extra-login").removeClass("show"), $(this).removeClass("open")
        }))
    })), window.matchMedia("(max-width: 990px)").matches && AMScroll(), $(document).ready((function() {
        var t = location.hash;
        if ("" != t) {
            if (window.matchMedia("(max-width: 767px)").matches) var e = 40;
            else var e = 70;
            $("html, body").animate({
                scrollTop: $(t).offset().top - e
            }, 500, (function() {}))
        }

        function i(t) {
            var e;
            var i = window.location.search.substring(1).split("&");
            for (var o = 0; o < i.length; o++) {
                var a = i[o].split("=");
                if (a[0] == t) return a[1]
            }
        }
        $(".template-index .product .sidebar__inner ul li a").on("click", (function(t) {
            if (t.preventDefault(), window.matchMedia("(max-width: 767px)").matches) var e = 40;
            else var e = 70;
            $("html, body").animate({
                scrollTop: $(this.hash).offset().top - e
            }, 500, (function() {}))
        })), $(".slideshow-caption-group .caption-group-content a").on("click", (function(t) {
            if ("" !== this.hash) {
                t.preventDefault();
                var e = this.hash;
                if (window.matchMedia("(max-width: 767px)").matches) var i = 40;
                else var i = 70;
                window.matchMedia("(max-width: 767px)").matches ? $("html, body").animate({
                    scrollTop: $(e).offset().top - i
                }, 1200, (function() {})) : $("html, body").animate({
                    scrollTop: $(e).offset().top - i
                }, 1800, (function() {}))
            }
        }));
        var o = i("s");
        if (o && "1" == o) {
            if (window.matchMedia("(max-width: 767px)").matches) var e = 30;
            else var e = 70;
            $("html, body").animate({
                scrollTop: $("#tab-1560820262740-0-coffee-tea").offset().top - e
            }, 500, (function() {})), $(document.body).addClass("open-canvas-panel"), $("#cart-panel").addClass("open")
        }
    })), $(".aisles-open").click((function() {
        $("#product-tabs-wrapper-1560820262740 > div > div.content-area.all-collection-content.col-md-10").addClass("intro")
    })), $(document).ready((function() {
        $(".group_navbtn_small").click((function() {
            $("body").addClass("fix-bg")
        })), $("#off-canvas-layer").click((function() {
            $("body").removeClass("fix-bg")
        })), $(".widget-panel-header").click((function() {
            $("body").removeClass("fix-bg")
        })), $("#menu-sidebar-menu-sidebar").click((function() {
            $("body").removeClass("fix-bg")
        })), setTimeout((function() {
            $(".slideshow-caption-group").show()
        }), 500), $(document).on("click", ".empty-parcel", (function() {
            $.ajax({
                type: "POST",
                url: "/cart/clear.js",
                async: !0,
                cache: !1,
                data: {},
                dataType: "json",
                error: function(t) {
                    var e = $.parseJSON(t.responseText),
                        i = e.message + ": " + e.description;
                    alert(i)
                },
                success: function() {
                    $(".mini_cart_item").each((function() {
                        var t = $(this).find("a").attr("data-id");
                        setTimeout((function() {
                            $(".products .product-inner .custom-quantity").find('[data-variant_id="' + t + '"]').parent().parent().addClass("hide"), $(".products .product-inner .custom-quantity").find('[data-variant_id="' + t + '"]').parent().removeClass("hide"), $(".products .product-inner .custom-quantity").find('[data-variant_id="' + t + '"]').parents().removeClass("pro_img_bg"), $(".products .product-inner .custom-quantity").find('[data-variant_id="' + t + '"]').parent().parent().parent().find(".custom-cart-form").removeClass("hide"), $(".mini-cart-counter").text("0")
                        }), 1e3)
                    })), $(".cart-panel .cart_list.product_list_widget").html('<li class="empty">No items in your parcel.</li>'), $(".un-cart-panel-footer, .empty-parcel").remove()
                }
            })
        })), $(".empty-parcel p").hover((function() {
            $(".empty-parcel span").addClass("only-hov")
        }), (function() {
            $(".empty-parcel span").removeClass("only-hov") 
        })), $(".empty-parcel .icon-cross2").hover((function() {
            $(".empty-parcel p").addClass("only-hov")
        }), (function() {
            $(".empty-parcel p").removeClass("only-hov")
        })), $(document.body).on("click", (function() {
            $(".cart-panel").hasClass("open") || $(".product-tabs-wrapper .aisles-content").hasClass("aisles-open") || $("#menu-sidebar-menu-sidebar").hasClass("open") ? ($("#shopify-section-header").css("z-index", "999999"), $(".product .product-inner .product-images .keeper-quickview").css("z-index", "99999")) : ($("#shopify-section-header").css("z-index", "999999999"), $(".product .product-inner .product-images .keeper-quickview").css("z-index", "99999999"))
        }))
    })), document.querySelector(".faq-menu")) {
    var topLimit = $(".faq-menu").offset().top;
    $(window).scroll((function() {
        topLimit <= $(window).scrollTop() ? $(".faq-menu ").addClass("stickIt") : $(".faq-menu ").removeClass("stickIt")
    }))
}

function isFacebookApp() {
    var t = navigator.userAgent || navigator.vendor || window.opera;
    return t.indexOf("FBAN") > -1 || t.indexOf("FBAV") > -1
}

function goToByScroll(t) {
    var e;
    t = t.replace("link", ""), console.log(t), $(window).width() < 767 ? $("html,body").animate({
        scrollTop: $("#" + t).offset().top
    }, "slow") : $("html,body").animate({
        scrollTop: $("#" + t).offset().top - 100
    }, "slow")
}

function goToByScrollR(t) {
    var e;
    t = t.replace("widget", "content"), $(window).width() < 767 ? $("html,body").animate({
        scrollTop: $("#" + t).offset().top - 20
    }, "slow") : $("html,body").animate({
        scrollTop: $("#" + t).offset().top - 40
    }, "slow")
}
$("#brandlink").click((function(t) {
    t.preventDefault(), goToByScroll($(this).attr("id"))
})), $("#stamped-reviews-widget").click((function(t) {
    t.preventDefault(), goToByScrollR($(this).attr("id"))
})), $(document).ready((function() {}));
//# sourceMappingURL=/s/files/1/0113/1325/0404/t/209/assets/theme.js.map?v=1634634685